import { translateInline } from '../i18n/inlineTranslations';

export const NADI_EVENT_TRANSLATIONS = {
  "hi": {
    "Education": "शिक्षा",
    "Awards": "पुरस्कार",
    "Prize": "इनाम",
    "Career": "करियर",
    "Love": "प्रेम",
    "Marriage": "विवाह",
    "Dowry or Legacy": "दहेज या विरासत",
    "Divorce": "तलाक",
    "Abortion": "गर्भपात",
    "Child Birth": "संतान जन्म",
    "Property/Vehicle Purchase": "संपत्ति/वाहन खरीद",
    "Property/Vehicle Sale": "संपत्ति/वाहन बिक्री",
    "Love and Caring": "प्रेम और देखभाल",
    "Depression": "अवसाद",
    "Aggression": "आक्रामकता",
    "Health": "स्वास्थ्य",
    "Travel": "यात्रा",
    "Homecoming": "घर वापसी",
    "Litigation": "मुकदमेबाजी",
    "Arrest": "गिरफ्तारी",
    "Event Analysis": "ईवेंट विश्लेषण",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "किसी श्रेणी और ईवेंट का चयन करें ताकि उसके पारंपरिक नाड़ी हाउस समूह और संबंधित ग्रह देख सकें।",
    "Category": "श्रेणी",
    "Event": "ईवेंट",
    "Locked": "लॉक किया गया",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "सभी श्रेणियाँ और ईवेंट दृश्य हैं। लॉक किए गए ईवेंट विश्लेषण विकल्पों को अनलॉक करने के लिए प्रीमियम में अपग्रेड करें।",
    "Supportive indication": "सहायक संकेत",
    "Challenging indication": "चुनौतीपूर्ण संकेत",
    "Neutral indication": "तटस्थ संकेत",
    "Event groups": "ईवेंट समूह",
    "Good": "अच्छा",
    "Bad": "बुरा",
    "Supportive": "सहायक",
    "Challenging supportive": "चुनौतीपूर्ण सहायक",
    "Planets involved": "शामिल ग्रह",
    "involved": "शामिल",
    "Pro": "प्रो",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "ये व्याख्याएँ पारंपरिक ज्योतिषीय सिद्धांतों पर आधारित हैं और केवल सूचनात्मक और शैक्षिक उद्देश्यों के लिए हैं। ये प्रवृत्तियों और संभावनाओं को इंगित करती हैं, निश्चित परिणाम नहीं। कानूनी, वित्तीय, चिकित्सा या अन्य पेशेवर मामलों के लिए, योग्य पेशेवर से परामर्श करें।",
    "Career, Work & Business": "करियर, कार्य और व्यवसाय",
    "Employment Prospects": "रोजगार संभावनाएं",
    "Business Prospects": "व्यवसाय की संभावनाएं",
    "Earning Potential": "कमाई की संभावना",
    "Business Challenges": "व्यापार में चुनौतियाँ",
    "Business Recovery Indicators": "व्यवसाय पुनर्प्राप्ति संकेतक",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 व्यापार कठिनाई के बाद पुनर्प्राप्ति/सहायता के रूप में कार्य करता है।",
    "Administration Career": "प्रशासनिक करियर",
    "Employment Challenges": "रोजगार संबंधी चुनौतियाँ",
    "Professional Obstacles / Delays": "पेशेवर बाधाएँ / विलंब",
    "Professional Recognition Challenges": "पेशेवर मान्यता संबंधी चुनौतियाँ",
    "Financial Pressure": "वित्तीय दबाव",
    "Financial Return Cycle": "वित्तीय वापसी चक्र",
    "Supportive Career Change": "सहायक करियर परिवर्तन",
    "Favourable Career Transition": "अनुकूल करियर परिवर्तन",
    "Next DBA": "अगला DBA",
    "Challenging Career Transition": "चुनौतीपूर्ण करियर परिवर्तन",
    "Workplace Transfer / Relocation": "कार्यस्थल स्थानांतरण / पुनर्वास",
    "Return to Previous Workplace / Location": "पिछले कार्यस्थल / स्थान पर वापसी",
    "Personality & Temperament": "व्यक्तित्व और स्वभाव",
    "Assertive / Intense Temperament": "आत्मविश्वासी / तीव्र स्वभाव",
    "Mars": "मंगल",
    "modifier": "संशोधक",
    "Mars connected with the 1st or 3rd house": "मंगल का 1st या 3rd घर से जुड़ा होना",
    "Emotional Sensitivity": "भावनात्मक संवेदनशीलता",
    "Moon": "चंद्रमा",
    "Moon influence; source also notes Cancer connected with the 1st house": "चंद्रमा का प्रभाव; स्रोत में यह भी उल्लेख है कि कर्क का 1st घर से संबंध है",
    "Affectionate & Relationship-Oriented Nature": "स्नेही और संबंध-केंद्रित स्वभाव",
    "Warm & Supportive Nature": "गर्म और सहायक स्वभाव",
    "Independent / Detached Tendencies": "स्वतंत्र / अलग रहने की प्रवृत्तियाँ",
    "Rahu": "राहु",
    "associated planet": "संबंधित ग्रह",
    "Ketu": "केतु",
    "Saturn": "शनि",
    "Sun": "सूर्य",
    "Reserved / Practical Nature": "आरक्षित / व्यावहारिक स्वभाव",
    "Persistent / Determined Nature": "दृढ़ / निश्चयी स्वभाव",
    "Relationships & Marriage": "संबंध और विवाह",
    "Relationship Boundary Challenges": "संबंध सीमा चुनौतियाँ",
    "Supportive Relationship Bond": "सहायक संबंध बंधन",
    "Private / Complex Relationship Phase": "निजी / जटिल संबंध चरण",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "स्रोत में 5,9,11; 5,11; और 5,8,11 को साफ/सहायक संबंध विकल्प के रूप में भी सूचीबद्ध किया गया है।",
    "Relationship Conflict / Reactive Dynamics": "संबंध संघर्ष / प्रतिक्रियाशील गतिशीलता",
    "Marriage Prospects": "विवाह की संभावनाएँ",
    "Marriage Through Known Circle": "परिचित वृतांत के माध्यम से विवाह",
    "Supportive Marriage Circumstances": "सहायक विवाह परिस्थितियाँ",
    "Marriage Delay Indicators": "विवाह में विलंब के संकेतक",
    "In DBA": "डीबीए में",
    "Emotional Distance in Relationship": "संबंध में भावनात्मक दूरी",
    "Reconciliation Indicators": "पुनर्मिलन के संकेतक",
    "Use with the preceding relationship/separation combination.": "इसका उपयोग पूर्व के संबंध/विच्छेद संयोजन के साथ करें।",
    "Marital Transition / Separation Indicators": "वैवाहिक परिवर्तन / विच्छेद के संकेतक",
    "Reduced Support for Marriage": "विवाह के लिए घटता समर्थन",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "जब 1,6,10 को कई संबंधित ग्रह/सङ्केतक द्वारा पुनः दोहराया जाता है तो यह मजबूत होता है।",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "जब सप्तम कुस्प का स्वामी भी 1,6,10 को सङ्केत करता है तो यह मजबूत होता है।",
    "Relocation After Marriage": "विवाह के बाद स्थानान्तरण",
    "Relocation to a Distant / Unfamiliar Place": "दूर / अपरिचित स्थान पर स्थानांतरण",
    "Non-Traditional Relationship Pattern": "गैर-पारंपरिक संबंध पैटर्न",
    "Education & Learning": "शिक्षा और अधिगम",
    "Education Prospects": "शिक्षा की संभावनाएँ",
    "Strong Education Potential": "मजबूत शिक्षा क्षमता",
    "Management / Professional Higher Education Potential": "प्रबंधन / पेशेवर उच्च शिक्षा क्षमता",
    "Profession Indicators": "पेशेवर संकेतक",
    "Astrology / Astrologer": "ज्योतिष / ज्योतिषी",
    "Mercury": "बुध",
    "profession modifier": "पेशेवर संशोधक",
    "Jupiter": "बृहस्पति",
    "Teacher / Educator": "शिक्षक / शिक्षक",
    "Higher-education support: 1,2,4,9,11": "उच्च शिक्षा समर्थन: 1,2,4,9,11",
    "Writer / Professional Writing": "लेखक / पेशेवर लेखन",
    "Income Support Through Profession": "पेशे के माध्यम से आय समर्थन",
    "Medical / Healthcare Profession": "चिकित्सा / स्वास्थ्य देखभाल पेशा",
    "Stronger professional quality: 5,9,11 + 6,8,12": "मजबूत पेशेवर गुणवत्ता: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "पेशेवर सफलता समर्थन: 6,8,12 + 10,11 या +11 या +9,11",
    "Engineer": "अभियंता",
    "Scientist": "वैज्ञानिक",
    "Research / Inventions / Deep Analysis": "अनुसंधान / आविष्कार / गहरी विश्लेषण",
    "Recognition Through Research / Innovation": "अनुसंधान / नवाचार के माध्यम से मान्यता",
    "Information Technology": "सूचना प्रौद्योगिकी",
    "Higher-education support: 2,4,5,9,11": "उच्च शिक्षा सहायता: 2,4,5,9,11",
    "Lawyer / Legal Profession": "वकील / कानूनी पेशा",
    "Architect": "आर्किटेक्ट",
    "Builder / Construction": "बिल्डर / निर्माण",
    "Property / Real-Estate Professional": "संपत्ति / रियल-एस्टेट पेशेवर",
    "Property purchase activity: 4,11,12": "संपत्ति खरीद गतिविधि: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "संपत्ति बिक्री गतिविधि: 3,5,10 शनि और मंगल के साथ",
    "Interior Designer / Decorator": "इंटीरियर डिज़ाइनर / सजावट विशेषज्ञ",
    "Creativity / Innovation": "रचनात्मकता / नवाचार",
    "Politics / Public Leadership": "राजनीति / सार्वजनिक नेतृत्व",
    "Chartered Accountant": "चार्टर्ड अकाउंटेंट",
    "Data Management / Business Management": "डेटा प्रबंधन / व्यवसाय प्रबंधन",
    "Chef / Culinary Profession": "शेफ / पाक कला पेशा",
    "Benefic planet": "शुभ ग्रह",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "दूसरे घर में शुभता या दूसरे घर को प्रभावी ढंग से दृष्टि डालना / प्रभावित करना",
    "International / continental cuisine: +9,3,12": "अंतरराष्ट्रीय / महाद्वीपीय व्यंजन: +9,3,12",
    "Correctional / Institutional Administration": "सुधारात्मक / संस्थात्मक प्रशासन",
    "Journalist / Media Professional": "पत्रकार / मीडिया पेशेवर",
    "Investigative / crime reporting: +7,8,12": "जांच / अपराध रिपोर्टिंग: +7,8,12",
    "Political reporting: +1,10,11": "राजनीतिक रिपोर्टिंग: +1,10,11",
    "Sports reporting: +5,10": "खेल रिपोर्टिंग: +5,10",
    "Creative Writer": "रचनात्मक लेखक",
    "Creativity: +5,9": "रचनात्मकता: +5,9",
    "Artistic writing: 5,11": "कलात्मक लेखन: 5,11",
    "Mystery / occult / deep subjects: 8,12": "रहस्य / गुप्त / गहरे विषय: 8,12",
    "Legal Matters": "कानूनी मामले",
    "Legal Dispute Indicators": "कानूनी विवाद संकेत",
    "Supportive Legal Matter Indicators": "सहायक कानूनी मामले संकेत",
    "Challenging Legal Matter Indicators": "चुनौतीपूर्ण कानूनी मामले संकेत",
    "Legal Relief Indicators": "कानूनी राहत संकेत",
    "5,9 acts as a facilitator.": "5,9 एक सहायक के रूप में कार्य करता है।",
    "Property & Residence": "संपत्ति और निवास",
    "Property Purchase Prospects": "संपत्ति खरीद संभावनाएँ",
    "property modifier": "संपत्ति संशोधक",
    "Source notes aspect, transit, conjunction and DBA involvement": "स्रोत नोट्स पहलू, यातायात, संयोजन और DBA की भागीदारी",
    "Property Through Financing / Loan": "वित्त पोषण / ऋण के माध्यम से संपत्ति",
    "Loan repayment/completion support: +4,11": "ऋण पुनर्भुगतान / समापन समर्थन: +4,11",
    "Property Through Institutional / Personal Support": "संस्थागत / व्यक्तिगत समर्थन के माध्यम से संपत्ति",
    "Property Through Gift / Inheritance": "उपहार / विरासत के माध्यम से संपत्ति",
    "Property Purchase in Stages": "चरणबद्ध संपत्ति खरीद",
    "Government / Institution-Allotted Property": "सरकारी / संस्थागत आवंटित संपत्ति",
    "Commercial Property Purchase": "वाणिज्यिक संपत्ति खरीद",
    "Rental Income Potential": "किराए से आय की संभावना",
    "Considering a Residence Change": "निवास स्थान परिवर्तन पर विचार",
    "Change of Residence": "निवास स्थान परिवर्तन",
    "Separative planets": "पृथक ग्रह",
    "Property Through Family / Marriage Arrangement": "परिवार / विवाह व्यवस्था के माध्यम से संपत्ति",
    "Property Ownership / Possession Challenges": "संपत्ति का स्वामित्व / कब्जे की चुनौतियाँ",
    "Property Conflict / Government Intervention": "संपत्ति विवाद / सरकारी हस्तक्षेप",
    "Property Dispute / Litigation Indicators": "संपत्ति विवाद / मुकदमेबाजी के संकेत",
    "Venus": "शुक्र",
    "source modifier": "स्रोत परिवर्तक",
    "Do not infer gender in public UI": "सार्वजनिक UI में लिंग का अनुमान न लगाएँ",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "बुध और द्विगुणित राशि के साथ, स्रोत बार-बार/अनेक समस्याओं का संकेत देता है",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "बृहस्पति और द्विगुणित राशि के साथ, स्रोत बार-बार/अनेक समस्याओं का संकेत देता है",
    "Supportive Property Dispute Indicators": "सहायक संपत्ति विवाद संकेत",
    "Challenging Property Dispute Indicators": "चुनौतीपूर्ण संपत्ति विवाद संकेतक",
    "Property Division / Partition": "संपत्ति विभाजन / पार्टिशन",
    "Property Sale Prospects": "संपत्ति बिक्री संभावनाएँ",
    "Favourable Property Sale Conditions": "अनुकूल संपत्ति बिक्री स्थितियाँ",
    "Less Supportive Property Sale Conditions": "कम सहायक संपत्ति बिक्री स्थितियाँ",
    "Vehicle": "वाहन",
    "Vehicle Acquisition Prospects": "वाहन अधिग्रहण संभावनाएँ",
    "primary vehicle significator": "प्राथमिक वाहन संकेतक",
    "Vehicle Through Financing / Loan": "वित्तपोषण / ऋण द्वारा वाहन",
    "Vehicle Through Gift": "उपहार के माध्यम से वाहन",
    "Venus active in DBA": "DBA में शुक्र सक्रिय",
    "Premium / Luxury Vehicle Indicators": "प्रीमियम / लक्ज़री वाहन संकेतक",
    "primary factor": "प्राथमिक कारक",
    "Natural benefic planets": "प्राकृतिक शुभ ग्रह",
    "aspecting/supporting factor": "दृष्टि/समर्थक कारक",
    "Pre-Owned Vehicle Indicators": "प्रयुक्त वाहन संकेतक",
    "aspecting factor": "दृष्टि कारक",
    "Vehicle Maintenance Concerns": "वाहन रखरखाव संबंधी चिंता",
    "Commercial Vehicle Indicators": "वाणिज्यिक वाहन संकेतक",
    "commercial vehicle modifier": "वाणिज्यिक वाहन संशोधक",
    "Mercury involved or aspecting": "बुध शामिल या दृष्टि डाल रहा है",
    "small commercial vehicle modifier": "छोटे वाणिज्यिक वाहन संशोधक",
    "Venus involved or aspecting": "शुक्र शामिल या दृष्टि में",
    "heavy commercial vehicle modifier": "भारी वाणिज्यिक वाहन संशोधक",
    "Saturn involved or aspecting": "शनि शामिल या दृष्टि में",
    "Vehicle Security / Possession Caution": "वाहन सुरक्षा / संपत्ति सावधानी",
    "Strong Vehicle Security / Possession Caution": "मजबूत वाहन सुरक्षा / संपत्ति सावधानी",
    "Vehicle Recovery / Resolution Indicators": "वाहन वापसी / समाधान संकेतक",
    "Vehicle Loan Repayment Challenges": "वाहन ऋण भुगतान चुनौतियाँ",
    "Stronger while the combination remains active in DBA": "जब संयोजन DBA में सक्रिय रहता है तब और मजबूत",
    "Improvement/return after payment: 4,6,11": "भुगतान के बाद सुधार / वापसी: 4,6,11",
    "Vehicle Sale Prospects": "वाहन बिक्री की संभावनाएँ",
    "Insurance Claim Indicators": "बीमा दावा संकेतक",
    "Travel, Visa & Foreign Matters": "यात्रा, वीज़ा और विदेशी मामले",
    "Travel Prospects": "यात्रा की संभावनाएँ",
    "travel modifier": "यात्रा संशोधक",
    "Short-Distance Travel": "कोर-संसार यात्रा",
    "Long-Distance Travel": "लंबी दूरी की यात्रा",
    "Change in Travel Plans / Route": "यात्रा योजनाओं / मार्ग में परिवर्तन",
    "Separative planet": "पृथक ग्रह",
    "International Travel Requiring Greater Adjustment": "अंतर्राष्ट्रीय यात्रा जिसके लिए अधिक समायोजन आवश्यक है",
    "Malefic planets": "कारी ग्रह",
    "Supportive International Travel": "सहायक अंतर्राष्ट्रीय यात्रा",
    "Benefic planets": "शुभ ग्रह",
    "Return Home / Homecoming": "घर वापसी / घर आना",
    "Visa Prospects": "वीज़ा संभावनाएँ",
    "Tourist Visa Prospects": "पर्यटन वीज़ा संभावनाएँ",
    "Study Visa Prospects": "अध्ययन वीज़ा संभावनाएँ",
    "Business Visa Prospects": "व्यवसाय वीज़ा संभावनाएँ",
    "Import/export business: +2,7,10,11": "आयात/निर्यात व्यवसाय: +2,7,10,11",
    "Work Visa Prospects": "कार्य वीज़ा संभावनाएँ",
    "Partner Abroad Indicators": "विदेशी भागीदार संकेतक",
    "Marriage Abroad Prospects": "विदेश में विवाह संभावनाएँ",
    "Professional / Conference Travel": "पेशेवर / सम्मेलन यात्रा",
    "Sports-Related Travel": "खेल-संबंधित यात्रा",
    "Family & Life Development": "परिवार और जीवन विकास",
    "Family Expansion Prospects": "परिवार विस्तार संभावनाएँ"
  },
  "ta": {
    "Event Analysis": "நிகழ்வு பகுப்பாய்வு",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "அதன் பாரம்பரிய நாடி வீட்டு குழுக்களையும் சம்பந்தப்பட்ட கிரகங்களையும் காண, ஒரு வகை மற்றும் நிகழ்வை தேர்ந்தெடுக்கவும்.",
    "Category": "வகை",
    "Event": "நிகழ்வு",
    "Locked": "பூட்டப்பட்டது",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "அனைத்து வகைகளும் மற்றும் நிகழ்வுகளும் காட்சிபடுத்தப்படுகின்றன. பூட்டப்பட்ட நிகழ்வு பகுப்பாய்வு விருப்பங்களை திறக்க பிரிமியம் பதிப்புக்கு மேம்படுத்தவும்.",
    "Supportive indication": "ஆதரவு குறிப்பு",
    "Challenging indication": "சவாலை குறிக்கும் குறிப்பு",
    "Neutral indication": "நியூட்ரல் குறிப்பு",
    "Event groups": "நிகழ்வு குழுக்கள்",
    "Good": "நல்லது",
    "Bad": "மோசமானது",
    "Supportive": "ஆதரவு",
    "Challenging supportive": "சவாலை எதிர்கொள்ளும் ஆதரவு",
    "Planets involved": "சம்பந்தப்பட்ட கிரகங்கள்",
    "involved": "சம்பந்தப்பட்டது",
    "Pro": "தொழில்முறை",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "இந்த விளக்கங்கள் பாரம்பரிய ஜோதிடக் கோட்பாடுகளின் அடிப்படையில் உருவாக்கப்பட்டவை மற்றும் தகவல் மற்றும் கல்வியறிவு குறிக்கோளுக்காகவே உள்ளன. இவை ஒரு நபரின் பழகுமுறைகள் மற்றும் சாத்தியங்களை காட்டுகின்றன, உறுதி செய்யப்பட்ட முடிவுகளை அல்ல. சட்ட, நிதி, மருத்துவ அல்லது பிற தொழில்முறை விஷயங்களுக்கு, தகுதி பெற்ற தொழில்முறை ஒருவரைப் பரிந்துரைக்கவும்.",
    "Career, Work & Business": "தொழில், வேலை மற்றும் வணிகம்",
    "Employment Prospects": "பணியிட வாய்ப்புகள்",
    "Business Prospects": "வணிக வாய்ப்புகள்",
    "Earning Potential": "வருமானக் திறன்",
    "Business Challenges": "வணிகச் சிக்கல்கள்",
    "Business Recovery Indicators": "வணிக மீட்பு குறியீடுகள்",
    "10,11 acts as regain/recovery support after business difficulty.": "வணிகக் கடினத்திறன் பிறகு 10, 11 மீண்டு/மீட்டெடுப்பிற்கு ஆதரவு அளிக்கின்றன.",
    "Administration Career": "நிர்வாகத் தொழில்",
    "Employment Challenges": "பணியிட சிக்கல்கள்",
    "Professional Obstacles / Delays": "தொழில்முறை தடைகள் / தாமதங்கள்",
    "Professional Recognition Challenges": "தொழில்முறை அங்கீகாரம் பெறுவதில் சிக்கல்கள்",
    "Financial Pressure": "நிதி அழுத்தம்",
    "Financial Return Cycle": "நிதி மீட்டெடுப்பு சுற்றம்",
    "Supportive Career Change": "ஆதரவான தொழில் மாற்றம்",
    "Favourable Career Transition": "சாதகமான தொழிலை மாற்றம்",
    "Next DBA": "அடுத்த DBA",
    "Challenging Career Transition": "சவாலான தொழிலை மாற்றம்",
    "Workplace Transfer / Relocation": "வேலைப்பேற்றம் / இடமாற்றம்",
    "Return to Previous Workplace / Location": "முந்தைய வேலை / இடத்திற்கு திரும்புதல்",
    "Personality & Temperament": "தன்மை மற்றும் மனப்பாங்கு",
    "Assertive / Intense Temperament": "உறுதிப்படும் / தீவிர மனப்பாங்கு",
    "Mars": "செவ்வாய் நில்",
    "modifier": "மாற்றக்கூடியவை",
    "Mars connected with the 1st or 3rd house": "1வது அல்லது 3வது வீட்டுடன் செவ்வாய் இணைப்பு",
    "Emotional Sensitivity": "உணர்ச்சி உணர்வு",
    "Moon": "சந்திரன்",
    "Moon influence; source also notes Cancer connected with the 1st house": "சந்திரன் தாக்கம்; மூலமும் குறிப்பிடுகிறது 1வது வீட்டுடன் கார்கன் இணைப்பு",
    "Affectionate & Relationship-Oriented Nature": "அன்பான மற்றும் உறவு மையமான தன்மை",
    "Warm & Supportive Nature": "சூடான மற்றும் ஆதரவான தன்மை",
    "Independent / Detached Tendencies": "சுயாதீன / தனிமை காதல் நோக்கங்கள்",
    "Rahu": "ராகு",
    "associated planet": "தொடர்புடைய கோள்கள்",
    "Ketu": "கேது",
    "Saturn": "சனி",
    "Sun": "சூரியன்",
    "Reserved / Practical Nature": "உள்வாங்கும் / நடைமுறை தன்மை",
    "Persistent / Determined Nature": "நிலைத்திருக்கும் / தீர்மானமான தன்மை",
    "Relationships & Marriage": "உறவுகள் மற்றும் திருமணம்",
    "Relationship Boundary Challenges": "உறவு எல்லை சவால்கள்",
    "Supportive Relationship Bond": "ஆதரவான உறவுக்கோடு",
    "Private / Complex Relationship Phase": "தனிப்பட்ட / சிக்கலான உறவுக் கட்டம்",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "மூலமும் 5,9,11; 5,11; மற்றும் 5,8,11 போன்ற தூய்மையான/ஆதரவான உறவு பதிப்புகளையும் பட்டியலிடுகிறது.",
    "Relationship Conflict / Reactive Dynamics": "உறவு மோதல் / பகுப்பாய்வு இயங்குகள்",
    "Marriage Prospects": "திருமண வாய்ப்புகள்",
    "Marriage Through Known Circle": "தெரிந்த வட்டார மூலம் திருமணம்",
    "Supportive Marriage Circumstances": "ஆதரவான திருமண சூழல்கள்",
    "Marriage Delay Indicators": "திருமண தாமதக் குறிப்புகள்",
    "In DBA": "DBA இல்",
    "Emotional Distance in Relationship": "உறவில் உணர்வு தூரம்",
    "Reconciliation Indicators": "மீளுஅமைப்பு குறிப்புகள்",
    "Use with the preceding relationship/separation combination.": "முந்தைய உறவு/பிரிவு ஒன்றிணைப்புடன் பயன்படுத்தவும்.",
    "Marital Transition / Separation Indicators": "திருமண மாற்றம் / பிரிவுகள் குறிப்புகள்",
    "Reduced Support for Marriage": "திருமணத்திற்கு ஆதரவு குறைவு",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "பல தொடர்புடைய கிரகங்கள்/சின்னங்கள் மூலம் 1,6,10 மீண்டும் வருகிறது என்றால் பலப்படுத்துகிறது.",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "7வது கூப்பு ஆண்டரும் 1,6,10 ஐ குறிப்பிடும்போது பலப்படுத்துகிறது.",
    "Relocation After Marriage": "திருமணத்துக்குப் பிறகு இடமாற்றம்",
    "Relocation to a Distant / Unfamiliar Place": "தொலைவிலோ / அறிமுகமற்ற இடத்திற்கான மாற்றம்",
    "Non-Traditional Relationship Pattern": "பாரம்பரிய அல்லாத உறவு முறை",
    "Education & Learning": "கல்வி மற்றும் கற்பித்தல்",
    "Education Prospects": "கல்வி வாய்ப்புகள்",
    "Strong Education Potential": "வலுவான கல்வி திறன்",
    "Management / Professional Higher Education Potential": "மேலாண்மை / தொழில்முறை மேல்நிலை கல்வி திறன்",
    "Profession Indicators": "தொழில் குறிக்கைகள்",
    "Astrology / Astrologer": "ஜோதிடம் / ஜோதிடர்",
    "Mercury": "புதன்",
    "profession modifier": "தொழில் மாற்றி",
    "Jupiter": "வியாழன்",
    "Teacher / Educator": "ஆசிரியர் / கற்பிப்பவர்",
    "Higher-education support: 1,2,4,9,11": "உயர் கல்வி ஆதரவு: 1,2,4,9,11",
    "Writer / Professional Writing": "எழுத்தாளர் / தொழில்முறை எழுத்து",
    "Income Support Through Profession": "தொழிலின் மூலம் வருமான ஆதரவு",
    "Medical / Healthcare Profession": "மருத்துவ / சுகாதார தொழில்",
    "Stronger professional quality: 5,9,11 + 6,8,12": "வலுவான தொழில்முறை குணாதிசயம்: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "தொழில்முறை வெற்றி ஆதரவு: 6,8,12 + 10,11 அல்லது +11 அல்லது +9,11",
    "Engineer": "இன்ஜினீயர்",
    "Scientist": "விஞ்ஞானி",
    "Research / Inventions / Deep Analysis": "ஆய்வு / கண்டுபிடிப்புகள் / ஆழ்ந்த பகுப்பாய்வு",
    "Recognition Through Research / Innovation": "ஆய்வு / கண்டுபிடிப்பின் மூலம் அங்கீகாரம்",
    "Information Technology": "தகவல் தொழில்நுட்பம்",
    "Higher-education support: 2,4,5,9,11": "உயர் கல்வி ஆதரவு: 2,4,5,9,11",
    "Lawyer / Legal Profession": "வழக்குரைஞர் / சட்ட தொழில்",
    "Architect": "வடிவமைப்பாளர்",
    "Builder / Construction": "கட்டுமான நிபுணர் / கட்டுமானம்",
    "Property / Real-Estate Professional": "சொத்துக் / ரியல் எஸ்டேட் நிபுணர்",
    "Property purchase activity: 4,11,12": "சொத்து வாங்கும் நடவடிக்கை: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "சொத்து விற்கும் நடவடிக்கை: 3,5,10 சனிபார்வையுடன் மற்றும் செவ்வாய்",
    "Interior Designer / Decorator": "உள்நிலை வடிவமைப்பாளர் / அலங்காரக் கலைஞர்",
    "Creativity / Innovation": "படைப்பாற்றல் / புதுமை",
    "Politics / Public Leadership": "அரசியல் / பொதுப் தலைமை",
    "Chartered Accountant": "சார்டர்ட் கணக்காளர்",
    "Data Management / Business Management": "தரவு மேலாண்மை / வணிக மேலாண்மை",
    "Chef / Culinary Profession": "சமையல் நிபுணர் / சமையல் தொழில்",
    "Benefic planet": "இனிய கிரகங்கள்",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "2வது வீட்டில் நேர்மறையாக உள்ள அல்லது 2வது வீட்டை நேர்மறையாக பாதிக்கும் கிரகங்கள்",
    "International / continental cuisine: +9,3,12": "சர்வதேச / கண்டினென்டல் சமையல்: +9,3,12",
    "Correctional / Institutional Administration": "திருத்தக்கூடிய / நிறுவன நிர்வாகம்",
    "Journalist / Media Professional": "பத்திரிகையாளர் / ஊடக நிபுணர்",
    "Investigative / crime reporting: +7,8,12": "விசாரணை / குற்றப்படை செய்தித்துறை: +7,8,12",
    "Political reporting: +1,10,11": "அரசியல் செய்தித்துறை: +1,10,11",
    "Sports reporting: +5,10": "விளையாட்டு செய்தித்துறை: +5,10",
    "Creative Writer": "படைப்பாற்றலாளர் எழுத்தாளர்",
    "Creativity: +5,9": "படைப்பாற்றல்: +5,9",
    "Artistic writing: 5,11": "கலைசார்ந்த எழுத்து: 5,11",
    "Mystery / occult / deep subjects: 8,12": "மறைமுகம் / ஸ்திர விசையியல் / ஆழமான விஷயங்கள்: 8,12",
    "Legal Matters": "சட்ட சம்பந்தமான விஷயங்கள்",
    "Legal Dispute Indicators": "சட்ட மோதல் குறியீடுகள்",
    "Supportive Legal Matter Indicators": "ஆதரவான சட்டம் குறியீடுகள்",
    "Challenging Legal Matter Indicators": "சவாலான சட்டம் குறியீடுகள்",
    "Legal Relief Indicators": "சட்ட நிவாரண குறியீடுகள்",
    "5,9 acts as a facilitator.": "5,9 ஒரு வழிகாட்டியாக செயல்படுகிறது.",
    "Property & Residence": "சொத்து & வாழிடம்",
    "Property Purchase Prospects": "சொத்து வாங்கும் முன் பார்வை",
    "property modifier": "சொத்து மாற்றும் கூறு",
    "Source notes aspect, transit, conjunction and DBA involvement": "மூல குறிப்புகள் அம்சம், போக்குவரத்து, இணைப்பு மற்றும் DBA சம்பந்தத்தை குறிப்பிடுகிறது",
    "Property Through Financing / Loan": "நிதியுதவி / கடன் மூலம் சொத்து",
    "Loan repayment/completion support: +4,11": "கடன் திரும்பச் செலுத்துதல் / முடிப்புக்கு ஆதரவு: +4,11",
    "Property Through Institutional / Personal Support": "நிறுவனம் / தனிப்பட்ட ஆதரவின் மூலம் சொத்து",
    "Property Through Gift / Inheritance": "பரிசு / பரம்பரை மூலம் சொத்து",
    "Property Purchase in Stages": "கட்டங்களில் சொத்து வாங்குதல்",
    "Government / Institution-Allotted Property": "அரசு / நிறுவனத்தால் ஒதுக்கப்பட்ட சொத்து",
    "Commercial Property Purchase": "வணிக சொத்து வாங்குதல்",
    "Rental Income Potential": "வாடகை வருமான சாத்தியம்",
    "Considering a Residence Change": "குடியிருப்பு மாற்றத்தைக் கருத்தில் கொள்ளுதல்",
    "Change of Residence": "குடியிருப்பு மாற்றம்",
    "Separative planets": "பிரிக்கும் கிரகங்கள்",
    "Property Through Family / Marriage Arrangement": "குடும்பம் / திருமண ஏற்பாட்டின் மூலம் சொத்து",
    "Property Ownership / Possession Challenges": "சொத்து உரிமை / உடைமை சவால்கள்",
    "Property Conflict / Government Intervention": "சொத்து மோதல் / அரசாங்க தலையீடு",
    "Property Dispute / Litigation Indicators": "சொத்து தகராறு / வழக்கு குறிகாட்டிகள்",
    "Venus": "வீனஸ்",
    "source modifier": "மூல மாற்றி",
    "Do not infer gender in public UI": "பொது UI இல் பாலினத்தை ஊகிக்க வேண்டாம்",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "புதன் மற்றும் இரட்டை அடையாளத்துடன், ஆதாரம் மீண்டும் மீண்டும் / பல சிக்கல்களைக் குறிக்கிறது",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "வியாழன் மற்றும் இரட்டை அடையாளத்துடன், ஆதாரம் மீண்டும் / பல சிக்கல்களைக் குறிக்கிறது",
    "Supportive Property Dispute Indicators": "ஆதரவு சொத்து தகராறு குறிகாட்டிகள்",
    "Challenging Property Dispute Indicators": "சவாலான சொத்து தகராறு குறிகாட்டிகள்",
    "Property Division / Partition": "சொத்து பிரிவு / பகிர்வு",
    "Property Sale Prospects": "சொத்து விற்பனை வாய்ப்புகள்",
    "Favourable Property Sale Conditions": "சாதகமான சொத்து விற்பனை நிபந்தனைகள்",
    "Less Supportive Property Sale Conditions": "குறைந்த ஆதரவான சொத்து விற்பனை நிபந்தனைகள்",
    "Vehicle": "வாகனம்",
    "Vehicle Acquisition Prospects": "வாகனம் கையகப்படுத்தல் வாய்ப்புகள்",
    "primary vehicle significator": "முதன்மை வாகன சிக்னிஃபிகேட்டர்",
    "Vehicle Through Financing / Loan": "நிதி / கடன் மூலம் வாகனம்",
    "Vehicle Through Gift": "பரிசு மூலம் வாகனம்",
    "Venus active in DBA": "டி.பி.ஏ.வில் வீனஸ் செயலில் உள்ளது",
    "Premium / Luxury Vehicle Indicators": "பிரீமியம் / சொகுசு வாகன குறிகாட்டிகள்",
    "primary factor": "முதன்மை காரணி",
    "Natural benefic planets": "இயற்கை நன்மை பயக்கும் கிரகங்கள்",
    "aspecting/supporting factor": "அம்சம்/துணை காரணி",
    "Pre-Owned Vehicle Indicators": "முன் சொந்தமான வாகன குறிகாட்டிகள்",
    "aspecting factor": "அம்சம் காரணி",
    "Vehicle Maintenance Concerns": "வாகன பராமரிப்பு கவலைகள்",
    "Commercial Vehicle Indicators": "வணிக வாகன குறிகாட்டிகள்",
    "commercial vehicle modifier": "வணிக வாகன மாற்றியமைப்பான்",
    "Mercury involved or aspecting": "புதன் சம்பந்தப்பட்ட அல்லது அம்சம்",
    "small commercial vehicle modifier": "சிறிய வணிக வாகன மாற்றியமைப்பான்",
    "Venus involved or aspecting": "செவ்வாய் பஞ்சாங்கத்தில் தொடர்புடைய அல்லது பார்வை செலுத்தும்",
    "heavy commercial vehicle modifier": "பெரிதான வணிக வாகன மாற்றி",
    "Saturn involved or aspecting": "சனிப்பிரதி பஞ்சாங்கத்தில் தொடர்புடைய அல்லது பார்வை செலுத்தும்",
    "Vehicle Security / Possession Caution": "வாகனத் பாதுகாப்பு / சொத்து எச்சரிக்கை",
    "Strong Vehicle Security / Possession Caution": "வலுவான வாகனத் பாதுகாப்பு / சொத்து எச்சரிக்கை",
    "Vehicle Recovery / Resolution Indicators": "வாகன மீட்பு / தீர்வு குறியீடுகள்",
    "Vehicle Loan Repayment Challenges": "வாகன கடன் திருப்பிச் செலுத்தல் சவால்கள்",
    "Stronger while the combination remains active in DBA": "இக்கூட்டு DBA-வில் செயல்பாட்டில் இருந்தால் அதிகமாகும்",
    "Improvement/return after payment: 4,6,11": "செலுத்தியபின் மேம்பாடு / திரும்பிப்பு: 4,6,11",
    "Vehicle Sale Prospects": "வாகன் விற்பனை வாய்ப்புகள்",
    "Insurance Claim Indicators": "காப்பீட்டு விவாத குறியீடுகள்",
    "Travel, Visa & Foreign Matters": "பயணம், விசா மற்றும் வெளிநாட்டு விவகாரங்கள்",
    "Travel Prospects": "பயண வாய்ப்புகள்",
    "travel modifier": "பயண மாற்றி",
    "Short-Distance Travel": "குறுகிய தூரப் பயணம்",
    "Long-Distance Travel": "நீண்ட தூரப் பயணம்",
    "Change in Travel Plans / Route": "பயணத் திட்டங்கள் / பாதை மாற்றம்",
    "Separative planet": "பிரிப்பு கிரகங்கள்",
    "International Travel Requiring Greater Adjustment": "அதிகச் சந்திர சீரமைப்பு தேவைப்படும் சர்வதேச பயணம்",
    "Malefic planets": "தீமான் கிரகங்கள்",
    "Supportive International Travel": "ஆதரவான சர்வதேச பயணம்",
    "Benefic planets": "பயனுள்ள கோள்கள்",
    "Return Home / Homecoming": "வீட்டுக்கு திரும்புதல் / வீடு வருகை",
    "Visa Prospects": "விசா வாய்ப்புகள்",
    "Tourist Visa Prospects": "சுற்றுலா விசா வாய்ப்புகள்",
    "Study Visa Prospects": "கல்வி விசா வாய்ப்புகள்",
    "Business Visa Prospects": "வணிக விசா வாய்ப்புகள்",
    "Import/export business: +2,7,10,11": "இறக்குமதி/ஏற்றுமதி வணிகம்: +2,7,10,11",
    "Work Visa Prospects": "வேலை விசா வாய்ப்புகள்",
    "Partner Abroad Indicators": "வெளிநாட்டில் துணைவருக்கான குறிக்கோள்கள்",
    "Marriage Abroad Prospects": "வெளிநாட்டில் திருமண வாய்ப்புகள்",
    "Professional / Conference Travel": "தொழிற் / கருத்தரங்க பயணம்",
    "Sports-Related Travel": "விளையாட்டு தொடர்பான பயணம்",
    "Family & Life Development": "குடும்பம் & வாழ்க்கை வளர்ச்சி",
    "Family Expansion Prospects": "குடும்ப விரிவாக்க வாய்ப்புகள்"
  },
  "te": {
    "Event Analysis": "ఈవెంట్ విశ్లేషణ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "దాని సాంప్రదాయ నాది గృహ గుంపులు మరియు భాగస్వామ్య గ్రహాలను చూడటానికి ఒక వర్గాన్ని మరియు ఈవెంట్‌ని ఎంచుకోండి.",
    "Category": "వర్గం",
    "Event": "ఈవెంట్",
    "Locked": "లాక్ చేయబడింది",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "అన్ని వర్గాలు మరియు ఈవెంట్లు కనిపిస్తున్నాయి. లాక్ చేయబడిన ఈవెంట్ విశ్లేషణ ఎంపికలను అన్‌లాక్ చేయడానికి ప్రీమియమ్‌కు అప్‌గ్రేడ్ చేయండి.",
    "Supportive indication": "మద్దతు సూచన",
    "Challenging indication": "సవాలు సూచన",
    "Neutral indication": "న్యూట్రల్ సూచన",
    "Event groups": "ఈవెంట్ గుంపులు",
    "Good": "మంచి",
    "Bad": "చెడు",
    "Supportive": "మద్దతుగా",
    "Challenging supportive": "సవాలు మద్దతుగా",
    "Planets involved": "భాగస్వామ్య గ్రహాలు",
    "involved": "పాల్గొన్నారు",
    "Pro": "ప్రో",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "ఈ వ్యాఖ్యానాలు సాంప్రదాయక జ్యోతిష్య సిద్ధాంతాలపై ఆధారపడి ఉంటాయి మరియు సమాచారం మరియు విద్యా ప్రయోజనాల కోసం ఉద్దేశించబడినవి. అవి ధోరణులు మరియు అవకాశాలను సూచిస్తాయి, హామీ ఇచ్చే ఫలితాలను కాదు. చట్ట, ఆర్థిక, వైద్య లేదా ఇతర వృత్తిపరమైన విషయాల కోసం, తగిన అర్హత కలిగిన వృత్తిపరులను సంప్రదించండి.",
    "Career, Work & Business": "వృత్తి, పని & వ్యాపారం",
    "Employment Prospects": "ఉపాధి అవకాశాలు",
    "Business Prospects": "వ్యాపార అవకాశాలు",
    "Earning Potential": "సంపాదన సామర్థ్యం",
    "Business Challenges": "వ్యాపార సవాళ్లు",
    "Business Recovery Indicators": "వ్యాపార పునరుద్ధరణ సూచనలు",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 వ్యాపార సమస్య తర్వాత మళ్లీ పొందడం / పునరుద్ధరణకు మద్దతుగా పనిచేస్తాయి.",
    "Administration Career": "పరిపాలన వృత్తి",
    "Employment Challenges": "ఉపాధి సవాళ్లు",
    "Professional Obstacles / Delays": "వృత్తిపరమైన అడ్డంకులు / ఆలస్యం",
    "Professional Recognition Challenges": "వృత్తిపరమైన గుర్తింపు సవాళ్లు",
    "Financial Pressure": "ఆర్థిక ఒత్తిడి",
    "Financial Return Cycle": "ఆర్థిక రాబడి చక్రం",
    "Supportive Career Change": "మద్దతుగా వృత్తి మార్పు",
    "Favourable Career Transition": "అనుకూలమైన కెరీర్ పరివర్తన",
    "Next DBA": "తదుపరి DBA",
    "Challenging Career Transition": "కెరీర్ పరివర్తన సవాలు",
    "Workplace Transfer / Relocation": "పనిప్రాంతపు బదిలీ/రీలొకేషన్",
    "Return to Previous Workplace / Location": "గత పనిప్రాంతం/లొకేషన్ కు తిరిగి రావడం",
    "Personality & Temperament": "వ్యక్తిత్వం & స్వభావం",
    "Assertive / Intense Temperament": "దృఢమైన/తీవ్రమైన స్వభావం",
    "Mars": "అంగారక గ్రహం",
    "modifier": "మాడిఫైయర్",
    "Mars connected with the 1st or 3rd house": "అంగారక గ్రహం 1వ లేదా 3వ ఇంటితో అనుసంధానించబడి ఉంది",
    "Emotional Sensitivity": "భావోద్వేగ సున్నితత్వం",
    "Moon": "చంద్రుడు",
    "Moon influence; source also notes Cancer connected with the 1st house": "చంద్రుని ప్రభావం; 1వ ఇంటితో ముడిపడి ఉన్న కర్కాటకుడు కూడా మూలం పేర్కొంది.",
    "Affectionate & Relationship-Oriented Nature": "ఆప్యాయత మరియు సంబంధాల ఆధారిత స్వభావం",
    "Warm & Supportive Nature": "వెచ్చని మరియు సహాయక స్వభావం",
    "Independent / Detached Tendencies": "స్వతంత్ర/వేరు ధోరణులు",
    "Rahu": "రాహువు",
    "associated planet": "అనుబంధ గ్రహం",
    "Ketu": "కేతు",
    "Saturn": "శని",
    "Sun": "సూర్యుడు",
    "Reserved / Practical Nature": "రిజర్వ్ / ప్రాక్టికల్ స్వభావం",
    "Persistent / Determined Nature": "నిరంతర/నిశ్చయంగా ఉండే స్వభావం",
    "Relationships & Marriage": "సంబంధాలు & వివాహం",
    "Relationship Boundary Challenges": "రిలేషన్ షిప్ బౌండరీ సవాళ్లు",
    "Supportive Relationship Bond": "మద్దతుగా ఉన్న సంబంధ బంధం",
    "Private / Complex Relationship Phase": "ప్రైవేట్ / క్లిష్ట సంబంధ దశ",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "మూలం కూడా 5,9,11; 5,11; మరియు 5,8,11 ను శుభ్రమైన/మద్దతుగా ఉన్న సంబంధం విభిన్నాలుగా సూచిస్తుంది.",
    "Relationship Conflict / Reactive Dynamics": "సంబంధ ఘర్షణ / ప్రతికూల గుణపరిణామాలు",
    "Marriage Prospects": "వివాహ అవకాశాలు",
    "Marriage Through Known Circle": "తెలిసిన పరిచయ ద్వారా వివాహం",
    "Supportive Marriage Circumstances": "మద్దతుగా ఉన్న వివాహ పరిస్థితులు",
    "Marriage Delay Indicators": "వివాహం ఆలస్యం సూత్రాలు",
    "In DBA": "డేటాబేస్‌లో",
    "Emotional Distance in Relationship": "సంబంధంలో భావోద్వేగ దూరం",
    "Reconciliation Indicators": "మనఃపూర్వక ఐక్యత సూచనలు",
    "Use with the preceding relationship/separation combination.": "ముందు ఉన్న సంబంధ / వేరూపాటు కలయికతో ఉపయోగించండి.",
    "Marital Transition / Separation Indicators": "వివాహ మార్పు / వేరుపాటు సూచనలు",
    "Reduced Support for Marriage": "వివాహానికి మద్దతు తగ్గడం",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "1,6,10 అనేవి అనేక సంబంధిత గ్రహాలు/ప్రతీకరించినవి ద్వారా పునరావృతమైతే బలమవుతుంది.",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "7వ కవిచర్ల ప్రభువూ 1,6,10 ను సూచిస్తే బలమవుతుంది.",
    "Relocation After Marriage": "వివాహం తర్వాత స్థలమార్పు",
    "Relocation to a Distant / Unfamiliar Place": "దూరమైన / తెలియని స్థలానికి మార్పిడీ",
    "Non-Traditional Relationship Pattern": "సంప్రదాయేతర సంబంధ నమూనా",
    "Education & Learning": "విద్య & నేర్చుకోవడం",
    "Education Prospects": "విద్యా అవకాశాలు",
    "Strong Education Potential": "బలమైన విద్యా సామర్థ్యం",
    "Management / Professional Higher Education Potential": "నిర్వహణ / వృత్తిపరమైన ఉన్నత విద్య సామర్థ్యం",
    "Profession Indicators": "వృత్తి సూచికలు",
    "Astrology / Astrologer": "జ్యోతిష్యం / జ్యోతిషి",
    "Mercury": "బుధుడు",
    "profession modifier": "వృత్తి మార్పు సూచిక",
    "Jupiter": "గురువు",
    "Teacher / Educator": "అధ్యాపకుడు / విద్యావేత్త",
    "Higher-education support: 1,2,4,9,11": "ఉన్నత విద్యా మద్దతు: 1,2,4,9,11",
    "Writer / Professional Writing": "రచయిత / వృత్తిపరమైన రచన",
    "Income Support Through Profession": "వృత్తి ద్వారా ఆదాయం మద్దతు",
    "Medical / Healthcare Profession": "వైద్య / ఆరోగ్య సంరక్షణ వృత్తి",
    "Stronger professional quality: 5,9,11 + 6,8,12": "మరింత బలమైన వృత్తిపరమైన లక్షణం: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "వృత్తిపరమైన విజయానికి మద్దతు: 6,8,12 + 10,11 లేదా +11 లేదా +9,11",
    "Engineer": "ఇంజనీరుడు",
    "Scientist": "శాస్త్రవేత్త",
    "Research / Inventions / Deep Analysis": "పరిశోధన / ఆవిష్కరణలు / లోతైన విశ్లేషణ",
    "Recognition Through Research / Innovation": "పరిశోధన / ఆవిష్కరణ ద్వారా గుర్తింపు",
    "Information Technology": "సమాచార సాంకేతికత",
    "Higher-education support: 2,4,5,9,11": "ఉన్నత విద్యా మద్దతు: 2,4,5,9,11",
    "Lawyer / Legal Profession": "న్యాయవాది / న్యాయ వృత్తి",
    "Architect": "ఆర్కిటెక్ట్",
    "Builder / Construction": "బిల్డర్ / నిర్మాణం",
    "Property / Real-Estate Professional": "ఆస్తి / రియల ఎస్టేట్ వృత్తి",
    "Property purchase activity: 4,11,12": "సొంత దృవరాన్ని కొనుగోలు కార్యాచరణ: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "ఆస్తి అమ్మకం కార్యకలాపం: 3,5,10 సని మరియు ఎండ్లతో",
    "Interior Designer / Decorator": "ఇంటీరియర్ డిజైనర్ / డెకరేటర్",
    "Creativity / Innovation": "సృజనాత్మకత / నవీనత",
    "Politics / Public Leadership": "రాజకీయాలు / ప్రజా నాయకత్వం",
    "Chartered Accountant": "చార్టర్డెడ్ అకౌంటెంట్",
    "Data Management / Business Management": "డేటా నిర్వహణ / వ్యాపార నిర్వహణ",
    "Chef / Culinary Profession": "చెఫ్ / వంట వృత్తి",
    "Benefic planet": "లాభదాయక గ్రహం",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "రెండవ ఇంట్లో లాభ దాయక గ్రహం లేదా రెండవ ఇంటిని లాభకరంగా ప్రభావితం చేసే/దృష్టి చేసే",
    "International / continental cuisine: +9,3,12": "అంతర్జాతీయ / ఖండీయ వంటకాలు: +9,3,12",
    "Correctional / Institutional Administration": "శిక్షా / సంస్థాపన పరపాలన",
    "Journalist / Media Professional": "జర్నలిస్ట్ / మీడియా వృత్తి",
    "Investigative / crime reporting: +7,8,12": "అన్వేషణ / నేరాల రిపోర్టింగ్: +7,8,12",
    "Political reporting: +1,10,11": "రాజకీయ రిపోర్టింగ్: +1,10,11",
    "Sports reporting: +5,10": "క్రీడా రిపోర్టింగ్: +5,10",
    "Creative Writer": "సృజనాత్మక రచయిత",
    "Creativity: +5,9": "సృజనాత్మకత: +5,9",
    "Artistic writing: 5,11": "కళాత్మక రచన: 5,11",
    "Mystery / occult / deep subjects: 8,12": "మిస్టరీ / రహస్య / లోతైన విషయాలు: 8,12",
    "Legal Matters": "చట్ట వ్యావహారాలు",
    "Legal Dispute Indicators": "చట్టపరమైన వివాద సూచికలు",
    "Supportive Legal Matter Indicators": "మద్దతుగా ఉండే చట్టపరమైన అంశ సూచికలు",
    "Challenging Legal Matter Indicators": "సవాలుగా ఉండే చట్టపరమైన అంశ సూచికలు",
    "Legal Relief Indicators": "చట్ట ఉపశమనం సూచికలు",
    "5,9 acts as a facilitator.": "5,9 ఒక సౌకర్యదాతగా పనిచేస్తుంది.",
    "Property & Residence": "ఆస్తి & నివాసం",
    "Property Purchase Prospects": "ఆస్తి కొనుగోలు అవకాశాలు",
    "property modifier": "ఆస్తి సంబంధిత సూచకం",
    "Source notes aspect, transit, conjunction and DBA involvement": "మూలం గమనికలు ముహూర్తం, రవాణా, సంకలనం మరియు DBA కృషిని సూచిస్తుంది",
    "Property Through Financing / Loan": "ఫైనాన్సింగ్ / లోన్ ద్వారా ఆస్తి",
    "Loan repayment/completion support: +4,11": "లోన్ చెల్లింపు / ముగింపు మద్దతు: +4,11",
    "Property Through Institutional / Personal Support": "సంస్థ / వ్యక్తిగత మద్దతు ద్వారా ఆస్తి",
    "Property Through Gift / Inheritance": "ఆస్తి బహుమతి / వారసత్వం ద్వారా",
    "Property Purchase in Stages": "దశలవారీగా ఆస్తి కొనుగోలు",
    "Government / Institution-Allotted Property": "ప్రభుత్వ / సంస్థ-కేటాయించిన ఆస్తి",
    "Commercial Property Purchase": "వాణిజ్య ఆస్తి కొనుగోలు",
    "Rental Income Potential": "అద్దె ఆదాయ సాధ్యత",
    "Considering a Residence Change": "నివాస మార్పుని పరిగణనలోకి తీసుకోవడం",
    "Change of Residence": "నివాస మార్పు",
    "Separative planets": "వేరుగా ఉన్న గ్రహాలు",
    "Property Through Family / Marriage Arrangement": "కుటుంబ / వివాహ ఏర్పాట్ల ద్వారా ఆస్తి",
    "Property Ownership / Possession Challenges": "ఆస్తి యొక్క సొంతం / కల్పన సమస్యలు",
    "Property Conflict / Government Intervention": "ఆస్తి ఘర్షణ / ప్రభుత్వ జోక్యం",
    "Property Dispute / Litigation Indicators": "ఆస్తి ఘర్షణ / న్యాయ నిష్పత్తి సూచకాలు",
    "Venus": "శుక్రుడు",
    "source modifier": "మూల సవరణకర్త",
    "Do not infer gender in public UI": "పబ్లిక్ UI లో లింగం అనుమానించరాదు",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "బుధుడు మరియు ద్విగుణ చిహ్నంతో, మూలం పునరావృత/బహు సమస్యలను సూచిస్తుంది",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "బృహస్పతి మరియు ద్విగుణ చిహ్నంతో, మూలం పునరావృత/బహు సమస్యలను సూచిస్తుంది",
    "Supportive Property Dispute Indicators": "సహాయక ఆస్తి ఘర్షణ సూచకాలు",
    "Challenging Property Dispute Indicators": "సవాలు స్థాయి ఆస్తి వివాద సూచికలు",
    "Property Division / Partition": "ఆస్తి విభజన / భాగపరచడం",
    "Property Sale Prospects": "ఆస్తి అమ్మకపు అవకాశాలు",
    "Favourable Property Sale Conditions": "అనుకూల ఆస్తి అమ్మకపు పరిస్థితులు",
    "Less Supportive Property Sale Conditions": "తక్కువ మద్దతు ఇవ్వే ఆస్తి అమ్మకపు పరిస్థితులు",
    "Vehicle": "వాహనం",
    "Vehicle Acquisition Prospects": "వాహనం పొందే అవకాశాలు",
    "primary vehicle significator": "ప్రాథమిక వాహన సూచిక",
    "Vehicle Through Financing / Loan": "ఫైనాన్స్ / రుణం ద్వారా వాహనం",
    "Vehicle Through Gift": "బహుమతి ద్వారా వాహనం",
    "Venus active in DBA": "DBA లో సక్రియమైన శుక్రుడు",
    "Premium / Luxury Vehicle Indicators": "ప్రీమియం / లగ్జరీ వాహన సూచికలు",
    "primary factor": "ప్రాథమిక అంశం",
    "Natural benefic planets": "సహజ లాబ్ధి గ్రహాలు",
    "aspecting/supporting factor": "స్వరూపాన్ని చూపే / మద్దతు ఇచ్చే అంశం",
    "Pre-Owned Vehicle Indicators": "మునుపు ఉపయోగించిన వాహన సూచికలు",
    "aspecting factor": "స్వరూపాన్ని చూపే అంశం",
    "Vehicle Maintenance Concerns": "వాహన నిర్వహణలో సమస్యలు",
    "Commercial Vehicle Indicators": "వాణిజ్య వాహన సూచికలు",
    "commercial vehicle modifier": "వాణిజ్య వాహన సవర్తక",
    "Mercury involved or aspecting": "బుధుడు సంబంధపడటం లేదా దృశ్యంగా ఉండటం",
    "small commercial vehicle modifier": "చిన్న వాణిజ్య వాహన సవర్తక",
    "Venus involved or aspecting": "శుక్రగ్రహం సంబంధం లేదా ప్రభావం చూపించడం",
    "heavy commercial vehicle modifier": "భారీ వాణిజ్య వాహన మార్పిడి",
    "Saturn involved or aspecting": "శని గ్రహం సంబంధం లేదా ప్రభావం చూపించడం",
    "Vehicle Security / Possession Caution": "వాహన భద్రత / రాకపోక జాగ్రత్త",
    "Strong Vehicle Security / Possession Caution": "బలమైన వాహన భద్రత / రాకపోక జాగ్రత్త",
    "Vehicle Recovery / Resolution Indicators": "వాహన పునరుద్ధరణ / పరిష్కార సూచనలు",
    "Vehicle Loan Repayment Challenges": "వాహన లోన్ తిరిగి చెల్లింపు సమస్యలు",
    "Stronger while the combination remains active in DBA": "DBAలో కలయిక సక్రియంగా ఉండగానే మరింత బలమైనది",
    "Improvement/return after payment: 4,6,11": "చెల్లింపు తర్వాత మెరుగుదల / తిరిగి రావడం: 4,6,11",
    "Vehicle Sale Prospects": "వాహన అమ్మకం అవకాశాలు",
    "Insurance Claim Indicators": "బీమా క్లెయిమ్ సూచనలు",
    "Travel, Visa & Foreign Matters": "ప్రయాణం, వీసా & విదేశీ విషయాలు",
    "Travel Prospects": "ప్రయాణ అవకాశాలు",
    "travel modifier": "ప్రయాణ మార్పిడి",
    "Short-Distance Travel": "చిన్న దూర ప్రయాణం",
    "Long-Distance Travel": "దీర్ఘ దూర ప్రయాణం",
    "Change in Travel Plans / Route": "ప్రయాణ ప్రణాళిక / మార్గంలో మార్పు",
    "Separative planet": "వేరుగా చేసే గ్రహం",
    "International Travel Requiring Greater Adjustment": "ఎక్కువ సర్దుబాటు అవసరమున్న అంతర్జాతీయ ప్రయాణం",
    "Malefic planets": "దుష్ట గ్రహాలు",
    "Supportive International Travel": "సహాయక అంతర్జాతీయ ప్రయాణం",
    "Benefic planets": "శుభ గ్రహాలు",
    "Return Home / Homecoming": "రిటర్న్ హోమ్ / హోమ్ కమింగ్",
    "Visa Prospects": "వీసా అవకాశాలు",
    "Tourist Visa Prospects": "టూరిస్ట్ వీసా అవకాశాలు",
    "Study Visa Prospects": "స్టడీ వీసా అవకాశాలు",
    "Business Visa Prospects": "బిజినెస్ వీసా అవకాశాలు",
    "Import/export business: +2,7,10,11": "దిగుమతి / ఎగుమతి వ్యాపారం: +2,7,10,11",
    "Work Visa Prospects": "వర్క్ వీసా అవకాశాలు",
    "Partner Abroad Indicators": "భాగస్వామి విదేశీ సూచికలు",
    "Marriage Abroad Prospects": "విదేశాలలో వివాహ అవకాశాలు",
    "Professional / Conference Travel": "ప్రొఫెషనల్ / కాన్ఫరెన్స్ ట్రావెల్",
    "Sports-Related Travel": "క్రీడలకు సంబంధించిన ప్రయాణాలు",
    "Family & Life Development": "కుటుంబం & జీవితాభివృద్ధి",
    "Family Expansion Prospects": "కుటుంబ విస్తరణ అవకాశాలు"
  },
  "mr": {
    "Event Analysis": "घटना विश्लेषण",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "पारंपरिक नाडी घर गट आणि संबंधित ग्रह पाहण्यासाठी एक श्रेणी आणि घटना निवडा.",
    "Category": "श्रेणी",
    "Event": "घटना",
    "Locked": "बंद",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "सर्व श्रेणी आणि घटना दिसत आहेत. बंद केलेले घटना विश्लेषण पर्याय उघडण्यासाठी प्रीमियममध्ये अपग्रेड करा.",
    "Supportive indication": "सहाय्यक संकेत",
    "Challenging indication": "आव्हानात्मक संकेत",
    "Neutral indication": "तटस्थ संकेत",
    "Event groups": "घटना गट",
    "Good": "चांगले",
    "Bad": "वाईट",
    "Supportive": "सहाय्यक",
    "Challenging supportive": "आव्हानात्मक सहाय्यक",
    "Planets involved": "संबंधित ग्रह",
    "involved": "संबंधित",
    "Pro": "प्रो",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "हे अर्थ पारंपरिक ज्योतिषशास्त्रीय तत्त्वांवर आधारित आहेत आणि माहिती व शैक्षणिक उद्देशांसाठी आहेत. हे प्रवृत्ती आणि शक्यता दर्शवतात, निश्चित परिणाम नाहीत. कानूनी, आर्थिक, वैद्यकीय किंवा इतर व्यावसायिक बाबींसाठी, योग्य पात्र व्यावसायिकाचा सल्ला घ्या.",
    "Career, Work & Business": "करिअर, काम आणि व्यवसाय",
    "Employment Prospects": "नोकरीच्या संधी",
    "Business Prospects": "व्यवसायाच्या संधी",
    "Earning Potential": "उत्पन्नाची क्षमता",
    "Business Challenges": "व्यवसायाची आव्हाने",
    "Business Recovery Indicators": "व्यवसाय पुनर्प्राप्तीचे निर्देशक",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 व्यवसायातील अडचणीनंतर पुनर्प्राप्ती/सहाय्यता म्हणून काम करतात.",
    "Administration Career": "प्रशासन करिअर",
    "Employment Challenges": "नोकरीतील आव्हाने",
    "Professional Obstacles / Delays": "व्यावसायिक अडथळे / उशीर",
    "Professional Recognition Challenges": "व्यावसायिक सन्मानाचे आव्हाने",
    "Financial Pressure": "आर्थिक ताण",
    "Financial Return Cycle": "आर्थिक परतावा चक्र",
    "Supportive Career Change": "सहायक करिअर बदल",
    "Favourable Career Transition": "अनुकूल करिअर संक्रमण",
    "Next DBA": "पुढील DBA",
    "Challenging Career Transition": "आव्हानात्मक करिअर संक्रमण",
    "Workplace Transfer / Relocation": "कार्यस्थळ स्थानांतर / स्थलांतर",
    "Return to Previous Workplace / Location": "मागील कार्यस्थळ / स्थानाकडे परतणे",
    "Personality & Temperament": "व्यक्तिमत्व व स्वभाव",
    "Assertive / Intense Temperament": "ठाम / तीव्र स्वभाव",
    "Mars": "मंगळ",
    "modifier": "सुधारक",
    "Mars connected with the 1st or 3rd house": "मंगळाचा 1 वा किंवा 3 वा घराशी संबंध",
    "Emotional Sensitivity": "भावनिक संवेदनशीलता",
    "Moon": "चंद्र",
    "Moon influence; source also notes Cancer connected with the 1st house": "चंद्राचा प्रभाव; स्रोतात नोंद केले आहे की कॅन्सरचा 1 वा घराशी संबंध",
    "Affectionate & Relationship-Oriented Nature": "स्नेही व नातेसंबंध-केंद्रीकृत स्वभाव",
    "Warm & Supportive Nature": "उबदार व सहायक स्वभाव",
    "Independent / Detached Tendencies": "स्वतंत्र / वेगळेपणा असलेले प्रवृत्ती",
    "Rahu": "राहू",
    "associated planet": "संबंधित ग्रह",
    "Ketu": "केतु",
    "Saturn": "शनि",
    "Sun": "सूर्य",
    "Reserved / Practical Nature": "आरक्षित / व्यावहारिक स्वभाव",
    "Persistent / Determined Nature": "सातत्यपूर्ण / ठोस स्वभाव",
    "Relationships & Marriage": "नातेसंबंध व लग्न",
    "Relationship Boundary Challenges": "नातेसंबंधातील सीमा आव्हाने",
    "Supportive Relationship Bond": "पाठिंबा देणारा नातेबंध",
    "Private / Complex Relationship Phase": "खाजगी / गुंतागुंतीच्या नात्याचे टप्पे",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "स्त्रोत 5,9,11; 5,11; आणि 5,8,11 ही स्वच्छ/पाठिंबा देणारी नातेवाईक आवृत्त्या म्हणून देखील सूचीबद्ध करतो.",
    "Relationship Conflict / Reactive Dynamics": "नातेदार संघर्ष / प्रतिक्रियात्मक गतिशीलता",
    "Marriage Prospects": "विवाहाच्या संधी",
    "Marriage Through Known Circle": "ज्ञात वर्तुळाद्वारे विवाह",
    "Supportive Marriage Circumstances": "पाठिंबा देणाऱ्या विवाहाच्या परिस्थिती",
    "Marriage Delay Indicators": "विवाह विलंबाचे संकेत",
    "In DBA": "डीबीएमध्ये",
    "Emotional Distance in Relationship": "नात्यातील भावनिक अंतर",
    "Reconciliation Indicators": "पुनर्मिलनाचे संकेत",
    "Use with the preceding relationship/separation combination.": "मागील नाते/विरह संयोजनासह वापरा.",
    "Marital Transition / Separation Indicators": "वैवाहिक संक्रमण / विरह संकेत",
    "Reduced Support for Marriage": "विवाहासाठी घटलेला पाठिंबा",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "जेव्हा 1,6,10 अनेक संबंधित ग्रह/सांकेतिक ग्रहांमधून पुनरावृत्त होतो तेव्हा बळकट होते.",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "जेव्हा 7व्या कस्ट लॉर्ड 1,6,10 दर्शवितो तेव्हा बळकट होते.",
    "Relocation After Marriage": "विवाहानंतर स्थलांतर",
    "Relocation to a Distant / Unfamiliar Place": "दूरच्या / अपरिचित ठिकाणी स्थलांतर",
    "Non-Traditional Relationship Pattern": "पारंपरिक नसलेले नातेसंबंध पद्धत",
    "Education & Learning": "शिक्षण आणि अध्ययन",
    "Education Prospects": "शिक्षणाची संधी",
    "Strong Education Potential": "मजबूत शिक्षण क्षमता",
    "Management / Professional Higher Education Potential": "व्यवस्थापन / व्यावसायिक उच्च शिक्षण क्षमता",
    "Profession Indicators": "व्यावसायिक निर्देशक",
    "Astrology / Astrologer": "ज्योतिषशास्त्र / ज्योतिषी",
    "Mercury": "बुध",
    "profession modifier": "व्यवसाय बदलक",
    "Jupiter": "गुरु",
    "Teacher / Educator": "शिक्षक / शिक्षक",
    "Higher-education support: 1,2,4,9,11": "उच्च शिक्षण समर्थन: 1,2,4,9,11",
    "Writer / Professional Writing": "लेखक / व्यावसायिक लेखन",
    "Income Support Through Profession": "व्यवसायाद्वारे उत्पन्न समर्थन",
    "Medical / Healthcare Profession": "वैद्यकीय / आरोग्यसेवा व्यावसाय",
    "Stronger professional quality: 5,9,11 + 6,8,12": "मजबूत व्यावसायिक गुणवत्ता: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "व्यावसायिक यश समर्थन: 6,8,12 + 10,11 किंवा +11 किंवा +9,11",
    "Engineer": "अभियंता",
    "Scientist": "शास्त्रज्ञ",
    "Research / Inventions / Deep Analysis": "संशोधन / शोध / सखोल विश्लेषण",
    "Recognition Through Research / Innovation": "संशोधन / नवकल्पना मधून ओळख",
    "Information Technology": "माहिती तंत्रज्ञान",
    "Higher-education support: 2,4,5,9,11": "उच्च शिक्षण समर्थन: 2,4,5,9,11",
    "Lawyer / Legal Profession": "वकील / कायदेशीर व्यावसाय",
    "Architect": "वास्तुविशारद",
    "Builder / Construction": "बांधकाम व्यावसाय / निर्माता",
    "Property / Real-Estate Professional": "मालमत्ता / रिअल इस्टेट व्यावसाय",
    "Property purchase activity: 4,11,12": "मालमत्ता खरेदी क्रियाकलाप: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "मालमत्ता विक्री क्रियाकलाप: 3,5,10 शनि आणि मंगळासह",
    "Interior Designer / Decorator": "आंतररिक डिझायनर / डेकोरेटर",
    "Creativity / Innovation": "सर्जनशीलता / नविन कल्पकता",
    "Politics / Public Leadership": "राजकारण / सार्वजनिक नेतृत्व",
    "Chartered Accountant": "चार्टर्ड अकाउंटंट",
    "Data Management / Business Management": "डेटा व्यवस्थापन / व्यवसाय व्यवस्थापन",
    "Chef / Culinary Profession": "शेफ / पाककला व्यावसाय",
    "Benefic planet": "शुभ ग्रह",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "दुसऱ्या घरात शुभ किंवा दुसऱ्या घरावर अनुकूल दृष्टी/प्रभाव करणारा ग्रह",
    "International / continental cuisine: +9,3,12": "आंतरराष्ट्रीय / खंडीय पाककला: +9,3,12",
    "Correctional / Institutional Administration": "सुधारात्मक / संस्थात्मक प्रशासन",
    "Journalist / Media Professional": "पत्रकार / माध्यम व्यावसाय",
    "Investigative / crime reporting: +7,8,12": "तपासणी / गुन्हा रिपोर्टिंग: +7,8,12",
    "Political reporting: +1,10,11": "राजकीय रिपोर्टिंग: +1,10,11",
    "Sports reporting: +5,10": "क्रीडा रिपोर्टिंग: +5,10",
    "Creative Writer": "सर्जनशील लेखक",
    "Creativity: +5,9": "सर्जनशीलता: +5,9",
    "Artistic writing: 5,11": "कलात्मक लेखन: 5,11",
    "Mystery / occult / deep subjects: 8,12": "रहस्य / गूढ / खोल विषय: 8,12",
    "Legal Matters": "कायदेशीर बाबी",
    "Legal Dispute Indicators": "कायदेशीर झगड्याची बाबी दर्शविणारे संकेत",
    "Supportive Legal Matter Indicators": "सहाय्यक कायदेशीर बाबी दर्शविणारे संकेत",
    "Challenging Legal Matter Indicators": "आव्हानात्मक कायदेशीर बाबी दर्शविणारे संकेत",
    "Legal Relief Indicators": "कायदेशीर मदत दर्शविणारे संकेत",
    "5,9 acts as a facilitator.": "5,9 मदतनीस म्हणून कार्य करते.",
    "Property & Residence": "मालमत्ता व निवासस्थान",
    "Property Purchase Prospects": "मालमत्ता विकत घेण्याचे संभाव्य परिणाम",
    "property modifier": "मालमत्ता सुधारक",
    "Source notes aspect, transit, conjunction and DBA involvement": "स्त्रोत नोट्स पैलू, ट्रांझिट, संयुग आणि DBA सहभाग दर्शविते",
    "Property Through Financing / Loan": "वित्तपुरवठा / कर्जाद्वारे मालमत्ता",
    "Loan repayment/completion support: +4,11": "कर्ज परतफेड/पूर्णतेसाठी सहाय्य: +4,11",
    "Property Through Institutional / Personal Support": "संस्थात्मक / वैयक्तिक सहाय्याद्वारे मालमत्ता",
    "Property Through Gift / Inheritance": "भेट / वारसाहक्काद्वारे मालमत्ता",
    "Property Purchase in Stages": "टप्प्याटप्प्याने मालमत्ता खरेदी",
    "Government / Institution-Allotted Property": "सरकार / संस्थेकडून वाटप केलेली मालमत्ता",
    "Commercial Property Purchase": "व्यावसायिक मालमत्ता खरेदी",
    "Rental Income Potential": "भाडे उत्पन्नाची क्षमता",
    "Considering a Residence Change": "निवास बदलाचा विचार करीत आहे",
    "Change of Residence": "निवास बदल",
    "Separative planets": "वेगळे ग्रह",
    "Property Through Family / Marriage Arrangement": "कुटुंब / विवाह व्यवस्थेद्वारे मालमत्ता",
    "Property Ownership / Possession Challenges": "मालमत्तेवरील मालकी / ताब्यात अडचणी",
    "Property Conflict / Government Intervention": "मालमत्ता संघर्ष / सरकारी हस्तक्षेप",
    "Property Dispute / Litigation Indicators": "मालमत्ता वाद / खटल्याचे निर्देशक",
    "Venus": "शुक्र",
    "source modifier": "स्रोत सुधारक",
    "Do not infer gender in public UI": "सार्वजनिक UI मध्ये लिंगाचा अर्थ लावू नका",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "बुध आणि द्विगुण चिन्हासह, स्रोत सतत / अनेक समस्या दर्शवितो",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "गुरु आणि द्विगुण चिन्हासह, स्रोत सतत / अनेक समस्या दर्शवितो",
    "Supportive Property Dispute Indicators": "मदत करणारे मालमत्ता वाद निर्देशक",
    "Challenging Property Dispute Indicators": "मालमत्ता विवाद निर्देशकांना आव्हान देणे\n[[एन१५४]] मालमत्ता विभागणी / विभाजन",
    "Property Division / Partition": "मालमत्ता विभाग / वाटप",
    "Property Sale Prospects": "मालमत्ता विक्रीची शक्यता\n[[एन१५६]] अनुकूल मालमत्ता विक्री अटी\n[[एन 157]] कमी सहाय्यक मालमत्ता विक्री अटी",
    "Favourable Property Sale Conditions": "अनुकूल मालमत्ता विक्रीची शर्ती",
    "Less Supportive Property Sale Conditions": "कमी सहायक मालमत्ता विक्रीची अटी",
    "Vehicle": "वाहन .",
    "Vehicle Acquisition Prospects": "वाहन संपादनाची शक्यता",
    "primary vehicle significator": "प्राथमिक वाहन सूचक\n[[एन 161]] वित्तपुरवठा / कर्जाद्वारे वाहन",
    "Vehicle Through Financing / Loan": "वाहन फाइनान्सिंग / कर्जाद्वारे",
    "Vehicle Through Gift": "भेटवस्तूद्वारे वाहन",
    "Venus active in DBA": "डीबीएमध्ये सक्रिय शुक्र\n[[एन 164]] प्रीमियम / लक्झरी वाहन निर्देशक",
    "Premium / Luxury Vehicle Indicators": "प्रिमियम / लक्झरी वाहन निर्देशक",
    "primary factor": "प्राथमिक घटक",
    "Natural benefic planets": "नैसर्गिक शुभ ग्रह[संपादन]",
    "aspecting/supporting factor": "पैलू / समर्थन घटक\n[[एन 168]] प्री-ओन्ड वाहन निर्देशक",
    "Pre-Owned Vehicle Indicators": "पूर्व-मालक वाहन निर्देशक",
    "aspecting factor": "पैलू घटक",
    "Vehicle Maintenance Concerns": "वाहन देखभाल चिंता",
    "Commercial Vehicle Indicators": "व्यावसायिक वाहन निर्देशक",
    "commercial vehicle modifier": "व्यावसायिक वाहन सुधारक",
    "Mercury involved or aspecting": "बुध गुंतलेला किंवा दृष्टीक्षेप",
    "small commercial vehicle modifier": "लहान व्यावसायिक वाहन सुधारक",
    "Venus involved or aspecting": "शुक्र involved किंवा aspecting",
    "heavy commercial vehicle modifier": "जड व्यावसायिक वाहन बदलक",
    "Saturn involved or aspecting": "शनि involved किंवा aspecting",
    "Vehicle Security / Possession Caution": "वाहन सुरक्षा / मालकी खबरदारी",
    "Strong Vehicle Security / Possession Caution": "मजबूत वाहन सुरक्षा / मालकी खबरदारी",
    "Vehicle Recovery / Resolution Indicators": "वाहन पुनर्प्राप्ती / निर्णय निर्देशक",
    "Vehicle Loan Repayment Challenges": "वाहन कर्ज परतफेड आव्हाने",
    "Stronger while the combination remains active in DBA": "हा संयोजन DBA मध्ये सक्रिय असताना अधिक मजबूत",
    "Improvement/return after payment: 4,6,11": "रक्कम भरण्यापरंतर सुधारणा / परतावा: 4,6,11",
    "Vehicle Sale Prospects": "वाहन विक्रीची शक्यता",
    "Insurance Claim Indicators": "विमा दावा निर्देशक",
    "Travel, Visa & Foreign Matters": "प्रवास, व्हिसा आणि परदेशी बाबी",
    "Travel Prospects": "प्रवासाच्या शक्यता",
    "travel modifier": "प्रवास बदलक",
    "Short-Distance Travel": "लहान अंतराचा प्रवास",
    "Long-Distance Travel": "लांब अंतराचा प्रवास",
    "Change in Travel Plans / Route": "प्रवास योजना / मार्ग बदल",
    "Separative planet": "विभाजन करणारा ग्रह",
    "International Travel Requiring Greater Adjustment": "आंतरराष्ट्रीय प्रवास ज्यासाठी अधिक समायोजन आवश्यक",
    "Malefic planets": "अपायकारक ग्रह",
    "Supportive International Travel": "सहाय्यक आंतरराष्ट्रीय प्रवास",
    "Benefic planets": "लाभदायक ग्रह",
    "Return Home / Homecoming": "घर परतणे / घर परत येणे",
    "Visa Prospects": "व्हिसा संधी",
    "Tourist Visa Prospects": "पर्यटक व्हिसा संधी",
    "Study Visa Prospects": "अध्ययन व्हिसा संधी",
    "Business Visa Prospects": "व्यावसायिक व्हिसा संधी",
    "Import/export business: +2,7,10,11": "आयात/निर्यात व्यवसाय: +2,7,10,11",
    "Work Visa Prospects": "कामाचा व्हिसा संधी",
    "Partner Abroad Indicators": "परदेशातील भागीदाराचे निर्देशक",
    "Marriage Abroad Prospects": "परदेशात विवाहाच्या संधी",
    "Professional / Conference Travel": "व्यावसायिक / परिषद प्रवास",
    "Sports-Related Travel": "क्रीडा-संबंधित प्रवास",
    "Family & Life Development": "कुटुंब आणि जीवन विकास",
    "Family Expansion Prospects": "कुटुंब विस्ताराच्या संधी"
  },
  "gu": {
    "Event Analysis": "ઘટનાનો વિશ્લેષણ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "તેની પરંપરાગત નાડી ઘર જૂથો અને જોડાયેલા ગ્રહો જોવા માટે એક શ્રેણી અને ઘટના પસંદ કરો.",
    "Category": "શ્રેણી",
    "Event": "ઘટનાબાર",
    "Locked": "લોકડ",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "તમામ શ્રેણીઓ અને ઘટનાઓ દૃશ્યમાન છે. લોકડ થયેલી ઘટના વિશ્લેષણ વિકલ્પોને અનલોક કરવા પ્રીમિયમમાં અપગ્રેડ કરો.",
    "Supportive indication": "મદદરૂપ સૂચન",
    "Challenging indication": "પડકારજનક સૂચન",
    "Neutral indication": "તટસ્થ સૂચન",
    "Event groups": "ઘટના જૂથો",
    "Good": "સારો",
    "Bad": "ખરાબ",
    "Supportive": "મદદરૂપ",
    "Challenging supportive": "પડકારજનક મદદરૂપ",
    "Planets involved": "જોડાયેલા ગ્રહો",
    "involved": "જોડાયેલા",
    "Pro": "પ્રો",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "આ વ્યાખ્યાઓ પરંપરાગત જ્યોતિષશાસ્ત્રીય સિદ્ધાંતો પર આધારિત છે અને માહિતિગત અને શૈક્ષણિક ઉદ્દેશ્યો માટે બનાવવામાં આવી છે. તે વલણો અને શક્યતાઓ દર્શાવે છે, નિશ્ચિત પરિણામો નહીં. કાનૂની, નાણાકીય, વૈદ્યકીય અથવા અન્ય વ્યાવસાયિક બાબતો માટે, યોગ્ય પ્રમાણપત્ર ધરાવતા વ્યાવસાયિક સાથે પરામર્શ કરો.",
    "Career, Work & Business": "કૅરિયર, કામ અને વ્યવસાય",
    "Employment Prospects": "રોજગારની સંભાવનાઓ",
    "Business Prospects": "વ્યવસાયની સંભાવનાઓ",
    "Earning Potential": "કમાણીની ક્ષમતા",
    "Business Challenges": "વ્યવસાયના પડકારો",
    "Business Recovery Indicators": "વ્યવસાય પુનઃપ્રાપ્તિ સૂચકો",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 વ્યવસાયની મુશ્કેલી પછી પુનઃપ્રાપ્તિ/મદદરુપ ટેકો તરીકે કામ કરે છે.",
    "Administration Career": "પ્રશાસન કૅરિયર",
    "Employment Challenges": "રોજગાર પડકારો",
    "Professional Obstacles / Delays": "વ્યાવસાયિક અવરોધ / વિલંબ",
    "Professional Recognition Challenges": "વ્યાવસાયિક માન્યતા પડકારો",
    "Financial Pressure": "નાણાકીય દબાણ",
    "Financial Return Cycle": "નાણાંકીય રિટર્ન ચક્ર",
    "Supportive Career Change": "સમર્થક કૅરિયર બદલાવ",
    "Favourable Career Transition": "અનુકૂલ કારકિર્દી પરિવર્તન",
    "Next DBA": "આગળનો DBA",
    "Challenging Career Transition": "પડકારજનક કારકિર્દી પરિવર્તન",
    "Workplace Transfer / Relocation": "કાર્યસ્થળનું સ્થાનાંતરણ / સ્થાન પરિવર્તન",
    "Return to Previous Workplace / Location": "પૂર્વ કાર્યસ્થળ / સ્થાન પર પાછું ફરવું",
    "Personality & Temperament": "વ્યક્તિત્વ અને સ્વભાવ",
    "Assertive / Intense Temperament": "દૃઢ / તીવ્ર સ્વભાવ",
    "Mars": "મંગળ",
    "modifier": "સંશોધક",
    "Mars connected with the 1st or 3rd house": "મંગળનો પ્રથમ અથવા ત્રીજા ઘરે સંયોજન",
    "Emotional Sensitivity": "લાગણીશીલ સંવેદનશીલતા",
    "Moon": "ચંદ્ર",
    "Moon influence; source also notes Cancer connected with the 1st house": "ચંદ્રનો પ્રભાવ; સ્ત્રોતમાં દર્શાવ્યું કે કૅન્સર પ્રથમ ઘરની સાથે જોડાયેલ છે",
    "Affectionate & Relationship-Oriented Nature": "પ્રેમાળ અને સંબંધ પર આધારિત સ્વભાવ",
    "Warm & Supportive Nature": "ગરમ અને સહાયક સ્વભાવ",
    "Independent / Detached Tendencies": "સ્વતંત્ર / અલગાવવાળા વલણ",
    "Rahu": "રાહી",
    "associated planet": "જોડાયેલ ગ્રહ",
    "Ketu": "કેતુ",
    "Saturn": "શનિ",
    "Sun": "સૂર્ય",
    "Reserved / Practical Nature": "સંરક્ષિત / વ્યવહારુ સ્વભાવ",
    "Persistent / Determined Nature": "દૃઢ / નિર્ધારિત સ્વભાવ",
    "Relationships & Marriage": "સંબંધો અને લગ્ન",
    "Relationship Boundary Challenges": "સંબંધોની હદોની પડકારો",
    "Supportive Relationship Bond": "સહાયક સંબંધ બંધન",
    "Private / Complex Relationship Phase": "ખાનગી / જટિલ સંબંધ તબક્કો",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "સ્ત્રોત 5,9,11; 5,11; અને 5,8,11 ને વધુ શુધ્ધ/સહાયક સંબંધ રૂપે પણ સૂચવે છે.",
    "Relationship Conflict / Reactive Dynamics": "સંબંધ વિવાદ / પ્રતિક્રિયાત્મક ગતિશીલતા",
    "Marriage Prospects": "લગ્નની શક્યતાઓ",
    "Marriage Through Known Circle": "ઓળખાયેલ વર્તુળ મારફતે લગ્ન",
    "Supportive Marriage Circumstances": "સહાયક લગ્ન પરિસ્થિતિઓ",
    "Marriage Delay Indicators": "લગ્ન મુલતવાના સૂચકો",
    "In DBA": "DBA માં",
    "Emotional Distance in Relationship": "સંબંધમાં ભાવનાત્મક અંતર",
    "Reconciliation Indicators": "પુનર્મિલનની સૂચકો",
    "Use with the preceding relationship/separation combination.": "અગાઉના સંબંધ/વિભાજન સંયોજન સાથે ઉપયોગ કરો.",
    "Marital Transition / Separation Indicators": "લાગ્નિક પરિવર્તન / વિભાજન સૂચકો",
    "Reduced Support for Marriage": "લગ્ન માટેનો સહારો ઘટ્યો",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "મજબૂત બની જાય છે જ્યારે 1,6,10 અનેક સંબંધિત ગ્રહો/સંકેતકર્તાઓ દ્વારા પુનરાવૃત થાય છે.",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "મજબૂત બનશે જ્યારે 7મા કસપનો ભગવાન પણ 1,6,10 દર્શાવે.",
    "Relocation After Marriage": "લગ્ન પછી સ્થળાંતર",
    "Relocation to a Distant / Unfamiliar Place": "દૂરના / અજાણ્યા સ્થળ પર સ્થળાંતર",
    "Non-Traditional Relationship Pattern": "પરંપરાગત નહીં એવી સંબંધની પદ્ધતિ",
    "Education & Learning": "શિક્ષણ અને શીખવું",
    "Education Prospects": "શિક્ષણની શક્યતાઓ",
    "Strong Education Potential": "મજબૂટ શિક્ષણ ક્ષમતા",
    "Management / Professional Higher Education Potential": "મેનેજમેન્ટ / વ્યાવસાયિક ઉચ્ચ શિક્ષણ ક્ષમતા",
    "Profession Indicators": "વ્યવસાય સંકેતો",
    "Astrology / Astrologer": "જ્યોતિષશાસ્ત્ર / જ્યોતિષી",
    "Mercury": "બુધ",
    "profession modifier": "વ્યવસાય ફેરફારક",
    "Jupiter": "બૃહસ્પતિ",
    "Teacher / Educator": "શિક્ષક / શિક્ષક",
    "Higher-education support: 1,2,4,9,11": "ઉચ્ચ શિક્ષણ આધાર: 1,2,4,9,11",
    "Writer / Professional Writing": "લેખક / વ્યાવસાયિક લેખન",
    "Income Support Through Profession": "વ્યવસાય દ્વારા આવક આધાર",
    "Medical / Healthcare Profession": "ચિકિત્સા / આરોગ્ય વ્યવસાય",
    "Stronger professional quality: 5,9,11 + 6,8,12": "વધુ મજબૂત વ્યાવસાયિક ગુણ: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "વ્યાવસાયિક સફળતા આધાર: 6,8,12 + 10,11 અથવા +11 અથવા +9,11",
    "Engineer": "એન્જિનિયર",
    "Scientist": "વૈજ્ઞાનિક",
    "Research / Inventions / Deep Analysis": "અભ્યાસ / શોધ / ઊંડા વિશ્લેષણ",
    "Recognition Through Research / Innovation": "અભ્યાસ / નવીનતા દ્વારા માન્યતા",
    "Information Technology": "માહિતી ટેકનોલોજી",
    "Higher-education support: 2,4,5,9,11": "ઉચ્ચ શિક્ષણમાં સપોર્ટ: 2,4,5,9,11",
    "Lawyer / Legal Profession": "વકીલ / કાનૂની વ્યવસાય",
    "Architect": "આર્કિટેક્ટ",
    "Builder / Construction": "બિલ્ડર / બાંધકામ",
    "Property / Real-Estate Professional": "મિલકત / રિયલ એસ્ટેટ પ્રોફેશનલ",
    "Property purchase activity: 4,11,12": "મિલકત ખરીદવાની પ્રવૃત્તિ: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "મિલકત વેચવાની પ્રવૃત્તિ: 3,5,10 સાથે શનિ અને મંગલ",
    "Interior Designer / Decorator": "ઈન્ટીરિયર ડિઝાઇનર / ડૅકોરેટર",
    "Creativity / Innovation": "સર્જનાત્મકતા / નવીનતા",
    "Politics / Public Leadership": "રાજકારણ / જાહેર નેતૃત્વ",
    "Chartered Accountant": "ચાર્ટર્ડ એકાઉન્ટન્ટ",
    "Data Management / Business Management": "ડેટા મેનેજમેન્ટ / વ્યવસાય મેનેજમેન્ટ",
    "Chef / Culinary Profession": "શેફ / રસોડાકીય વ્યવસાય",
    "Benefic planet": "લાભદાયક ગ્રહ",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "બીજુ ઘરમાં લાભદાયક અથવા બીજુ ઘરમાં લાભદાયક રૂપે અસરકર્તા/પ્રભાવશાળી",
    "International / continental cuisine: +9,3,12": "આંતરરાષ્ટ્રીય / ખંડીય રસોઈ: +9,3,12",
    "Correctional / Institutional Administration": "સુધારણાત્મક / સંસ્થાકીય વહીવટ",
    "Journalist / Media Professional": "પત્રકાર / મીડિયા પ્રોફેશનલ",
    "Investigative / crime reporting: +7,8,12": "તપાસ / ગુનાના રિપોર્ટિંગ: +7,8,12",
    "Political reporting: +1,10,11": "રાજકીય રિપોર્ટિંગ: +1,10,11",
    "Sports reporting: +5,10": "ક્રીડા રિપોર્ટિંગ: +5,10",
    "Creative Writer": "સર્જનાત્મક લેખક",
    "Creativity: +5,9": "સર્જનાત્મકતા: +5,9",
    "Artistic writing: 5,11": "કલાત્મક લેખન: 5,11",
    "Mystery / occult / deep subjects: 8,12": "રહસ્ય / છુપાયેલું / ઊંડા વિષયો: 8,12",
    "Legal Matters": "કાનૂની મુદ્દાઓ",
    "Legal Dispute Indicators": "કાનૂની વિવાદ સૂચકાંકો",
    "Supportive Legal Matter Indicators": "સહાયક કાનૂની મુદ્દા સૂચકાંકો",
    "Challenging Legal Matter Indicators": "પડકારજનક કાનૂની મુદ્દા સૂચકાંકો",
    "Legal Relief Indicators": "કાનૂની રાહત સૂચકાંકો",
    "5,9 acts as a facilitator.": "5,9 એક સગવડકાર તરીકે કાર્ય કરે છે.",
    "Property & Residence": "સંપત્તિ અને નિવાસ",
    "Property Purchase Prospects": "સંપત્તિ ખરીદીની શક્યતાઓ",
    "property modifier": "સંપત્તિ સુધારક",
    "Source notes aspect, transit, conjunction and DBA involvement": "સ્ત્રોત નોંધો પાસાં, પરિવહન, જોડાણ અને ડીબીએ સામેલ છે",
    "Property Through Financing / Loan": "ફાઈનાન્સિંગ / લોન દ્વારા સંપત્તિ",
    "Loan repayment/completion support: +4,11": "લોન ચૂકવણી / પૂર્ણતા સહાય: +4,11",
    "Property Through Institutional / Personal Support": "સંસ્થાકીય / વ્યક્તિગત આધાર દ્વારા સંપત્તિ",
    "Property Through Gift / Inheritance": "ભેટ / વરાસત દ્વારા મિલકત",
    "Property Purchase in Stages": "તબક્કાઓમાં મિલકત ખરીદી",
    "Government / Institution-Allotted Property": "સરકાર / સંસ્થાના દ્વારા ફાળવેલી મિલકત",
    "Commercial Property Purchase": "વ્યાવસાયિક મિલકત ખરીદી",
    "Rental Income Potential": "ભાડુઆવકની સંભાવના",
    "Considering a Residence Change": "નિવાસ બદલાવ પર વિચાર",
    "Change of Residence": "નિવાસ બદલાવ",
    "Separative planets": "વિભાજક ગ્રહો",
    "Property Through Family / Marriage Arrangement": "પરિવાર / લગ્ન વ્યવસ્થા દ્વારા મિલકત",
    "Property Ownership / Possession Challenges": "મિલકતની માલિકી / કબ્જા સંબંધિત પડકારો",
    "Property Conflict / Government Intervention": "મિલકત સંઘર્ષ / સરકારની હસ્તક્ષેપ",
    "Property Dispute / Litigation Indicators": "મિલકત વિવાદ / કાયદેસર મુદ્દાઓના સૂચક",
    "Venus": "શુક્ર",
    "source modifier": "સ્ત્રોત સંશોધક",
    "Do not infer gender in public UI": "જાહેર UI માં લિંગ ઉપર આભાષ ન કરો",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "મર્ક્યુરી અને ડ્યુઅલ સિગ્ન સાથે, સ્ત્રોત પુનરાવર્તિત/બહુવિધ સમસ્યાઓ દર્શાવે છે",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "બૃહસ્પતિ અને ડ્યૂલ રાશિ સાથે, સ્ત્રોતનો અર્થ પુનરાવર્તિત/અનેક સમસ્યાઓ",
    "Supportive Property Dispute Indicators": "સપોર્ટિવ મિલકત વિવાદ સૂચક",
    "Challenging Property Dispute Indicators": "પડકારજનક મિલકત વિવાદ સૂચકાંકો",
    "Property Division / Partition": "ગુણધર્મ વિભાગ / પાર્ટીશન",
    "Property Sale Prospects": "પ્રોપર્ટી વેચાણની સંભાવનાઓ",
    "Favourable Property Sale Conditions": "અનુકૂળ મિલકત વેચાણની શરતો",
    "Less Supportive Property Sale Conditions": "ઓછી સહાયક મિલકત વેચાણ શરતો",
    "Vehicle": "વાહન\n[[એન 159]] વાહન સંપાદનની સંભાવનાઓ",
    "Vehicle Acquisition Prospects": "વાહન મેળવવાના સંભાવનાઓ",
    "primary vehicle significator": "પ્રાઇમરી વ્હીકલ સિગ્નિફિકેટર",
    "Vehicle Through Financing / Loan": "ફાઇનાન્સિંગ/લોન દ્વારા વાહન",
    "Vehicle Through Gift": "ગિફ્ટ દ્વારા વાહન",
    "Venus active in DBA": "ડીબીએમાં સક્રિય શુક્ર",
    "Premium / Luxury Vehicle Indicators": "પ્રીમિયમ/લક્ઝરી વ્હીકલ ઇન્ડિકેટર્સ",
    "primary factor": "પ્રાથમિક પરિબળ",
    "Natural benefic planets": "પ્રાકૃતિક શુભ ગ્રહો",
    "aspecting/supporting factor": "પાસું / સહાયક પરિબળ",
    "Pre-Owned Vehicle Indicators": "પૂર્વ-માલિકીના વાહન સૂચકાંકો",
    "aspecting factor": "પાસા પરિબળ",
    "Vehicle Maintenance Concerns": "વાહનની જાળવણીની ચિંતાઓ",
    "Commercial Vehicle Indicators": "કોમર્શિયલ વ્હીકલ ઇન્ડિકેટર્સ",
    "commercial vehicle modifier": "કોમર્શિયલ વ્હીકલ મોડિફાયર",
    "Mercury involved or aspecting": "બુધ સંડોવાયેલ અથવા પાસું",
    "small commercial vehicle modifier": "નાના વ્યાપારી વાહન સંશોધક",
    "Venus involved or aspecting": "વેનોસ સંલગ્ન અથવા પરિસ્થિતિમાં",
    "heavy commercial vehicle modifier": "ભારે વાણિજ્યિક વાહન ફેરબદલક",
    "Saturn involved or aspecting": "સેટર્ન સંલગ્ન અથવા પરિસ્થિતિમાં",
    "Vehicle Security / Possession Caution": "વાહન સુરક્ષા / માલિકીની સાવચેતી",
    "Strong Vehicle Security / Possession Caution": "મજબૂત વાહન સુરક્ષા / માલિકીની સાવચેતી",
    "Vehicle Recovery / Resolution Indicators": "વાહન પુનઃપ્રાપ્તિ / નિરાકરણ સૂચકો",
    "Vehicle Loan Repayment Challenges": "વાહન લોન ચુકવણી સમસ્યાઓ",
    "Stronger while the combination remains active in DBA": "મજબૂત જ્યારે સંયોજન DBA માં સક્રિય રહે",
    "Improvement/return after payment: 4,6,11": "ચુકવણી પછી સુધારો/પરત આવનારી સ્થિતિ: ૪, ૬, ૧૧",
    "Vehicle Sale Prospects": "વાહન વેચાણની સંભાવનાઓ",
    "Insurance Claim Indicators": "વીમા દાવા સૂચકો",
    "Travel, Visa & Foreign Matters": "યાત્રા, વીઝા અને વિદેશી મામલાઓ",
    "Travel Prospects": "યાત્રા સંભાવનાઓ",
    "travel modifier": "યાત્રા ફેરબદલક",
    "Short-Distance Travel": "ટૂંકા અંતરની યાત્રા",
    "Long-Distance Travel": "લાંબી અંતરની યાત્રા",
    "Change in Travel Plans / Route": "યાત્રા યોજનાઓ / રૂટમાં બદલાવ",
    "Separative planet": "અલગ પાડનારો ગ્રહ",
    "International Travel Requiring Greater Adjustment": "આંતરરાષ્ટ્રીય યાત્રા જેમાં વધુ સમાયોજન જરૂરી છે",
    "Malefic planets": "દુષ્ટ ગ્રહો",
    "Supportive International Travel": "સહાયક આંતરરાષ્ટ્રીય મુસાફરી",
    "Benefic planets": "લાભદાયક ગ્રહો",
    "Return Home / Homecoming": "ઘરે પરત ફરવું / ઘરે આવવું",
    "Visa Prospects": "વિઝા સંભાવનાઓ",
    "Tourist Visa Prospects": "પ્રવાસન વિઝા સંભાવનાઓ",
    "Study Visa Prospects": "શૈક્ષણિક વિઝા સંભાવનાઓ",
    "Business Visa Prospects": "વ્યાવસાયિક વિઝા સંભાવનાઓ",
    "Import/export business: +2,7,10,11": "આયાત/અમદની બિઝનેસ: +2,7,10,11",
    "Work Visa Prospects": "કામ વિઝા સંભાવનાઓ",
    "Partner Abroad Indicators": "વિદેશી ભાગીદાર સૂચકો",
    "Marriage Abroad Prospects": "વિદેશમાં લગ્નની સંભાવનાઓ",
    "Professional / Conference Travel": "વ્યાવસાયિક / સંમેલન પ્રવાસ",
    "Sports-Related Travel": "ક્રીડા સંબંધિત મુસાફરી",
    "Family & Life Development": "કુટુંબ અને જીવન વિકાસ",
    "Family Expansion Prospects": "કુટુંબ વિસ્તરણ સંભાવનાઓ"
  },
  "bn": {
    "Event Analysis": "ইভেন্ট বিশ্লেষণ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "এর প্রচলিত নাড়ি হাউস গ্রুপ এবং সংশ্লিষ্ট গ্রহ দেখতে একটি বিভাগ এবং ইভেন্ট নির্বাচন করুন।",
    "Category": "বিভাগ",
    "Event": "ইভেন্ট",
    "Locked": "লক করা হয়েছে",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "সব বিভাগ এবং ইভেন্ট দৃশ্যমান। লক করা ইভেন্ট বিশ্লেষণ অপশন আনলক করতে প্রিমিয়ামে আপগ্রেড করুন।",
    "Supportive indication": "সহায়ক সূচক",
    "Challenging indication": "চ্যালেঞ্জিং সূচক",
    "Neutral indication": "নিরপেক্ষ সূচক",
    "Event groups": "ইভেন্ট গ্রুপ",
    "Good": "ভাল",
    "Bad": "খারাপ",
    "Supportive": "সহায়ক",
    "Challenging supportive": "চ্যালেঞ্জিং সহায়ক",
    "Planets involved": "সংশ্লিষ্ট গ্রহ",
    "involved": "সংশ্লিষ্ট",
    "Pro": "পেশাদার",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "এই ব্যাখ্যাগুলো ঐতিহ্যবাহী জ্যোতিষশাস্ত্রের ভিত্তিতে প্রস্তুত করা হয়েছে এবং তথ্য ও শিক্ষামূলক উদ্দেশ্যে দেওয়া হয়েছে। এগুলো প্রবণতা এবং সম্ভাবনাগুলি নির্দেশ করে, নিশ্চয়তা দেওয়া ফলাফল নয়। আইনি, অর্থনৈতিক, চিকিৎসা বা অন্যান্য পেশাদার ক্ষেত্রে, যথাযথ যোগ্য পেশাদারের সঙ্গে পরামর্শ করুন।",
    "Career, Work & Business": "কর্মজীবন, কাজ ও ব্যবসা",
    "Employment Prospects": "চাকরির সম্ভাবনা",
    "Business Prospects": "ব্যবসার সম্ভাবনা",
    "Earning Potential": "আয়ের সম্ভাবনা",
    "Business Challenges": "ব্যবসায়িক চ্যালেঞ্জ",
    "Business Recovery Indicators": "ব্যবসার পুনরুদ্ধার সূচক",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 ব্যবসায়িক সমস্যার পর পুনরুদ্ধার/সমর্থন হিসেবে কাজ করে।",
    "Administration Career": "প্রশাসনিক কাজের ক্যারিয়ার",
    "Employment Challenges": "চাকরির চ্যালেঞ্জ",
    "Professional Obstacles / Delays": "পেশাগত বাধা / বিলম্ব",
    "Professional Recognition Challenges": "পেশাগত স্বীকৃতির চ্যালেঞ্জ",
    "Financial Pressure": "আর্থিক চাপ",
    "Financial Return Cycle": "আর্থিক রিটার্ন চক্র",
    "Supportive Career Change": "সহায়ক ক্যারিয়ার পরিবর্তন",
    "Favourable Career Transition": "অনুকূল ক্যারিয়ার রূপান্তর",
    "Next DBA": "পরবর্তী ডিবিএ",
    "Challenging Career Transition": "চ্যালেঞ্জিং ক্যারিয়ার রূপান্তর",
    "Workplace Transfer / Relocation": "কর্মক্ষেত্র স্থানান্তর / স্থানান্তর",
    "Return to Previous Workplace / Location": "পূর্ববর্তী কর্মক্ষেত্র / অবস্থানে ফিরে যান",
    "Personality & Temperament": "ব্যক্তিত্ব ও মেজাজ",
    "Assertive / Intense Temperament": "দৃঢ় / তীব্র মেজাজ",
    "Mars": "মঙ্গল",
    "modifier": "মডিফায়ার",
    "Mars connected with the 1st or 3rd house": "মঙ্গল 1 ম বা 3 য় ঘরের সাথে সংযুক্ত",
    "Emotional Sensitivity": "মানসিক সংবেদনশীলতা",
    "Moon": "চাঁদ",
    "Moon influence; source also notes Cancer connected with the 1st house": "চাঁদের প্রভাব; সূত্র আরও উল্লেখ করেছে যে ক্যান্সার 1 ম বাড়ির সাথে সংযুক্ত",
    "Affectionate & Relationship-Oriented Nature": "স্নেহময় এবং সম্পর্ক-ভিত্তিক প্রকৃতি",
    "Warm & Supportive Nature": "উষ্ণ ও সহায়ক প্রকৃতি",
    "Independent / Detached Tendencies": "স্বাধীন / বিচ্ছিন্ন প্রবণতা",
    "Rahu": "রাহু",
    "associated planet": "সম্পর্কিত গ্রহ",
    "Ketu": "কেতু",
    "Saturn": "শনি",
    "Sun": "সূর্য",
    "Reserved / Practical Nature": "সংরক্ষিত / ব্যবহারিক প্রকৃতি",
    "Persistent / Determined Nature": "অবিরাম / নির্ধারিত প্রকৃতি",
    "Relationships & Marriage": "সম্পর্ক ও বিবাহ",
    "Relationship Boundary Challenges": "সম্পর্কের সীমানা চ্যালেঞ্জ",
    "Supportive Relationship Bond": "সমর্থনমূলক সম্পর্কের বন্ধন",
    "Private / Complex Relationship Phase": "ব্যক্তিগত / জটিল সম্পর্কের পর্যায়",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "উৎস এছাড়াও 5,9,11; 5,11; এবং 5,8,11 কে পরিষ্কার/সমর্থনমূলক সম্পর্কের ভ্যারিয়েন্ট হিসাবে তালিকাভুক্ত করেছে।",
    "Relationship Conflict / Reactive Dynamics": "সম্পর্কের সংঘর্ষ / প্রতিক্রিয়াশীল গতিবিদ্যা",
    "Marriage Prospects": "বিবাহের সম্ভাবনা",
    "Marriage Through Known Circle": "পরিচিত বৃত্তের মাধ্যমে বিবাহ",
    "Supportive Marriage Circumstances": "সমর্থনমূলক বিবাহের পরিস্থিতি",
    "Marriage Delay Indicators": "বিবাহ বিলম্বের সূচক",
    "In DBA": "ডিবিএ-তে",
    "Emotional Distance in Relationship": "সম্পর্কের মধ্যে মানসিক দূরত্ব",
    "Reconciliation Indicators": "পুনর্মিলনের সূচক",
    "Use with the preceding relationship/separation combination.": "এর আগে উল্লেখিত সম্পর্ক/বিচ্ছেদের সংমিশ্রণ সঙ্গে ব্যবহার করুন।",
    "Marital Transition / Separation Indicators": "বৈবাহিক পরিবর্তন / বিচ্ছেদের সূচক",
    "Reduced Support for Marriage": "বিবাহের জন্য সমর্থনের হ্রাস",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "যখন 1,6,10 একাধিক প্রাসঙ্গিক গ্রহ/প্রতীক দ্বারা পুনরাবৃত্তি হয় তখন এটি শক্তিশালী হয়।",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "যখন 7ম কাস্প লর্ডও 1,6,10 নির্দেশ করে তখন এটি শক্তিশালী হয়।",
    "Relocation After Marriage": "বিবাহের পরে পুনঃঅবস্থান",
    "Relocation to a Distant / Unfamiliar Place": "দূরবর্তী / অপরিচিত স্থানে স্থানান্তর",
    "Non-Traditional Relationship Pattern": "অসাংপ্রদায়িক সম্পর্কের ধরন",
    "Education & Learning": "শিক্ষা ও শেখা",
    "Education Prospects": "শিক্ষার সম্ভাবনা",
    "Strong Education Potential": "শক্তিশালী শিক্ষাগত সম্ভাবনা",
    "Management / Professional Higher Education Potential": "ব্যবস্থাপনা / পেশাদার উচ্চশিক্ষার সম্ভাবনা",
    "Profession Indicators": "পেশা সংক্রান্ত সূচক",
    "Astrology / Astrologer": "জ্যোতিষশাস্ত্র / জ্যোতিষী",
    "Mercury": "বুধ",
    "profession modifier": "পেশা সংশোধনকারী",
    "Jupiter": "বৃহস্পতি",
    "Teacher / Educator": "শিক্ষক / শিক্ষাবিদ",
    "Higher-education support: 1,2,4,9,11": "উচ্চশিক্ষা সহায়তা: 1,2,4,9,11",
    "Writer / Professional Writing": "লেখক / পেশাদার লেখা",
    "Income Support Through Profession": "পেশার মাধ্যমে আয় সহায়তা",
    "Medical / Healthcare Profession": "চিকিৎসা / স্বাস্থ্যসেবা পেশা",
    "Stronger professional quality: 5,9,11 + 6,8,12": "শক্তিশালী পেশাগত গুণাবলি: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "পেশাগত সাফল্যের সহায়তা: 6,8,12 + 10,11 অথবা +11 অথবা +9,11",
    "Engineer": "ইঞ্জিনিয়ার",
    "Scientist": "বিজ্ঞানী",
    "Research / Inventions / Deep Analysis": "গবেষণা / আবিষ্কার / গভীর বিশ্লেষণ",
    "Recognition Through Research / Innovation": "গবেষণা / উদ্ভাবনের মাধ্যমে স্বীকৃতি",
    "Information Technology": "তথ্যপ্রযুক্তি",
    "Higher-education support: 2,4,5,9,11": "উচ্চশিক্ষা সহায়তা: ২,৪,৫,৯,১১",
    "Lawyer / Legal Profession": "আইনজীবী / আইন পেশা",
    "Architect": "স্থপতি",
    "Builder / Construction": "নির্মাতা / নির্মাণ",
    "Property / Real-Estate Professional": "সম্পত্তি / রিয়েল-এস্টেট পেশাদার",
    "Property purchase activity: 4,11,12": "সম্পত্তি ক্রয় কার্যক্রম: ৪,১১,১২",
    "Property sale activity: 3,5,10 with Saturn and Mars": "সম্পত্তি বিক্রয় কার্যক্রম: ৩,৫,১০ শনির এবং মঙ্গলের সাথে",
    "Interior Designer / Decorator": "ইন্টেরিয়র ডিজাইনার / সজ্জাকার",
    "Creativity / Innovation": "সৃজনশীলতা / উদ্ভাবন",
    "Politics / Public Leadership": "রাজনীতি / জনপরিচালনা",
    "Chartered Accountant": "চার্টার্ড অ্যাকাউন্ট্যান্ট",
    "Data Management / Business Management": "তথ্য ব্যবস্থাপনা / ব্যবসা পরিচালনা",
    "Chef / Culinary Profession": "শেফ / রন্ধনসম্পর্কিত পেশা",
    "Benefic planet": "কল্যাণময় গ্রহ",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "দ্বিতীয় ঘরে কল্যাণময় বা দ্বিতীয় ঘরকে কল্যাণভাবে প্রভাবিত/প্রভাবিতকারী",
    "International / continental cuisine: +9,3,12": "আন্তর্জাতিক / মহাদেশীয় রান্না: +৯,৩,১২",
    "Correctional / Institutional Administration": "সংশোধনমূলক / প্রাতিষ্ঠানিক প্রশাসন",
    "Journalist / Media Professional": "সাংবাদিক / মিডিয়া পেশাদার",
    "Investigative / crime reporting: +7,8,12": "তদন্তমূলক / অপরাধ প্রতিবেদন: +7,8,12",
    "Political reporting: +1,10,11": "রাজনৈতিক প্রতিবেদন: +1,10,11",
    "Sports reporting: +5,10": "ক্রীড়া প্রতিবেদন: +5,10",
    "Creative Writer": "সৃজনশীল লেখক",
    "Creativity: +5,9": "সৃজনশীলতা: +5,9",
    "Artistic writing: 5,11": "শিল্পমুখী লেখা: 5,11",
    "Mystery / occult / deep subjects: 8,12": "রহস্য / ocult / গভীর বিষয়: 8,12",
    "Legal Matters": "আইনগত বিষয়",
    "Legal Dispute Indicators": "আইনি বিবাদ সূচক",
    "Supportive Legal Matter Indicators": "সহায়ক আইনি বিষয় সূচক",
    "Challenging Legal Matter Indicators": "চ্যালেঞ্জিং আইনি বিষয় সূচক",
    "Legal Relief Indicators": "আইনি সহায়তা সূচক",
    "5,9 acts as a facilitator.": "5,9 একজন সুপারভাইজার হিসেবে কাজ করে।",
    "Property & Residence": "সম্পদ ও আবাসন",
    "Property Purchase Prospects": "সম্পদ ক্রয় সম্ভাবনা",
    "property modifier": "সম্পদ সংশোধক",
    "Source notes aspect, transit, conjunction and DBA involvement": "উৎস নোট দিক, সংযোগ, সংঘাত এবং DBA জড়িততা",
    "Property Through Financing / Loan": "ফাইন্যান্সিং / ঋণের মাধ্যমে সম্পদ",
    "Loan repayment/completion support: +4,11": "ঋণ পরিশোধ / সমাপ্তি সমর্থন: +4,11",
    "Property Through Institutional / Personal Support": "প্রতিষ্ঠানিক / ব্যক্তিগত সহায়তার মাধ্যমে সম্পদ",
    "Property Through Gift / Inheritance": "উপহার / উত্তরাধিকার মাধ্যমে সম্পত্তি",
    "Property Purchase in Stages": "ধাপে ধাপে সম্পত্তি ক্রয়",
    "Government / Institution-Allotted Property": "সরকার / প্রতিষ্ঠানের বরাদ্দকৃত সম্পত্তি",
    "Commercial Property Purchase": "বাণিজ্যিক সম্পত্তি ক্রয়",
    "Rental Income Potential": "ভাড়ার আয়ের সম্ভাবনা",
    "Considering a Residence Change": "বাসস্থান পরিবর্তনের বিবেচনা",
    "Change of Residence": "বাসস্থান পরিবর্তন",
    "Separative planets": "পৃথককারী গ্রহ",
    "Property Through Family / Marriage Arrangement": "পরিবার / বিবাহের ব্যবস্থার মাধ্যমে সম্পত্তি",
    "Property Ownership / Possession Challenges": "সম্পত্তির মালিকানা / অধিকার সংক্রান্ত চ্যালেঞ্জ",
    "Property Conflict / Government Intervention": "সম্পত্তি সংঘাত / সরকারি হস্তক্ষেপ",
    "Property Dispute / Litigation Indicators": "সম্পত্তি বিবাদ / মামলার সূচক",
    "Venus": "শুক্র",
    "source modifier": "উৎস পরিবর্তক",
    "Do not infer gender in public UI": "পাবলিক UI-তে লিঙ্গ অনুমান করবেন না",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "বুধ এবং একটি দ্বৈত চিহ্ন সহ, উৎস নির্দেশ করে পুনরাবৃত্ত/একাধিক সমস্যা",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "বৃহস্পতি এবং একটি দ্বৈত চিহ্ন সহ, উৎস নির্দেশ করে পুনরাবৃত্ত/একাধিক সমস্যা",
    "Supportive Property Dispute Indicators": "সহায়ক সম্পত্তি বিবাদ সূচক",
    "Challenging Property Dispute Indicators": "চ্যালেঞ্জিং সম্পত্তি বিরোধ সূচক",
    "Property Division / Partition": "সম্পত্তি বিভাগ / বিভাজন",
    "Property Sale Prospects": "সম্পত্তি বিক্রয় সম্ভাবনা",
    "Favourable Property Sale Conditions": "অনুকূল সম্পত্তি বিক্রয় শর্তাবলী",
    "Less Supportive Property Sale Conditions": "কম সহায়ক সম্পত্তি বিক্রয় শর্তাবলী",
    "Vehicle": "গাড়ি",
    "Vehicle Acquisition Prospects": "যানবাহন অধিগ্রহণের সম্ভাবনা",
    "primary vehicle significator": "প্রাথমিক যানবাহন সিগনিফিকেটর",
    "Vehicle Through Financing / Loan": "অর্থায়ন / ঋণের মাধ্যমে যানবাহন",
    "Vehicle Through Gift": "উপহারের মাধ্যমে যানবাহন",
    "Venus active in DBA": "শুক্র ডিবিএ-তে সক্রিয়",
    "Premium / Luxury Vehicle Indicators": "প্রিমিয়াম/বিলাসবহুল গাড়ির সূচক",
    "primary factor": "প্রাথমিক ফ্যাক্টর",
    "Natural benefic planets": "প্রাকৃতিক উপকারী গ্রহ",
    "aspecting/supporting factor": "দৃষ্টিকোণ / সহায়ক ফ্যাক্টর",
    "Pre-Owned Vehicle Indicators": "প্রাক-মালিকানাধীন যানবাহন সূচক",
    "aspecting factor": "অ্যাসপেক্টিং ফ্যাক্টর",
    "Vehicle Maintenance Concerns": "যানবাহন রক্ষণাবেক্ষণের উদ্বেগ",
    "Commercial Vehicle Indicators": "বাণিজ্যিক যানবাহন সূচক",
    "commercial vehicle modifier": "বাণিজ্যিক যানবাহন সংশোধনকারী",
    "Mercury involved or aspecting": "বুধ জড়িত বা দৃষ্টিকোণ",
    "small commercial vehicle modifier": "ছোট বাণিজ্যিক যানবাহন সংশোধনকারী",
    "Venus involved or aspecting": "শুক্রগ্রহ জড়িত বা প্রভাবিত",
    "heavy commercial vehicle modifier": "ভারী বাণিজ্যিক যানবাহন সংশোধক",
    "Saturn involved or aspecting": "শনিগ্রহ জড়িত বা প্রভাবিত",
    "Vehicle Security / Possession Caution": "যানবাহন নিরাপত্তা / মালিকানার সতর্কতা",
    "Strong Vehicle Security / Possession Caution": "শক্তিশালী যানবাহন নিরাপত্তা / মালিকানার সতর্কতা",
    "Vehicle Recovery / Resolution Indicators": "যানবাহন পুনরুদ্ধার / সমাধান সূচক",
    "Vehicle Loan Repayment Challenges": "যানবাহন ঋণ পরিশোধ চ্যালেঞ্জ",
    "Stronger while the combination remains active in DBA": "DBA-তে সংমিশ্রণ সক্রিয় থাকাকালীন আরও শক্তিশালী",
    "Improvement/return after payment: 4,6,11": "পরিশোধের পরে উন্নতি / প্রত্যাবর্তন: ৪,৬,১১",
    "Vehicle Sale Prospects": "যানবাহন বিক্রয়ের সম্ভাবনা",
    "Insurance Claim Indicators": "বীমা দাবির সূচক",
    "Travel, Visa & Foreign Matters": "ভ্রমণ, ভিসা ও বিদেশী বিষয়",
    "Travel Prospects": "ভ্রমণের সম্ভাবনা",
    "travel modifier": "ভ্রমণ সংশোধক",
    "Short-Distance Travel": "স্বল্প দূরত্ব ভ্রমণ",
    "Long-Distance Travel": "দীর্ঘ দূরত্ব ভ্রমণ",
    "Change in Travel Plans / Route": "ভ্রমণ পরিকল্পনা / রুটে পরিবর্তন",
    "Separative planet": "বিচ্ছিন্নকারী গ্রহ",
    "International Travel Requiring Greater Adjustment": "বড় সমন্বয় প্রয়োজন এমন আন্তর্জাতিক ভ্রমণ",
    "Malefic planets": "দোষগ্রস্ত গ্রহ",
    "Supportive International Travel": "সহায়ক আন্তর্জাতিক ভ্রমণ",
    "Benefic planets": "শুভ গ্রহসমূহ",
    "Return Home / Homecoming": "বাড়ি ফেরা / স্বদেশ প্রত্যাবর্তন",
    "Visa Prospects": "ভিসার সম্ভাবনা",
    "Tourist Visa Prospects": "পর্যটন ভিসার সম্ভাবনা",
    "Study Visa Prospects": "শিক্ষার্থী ভিসার সম্ভাবনা",
    "Business Visa Prospects": "ব্যবসায়িক ভিসার সম্ভাবনা",
    "Import/export business: +2,7,10,11": "আমদানি/রফতানি ব্যবসা: +2,7,10,11",
    "Work Visa Prospects": "কাজের ভিসার সম্ভাবনা",
    "Partner Abroad Indicators": "বিদেশে অংশীদার সূচক",
    "Marriage Abroad Prospects": "বিদেশে বিবাহের সম্ভাবনা",
    "Professional / Conference Travel": "পেশাদার / সম্মেলন ভ্রমণ",
    "Sports-Related Travel": "ক্রীড়া সম্পর্কিত ভ্রমণ",
    "Family & Life Development": "পরিবার ও জীবন বিকাশ",
    "Family Expansion Prospects": "পরিবার সম্প্রসারণের সম্ভাবনা"
  },
  "kn": {
    "Event Analysis": "ಘಟನೆ ವಿಶ್ಲೇಷಣೆ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "ಅದರ ಪ್ರಚಲಿತ ನಾಡಿ ಮನೆ ಗುಂಪುಗಳು ಮತ್ತು ಭಾಗವಹಿಸುವ ಗ್ರಹಗಳನ್ನು ವೀಕ್ಷಿಸಲು ವರ್ಗ ಮತ್ತು ಘಟನೆ ಆಯ್ಕೆಮಾಡಿ.",
    "Category": "ವರ್ಗ",
    "Event": "ಘಟನೆ",
    "Locked": "ಲಾಕ್ ಮಾಡಲಾಗಿದೆ",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "ಎಲ್ಲಾ ವರ್ಗಗಳು ಮತ್ತು ಘಟನೆಗಳಿವೆ. ಲಾಕ್ ಮಾಡಲಾದ ಘಟನೆ ವಿಶ್ಲೇಷಣೆ ಆಯ್ಕೆಗಳನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಲು ಪ್ರೀಮಿಯಂಗೆ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿ.",
    "Supportive indication": "ಬೆಂಬಲ ಸೂಚನೆ",
    "Challenging indication": "ಸವಾಲು ಸೂಚನೆ",
    "Neutral indication": "ತಟಸ್ಥ ಸೂಚನೆ",
    "Event groups": "ಘಟನೆ ಗುಂಪುಗಳು",
    "Good": "ಉತ್ತಮ",
    "Bad": "ಕೆಟ್ಟದು",
    "Supportive": "ಬೆಂಬಲಕ",
    "Challenging supportive": "ಸವಾಲು ಬೆಂಬಲಕ",
    "Planets involved": "ಭಾಗವಹಿಸಿರುವ ಗ್ರಹಗಳು",
    "involved": "ಭಾಗವಹಿಸಿರುವ",
    "Pro": "ಪ್ರೊ",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "ಈ ವ್ಯಾಖ್ಯಾನಗಳು ಸಾಂಪ್ರದಾಯಿಕ ಜ್ಯೋತಿಷ್ಯ ತತ್ವಗಳನ್ನು ಆಧರಿಸಿವೆ ಮತ್ತು ಮಾಹಿತಿ ಹಾಗೂ ಶೈಕ್ಷಣಿಕ ಉದ್ದೇಶಗಳಿಗೆ ಮಾತ್ರ. ಇವು ಪ್ರವೃತ್ತಿಗಳು ಮತ್ತು ಸಾಧ್ಯತೆಗಳನ್ನು ಸೂಚಿಸುತ್ತವೆ; ಖಚಿತ ಫಲಿತಾಂಶಗಳನ್ನು ಅಲ್ಲ. ಕಾನೂನು, ಹಣಕಾಸು, ವೈದ್ಯಕೀಯ ಅಥವಾ ಇತರ ವೃತ್ತಿಪರ ವಿಷಯಗಳಿಗೆ ಸೂಕ್ತ ಅರ್ಹತೆ ಹೊಂದಿರುವ ವೃತ್ತಿಪರರನ್ನು ಸಂಪರ್ಕಿಸಿ.",
    "Career, Work & Business": "ವೃತ್ತಿ, ಕೆಲಸ & ಉದ್ಯಮ",
    "Employment Prospects": "ಉದ್ಯೋಗದ ಸಾಧ್ಯತೆಗಳು",
    "Business Prospects": "ವ್ಯವಹಾರ ಭವಿಷ್ಯಾಕಾಂಕ್ಷೆಗಳು",
    "Earning Potential": "ಸಂಪಾದನೆ ಸಾಮರ್ಥ್ಯ",
    "Business Challenges": "ವ್ಯವಹಾರ ಸವಾಲುಗಳು",
    "Business Recovery Indicators": "ವ್ಯವಹಾರ ಪುನಃಸ್ಥಾಪನಾ ಸೂಚಕರು",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 ಕಾರ್ಯಗಳು ವ್ಯವಹಾರದ ಕಷ್ಟದ ನಂತರ ಪುನಃಸ್ಥಾಪನ/ಪುನಃಪ್ರಾಪ್ತಿಗೆ ಬೆಂಬಲ ನೀಡುತ್ತವೆ.",
    "Administration Career": "ಆಡಳಿತ ವೃತ್ತಿ",
    "Employment Challenges": "ಉದ್ಯೋಗ ಸವಾಲುಗಳು",
    "Professional Obstacles / Delays": "ವೃತ್ತಿಪರ ಅಡ್ಡಿ / ವಿಳಂಬಗಳು",
    "Professional Recognition Challenges": "ವೃತ್ತಿಪರ ಗುರುತಿನ ಸವಾಲುಗಳು",
    "Financial Pressure": "ಹಣಕಾಸಿನ ಒತ್ತಡ",
    "Financial Return Cycle": "ಹಣಕಾಸಿನ ಫಲಪ್ರದ ಚಕ್ರ",
    "Supportive Career Change": "ಬೆಂಬಲಿಸುವ ವೃತ್ತಿ ಬದಲಾವಣೆ",
    "Favourable Career Transition": "ಅನುಕೂಲಕರ ವೃತ್ತಿ ಪರಿವರ್ತನೆ",
    "Next DBA": "ಮುಂದಿನ DBA",
    "Challenging Career Transition": "ಸವಾಲಿನ ವೃತ್ತಿ ಪರಿವರ್ತನೆ",
    "Workplace Transfer / Relocation": "ಕೆಲಸದ ಸ್ಥಳಾಂತರ / ಸ್ಥಳಾಂತರ",
    "Return to Previous Workplace / Location": "ಹಿಂದಿನ ವ್ಯಾವಸಾಯಕ್ಕೆ / ಸ್ಥಳಕ್ಕೆ ಮರಳುವುದು",
    "Personality & Temperament": "ವ್ಯಕ್ತಿತ್ವ ಮತ್ತು ಗುಣಭಾವ",
    "Assertive / Intense Temperament": "ದೃಢ / ತೀವ್ರ ಗುಣಭಾವ",
    "Mars": "ಮಂಗಳ",
    "modifier": "ಪರಿಷ್ಕಾರಕ",
    "Mars connected with the 1st or 3rd house": "ಮಂಗಳ 1ನೇ ಅಥವಾ 3ನೇ ಮನೆಯನ್ನು ಸಂಪರ್ಕಿಸಿದಾಗ",
    "Emotional Sensitivity": "ಭಾವನಾತ್ಮಕ ಸಂವೇದನೆ",
    "Moon": "ಚಂದ್ರ",
    "Moon influence; source also notes Cancer connected with the 1st house": "ಚಂದ್ರ ಪರಿಣಾಮ; ಮೂಲವು 1ನೇ ಮನೆಯೊಂದಿಗೆ ಕರ್ಸರ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿರುವುದಾಗಿ ಸಹ ದಾಖಲಿಸಿದೆ",
    "Affectionate & Relationship-Oriented Nature": "sneak ಮಾಯವಾದ ಮತ್ತು ಸಂಬಂಧ-ಕೇಂದ್ರೀಕೃತ ಸ್ವಭಾವ",
    "Warm & Supportive Nature": "ಉಷ್ಣ ಮತ್ತು ಬೆಂಬಲಾತ್ಮಕ ಸ್ವಭಾವ",
    "Independent / Detached Tendencies": "ಸ್ವತಂತ್ರ / ತದ್ವಾರಿತ ಪ್ರವೃತ್ತಿಗಳು",
    "Rahu": "ರಾಹು",
    "associated planet": "ಸಂಬಂಧಿಸಿದ ಗ್ರಹ",
    "Ketu": "kēತು",
    "Saturn": "ಶನಿ",
    "Sun": "ಸೂರ್ಯ",
    "Reserved / Practical Nature": "ನಿಧಾನಮಯ / ಪ್ರಾಯೋಗಿಕ ಸ್ವಭಾವ",
    "Persistent / Determined Nature": "ಸ್ಥಿರ / ನಿರ್ಧಾರವಾದ ಸ್ವಭಾವ",
    "Relationships & Marriage": "ಸಂಬಂಧಗಳು ಮತ್ತು ಮದುವೆ",
    "Relationship Boundary Challenges": "ಸಂಬಂಧಗಳ ಗಡಿ ಸವಾಲುಗಳು",
    "Supportive Relationship Bond": "ಬೆಂಬಲಿತ ಸಂಬಂಧ ಬಂಧ",
    "Private / Complex Relationship Phase": "ಖಾಸಗಿ / ಸಂಕೀರ್ಣ ಸಂಬಂಧದ ಹಂತ",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "ಮೂಲವು 5,9,11 ಅನ್ನು ಪಟ್ಟಿ ಮಾಡುತ್ತದೆ; 5,11; ಮತ್ತು 5,8,11 ಕ್ಲೀನರ್ / ಬೆಂಬಲಿತ ಸಂಬಂಧದ ರೂಪಾಂತರಗಳಾಗಿ.",
    "Relationship Conflict / Reactive Dynamics": "ಸಂಬಂಧ ಸಂಘರ್ಷ / ಪ್ರತಿಕ್ರಿಯಾತ್ಮಕ ಡೈನಾಮಿಕ್ಸ್",
    "Marriage Prospects": "ಮದುವೆಯ ನಿರೀಕ್ಷೆಗಳು",
    "Marriage Through Known Circle": "ತಿಳಿದಿರುವ ವಲಯದ ಮೂಲಕ ಮದುವೆ",
    "Supportive Marriage Circumstances": "ಬೆಂಬಲಿತ ವಿವಾಹ ಸಂದರ್ಭಗಳು",
    "Marriage Delay Indicators": "ಮದುವೆ ವಿಳಂಬ ಸೂಚಕಗಳು",
    "In DBA": "ಡಿಬಿಎಯಲ್ಲಿ",
    "Emotional Distance in Relationship": "ಸಂಬಂಧದಲ್ಲಿ ಭಾವನಾತ್ಮಕ ಅಂತರ",
    "Reconciliation Indicators": "ಸಾಮರಸ್ಯ ಸೂಚಕಗಳು",
    "Use with the preceding relationship/separation combination.": "ಹಿಂದಿನ ಸಂಬಂಧ / ಪ್ರತ್ಯೇಕತೆಯ ಸಂಯೋಜನೆಯೊಂದಿಗೆ ಬಳಸಿ.",
    "Marital Transition / Separation Indicators": "ವೈವಾಹಿಕ ಪರಿವರ್ತನೆ / ಪ್ರತ್ಯೇಕತೆಯ ಸೂಚಕಗಳು",
    "Reduced Support for Marriage": "ಮದುವೆಗೆ ಬೆಂಬಲ ಕಡಿಮೆಯಾಗಿದೆ",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "1,6,10 ಅನ್ನು ಅನೇಕ ಸಂಬಂಧಿತ ಗ್ರಹಗಳು / ಸಂಕೇತಗಳ ಮೂಲಕ ಪುನರಾವರ್ತಿಸಿದಾಗ ಬಲಗೊಳ್ಳುತ್ತದೆ.",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "7 ನೇ ಕಸ್ಪ್ ಲಾರ್ಡ್ ಸಹ 1,6,10 ಅನ್ನು ಸೂಚಿಸಿದಾಗ ಬಲಗೊಳ್ಳುತ್ತದೆ.",
    "Relocation After Marriage": "ಮದುವೆಯ ನಂತರ ಸ್ಥಳಾಂತರ",
    "Relocation to a Distant / Unfamiliar Place": "ದೂರದ / ಪರಿಚಯವಿಲ್ಲದ ಸ್ಥಳಕ್ಕೆ ಸ್ಥಳಾಂತರ",
    "Non-Traditional Relationship Pattern": "ಪರಂಪರೆಯಲ್ಲದ ಸಂಬಂಧ ಮಾದರಿ",
    "Education & Learning": "ಶಿಕ್ಷಣ ಮತ್ತು ಕಲಿಕೆಯನ್ನು",
    "Education Prospects": "ಶಿಕ್ಷಣದ ಅವಕಾಶಗಳು",
    "Strong Education Potential": "ಬಲವಾದ ಶಿಕ್ಷಣ ಸಾಮರ್ಥ್ಯ",
    "Management / Professional Higher Education Potential": "ನಿರ್ವಹಣೆ / ವೃತ್ತಿಪರ ಉನ್ನತ ಶಿಕ್ಷಣ ಸಾಮರ್ಥ್ಯ",
    "Profession Indicators": "ವೃತ್ತಿ ಸೂಚಕಗಳು",
    "Astrology / Astrologer": "ಜ್ಯೋತಿಷ್ಯಶಾಸ್ತ್ರ / ಜ್ಯೋತಿಷ್ಯನು",
    "Mercury": "ಬುಧ",
    "profession modifier": "ವೃತ್ತಿ ಪರಿವರ್ತಕ",
    "Jupiter": "ಗುರು",
    "Teacher / Educator": "ಶಿಕ್ಷಕ / ಶಿಕ್ಷಣಕ",
    "Higher-education support: 1,2,4,9,11": "ಉನ್ನತ ಶಿಕ್ಷಣ ಬೆಂಬಲ: 1,2,4,9,11",
    "Writer / Professional Writing": "ಲೇಖಕ / ವೃತ್ತಿಪರ ಬರವಣಿಗೆ",
    "Income Support Through Profession": "ವೃತ್ತಿಯಿಂದ ಆದಾಯ ಬೆಂಬಲ",
    "Medical / Healthcare Profession": "ವೈದ್ಯಕೀಯ / ಆರೋಗ್ಯ ಸೇವಾ ವೃತ್ತಿ",
    "Stronger professional quality: 5,9,11 + 6,8,12": "ಬಲವಾದ ವೃತ್ತಿಪರ ಗುಣ: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "ವೃತ್ತಿಪರ ಯಶಸ್ಸಿನ ಬೆಂಬಲ: 6,8,12 + 10,11 ಅಥವಾ +11 ಅಥವಾ +9,11",
    "Engineer": "ಇಂಜಿನಿಯರ್",
    "Scientist": "ವಿಜ್ಞಾನಿ",
    "Research / Inventions / Deep Analysis": "ಸಂಶೋಧನೆ / ಆವಿಷ್ಕಾರಗಳು / ಆಳವಾದ ವಿಶ್ಲೇಷಣೆ",
    "Recognition Through Research / Innovation": "ಸಂದರ್ಶನ / ನವೋದ್ಯಮದ ಮೂಲಕ ಗುರುತಿಸಿಕೊಂಡಿದ್ದು",
    "Information Technology": "ಮಾಹಿತಿ ತಂತ್ರಜ್ಞಾನ",
    "Higher-education support: 2,4,5,9,11": "ಉನ್ನತ ಶಿಕ್ಷಣ ಬೆಂಬಲ: 2,4,5,9,11",
    "Lawyer / Legal Profession": "ವಕೀಲ / ಕಾನೂನು ವೃತ್ತಿ",
    "Architect": "ವಾಸ್ತುಶಿಲ್ಪಿ",
    "Builder / Construction": "ನಿರ್ಮಾಪಕ / ನಿರ್ಮಾಣ",
    "Property / Real-Estate Professional": "ವ್ಯಾವಸಾಯಿಕ / ರಿಯಲ್ ಎಸ್ಟೇಟ್ ವೃತ್ತಿಪರ",
    "Property purchase activity: 4,11,12": "ಆಸ್ತಿ ಖರೀದಿ ಚಟುವಟಿಕೆ: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "ಆಸ್ತಿ ಮಾರಾಟ ಚಟುವಟಿಕೆ: 3,5,10 ಶನಿಗ್ರಹ ಮತ್ತು ಗುರುವಿನೊಂದಿಗೆ",
    "Interior Designer / Decorator": "ಇಂಟೀರಿಯರ್ ಡಿಸೈನರ್ / ಅಲಂಕರಣಕಾರ",
    "Creativity / Innovation": "ಸೃಜನಶೀಲತೆ / ನವೋದ್ಯಮ",
    "Politics / Public Leadership": "ರಾಜಕಾರಣ / ಸಾರ್ವಜನಿಕ ನಾಯಕತ್ವ",
    "Chartered Accountant": "ಚಾರ್ಟರ್ಡ್ ಅಕೌಂಟೆಂಟ್",
    "Data Management / Business Management": "ಡೇಟಾ ನಿರ್ವಹಣೆ / ವ್ಯವಹಾರ ನಿರ್ವಹಣೆ",
    "Chef / Culinary Profession": "ಶೆಫ್ / ಪಾಕಪ್ರವೃತ್ತಿ",
    "Benefic planet": "ಲಾಭದಾಯಕ ಗ್ರಹ",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "2ನೇ ಭವನದಲ್ಲಿ ಲಾಭದಾಯಕ ಅಥವಾ 2ನೇ ಭವನವನ್ನು ಲಾಭದಾಯಕವಾಗಿ ಪ್ರಭಾವಿಸುವ ಗ್ರಹ",
    "International / continental cuisine: +9,3,12": "ಅಂತರರಾಷ್ಟ್ರೀಯ / ಖಂಡೀಯ ಆಹಾರ: +9,3,12",
    "Correctional / Institutional Administration": "ಶ್ರೇಯಾಂಕ / ಸಂಸ್ಥಾಪಕ ಆಡಳಿತ",
    "Journalist / Media Professional": "ಪತ್ರಕರ್ತ / ಮಾಧ್ಯಮ ವೃತ್ತಿಪರ",
    "Investigative / crime reporting: +7,8,12": "ತನಿಖಾ / ಅಪರಾಧ ವರದಿ: +7,8,12",
    "Political reporting: +1,10,11": "ರಾಜಕೀಯ ವರದಿ: +1,10,11",
    "Sports reporting: +5,10": "ಕ್ರೀಡೆ ವರದಿ: +5,10",
    "Creative Writer": "ಸೃಜನಾತ್ಮಕ ಲೇಖಕ",
    "Creativity: +5,9": "ಸೃಜನಶೀಲತೆ: +5,9",
    "Artistic writing: 5,11": "ಕಲಾತ್ಮಕ ಲೇಖನ: 5,11",
    "Mystery / occult / deep subjects: 8,12": "ರಹಸ್ಯ / ಅಕೌಟುಂಬಿಕ / ಆಳವಾದ ವಿಷಯಗಳು: 8,12",
    "Legal Matters": "ಕಾನೂನು ವಿಷಯಗಳು",
    "Legal Dispute Indicators": "ಕಾನೂನು ವಿವಾದ ಸೂಚಕಗಳು",
    "Supportive Legal Matter Indicators": "ಬೆಂಬಡಿಕೀಯ ಕಾನೂನು ವಿಷಯ ಸೂಚಕಗಳು",
    "Challenging Legal Matter Indicators": "ಸವಾಲಿನ ಕಾನೂನು ವಿಷಯ ಸೂಚಕಗಳು",
    "Legal Relief Indicators": "ಕಾನೂನು ಪರಿಹಾರ ಸೂಚಕಗಳು",
    "5,9 acts as a facilitator.": "5,9 ಸಹಾಯಕನಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ.",
    "Property & Residence": "ಆಸ್ತಿಯು ಮತ್ತು ವಾಸಸ್ಥಳ",
    "Property Purchase Prospects": "ಆಸ್ತಿ ಖರೀದಿ ಭವಿಷ್ಯವನ್ನು ನಿರೀಕ್ಷಣೆ ಮಾಡುವುದು",
    "property modifier": "ಆಸ್ತಿ ಪರಿವರ್ತಕ",
    "Source notes aspect, transit, conjunction and DBA involvement": "ಮೂಲ ಲೇಖನವು ಅಂಶ, ಸಾರಿಗೆ, ಸಂಯೋಜನೆ ಮತ್ತು DBA ಭಾಗವಹಿಸುವಿಕೆಯನ್ನು ಸೂಚಿಸುತ್ತದೆ",
    "Property Through Financing / Loan": "ಹಣಕಾಸು / ಸಾಲದ ಮೂಲಕ ಆಸ್ತಿ",
    "Loan repayment/completion support: +4,11": "ಸಾಲದ ಪಾವತಿ / ಪೂರ್ಣತೆ ಬೆಂಬಡಿಕೆ: +4,11",
    "Property Through Institutional / Personal Support": "ಸಂಸ್ಥೆ / ವೈಯಕ್ತಿಕ ಬೆಂಬಡಿಕೆಯ ಮೂಲಕ ಆಸ್ತಿ",
    "Property Through Gift / Inheritance": "ಉಡುಗೊರೆ / ವಂಶ ಮೂಲಕ ಆಸ್ತಿ",
    "Property Purchase in Stages": "ಹಂತಗಳಲ್ಲಿ ಆಸ್ತಿ ಖರೀದಿ",
    "Government / Institution-Allotted Property": "ಸರ್ಕಾರ / ಸಂಸ್ಥೆಯಿಂದ ಮೀಸಲಾಗಿಸಲಾಗಿದ ಆಸ್ತಿ",
    "Commercial Property Purchase": "ವಾಣಿಜ್ಯ ಆಸ್ತಿ ಖರೀದಿ",
    "Rental Income Potential": "ಬಾಡಿಗೆ ಆದಾಯದ ಸಾಧ್ಯತೆ",
    "Considering a Residence Change": "ನಿವಾಸ ಬದಲಾವಣೆ ಬಗ್ಗೆ ಪರಿಗಣಿಸುವುದು",
    "Change of Residence": "ನಿವಾಸ ಬದಲಾವಣೆ",
    "Separative planets": "ವ್ಯತ್ಯಾಸಕಾರಿ ಗ್ರಹಗಳು",
    "Property Through Family / Marriage Arrangement": "ಕುಟುಂಬ / ವಿವಾಹ ವ್ಯವಸ್ಥೆಯಿಂದ ಆಸ್ತಿ",
    "Property Ownership / Possession Challenges": "ಆಸ್ತಿ ಸ್ವಾಧೀನ / ಹೊಗೆ ಸಂಬಂಧಿತ ಸವಾಲುಗಳು",
    "Property Conflict / Government Intervention": "ಆಸ್ತಿ ಸಂಘರ್ಷ / ಸರ್ಕಾರಿ ಹಸ್ತಕ್ಷೇಪ",
    "Property Dispute / Litigation Indicators": "ಆಸ್ತಿ ವಿವಾದ / ನ್ಯಾಯಾಂಗ ಸೂಚಕಗಳು",
    "Venus": "ಶುಕ್ರ",
    "source modifier": "ಮೂಲ ಪರಿಷ್ಕಾರಕ",
    "Do not infer gender in public UI": "ಸಾರ್ವಜನಿಕ UI ನಲ್ಲಿ ಲಿಂಗವನ್ನು ಊಹಿಸಬೇಡಿ",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "ಬುಧನೊಂದಿಗೆ ಮತ್ತು ಡ್ಯುಯಲ್ ಚಿಹ್ನೆಯೊಂದಿಗೆ, ಮೂಲವು ಪುನರಾವರ್ತಿತ/ಬಹು ಸಮಸ್ಯೆಗಳನ್ನು ಸೂಚಿಸುತ್ತದೆ",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "ಗುರು ಮತ್ತು ಡ್ಯುಯಲ್ ಚಿಹ್ನೆಯೊಂದಿಗೆ, ಮೂಲವು ಪುನರಾವರ್ತಿತ/ಬಹು ಸಮಸ್ಯೆಗಳನ್ನು ಸೂಚಿಸುತ್ತದೆ",
    "Supportive Property Dispute Indicators": "ಬೆಂಬಲಿಸುವ ಆಸ್ತಿ ವಿವಾದ ಸೂಚಕಗಳು",
    "Challenging Property Dispute Indicators": "ಸವಾಲಿನ ಆಸ್ತಿ ವಿವಾದ ಸೂಚಕಗಳು",
    "Property Division / Partition": "ಆಸ್ತಿ ಹಂಚಿಕೆ / ವಿಭಜನೆ",
    "Property Sale Prospects": "ಆಸ್ತಿ ಮಾರಾಟ ಸಾಧ್ಯತೆಗಳು",
    "Favourable Property Sale Conditions": "ಅನುಕೂಲಕರ ಆಸ್ತಿ ಮಾರಾಟ ಪರಿಸ್ಥಿತಿಗಳು",
    "Less Supportive Property Sale Conditions": "ಕಡಿಮೆ ಬೆಂಬಲದ ಆಸ್ತಿ ಮಾರಾಟ ಪರಿಸ್ಥಿತಿಗಳು",
    "Vehicle": "ವಾಹನ",
    "Vehicle Acquisition Prospects": "ವಾಹನ ಹೊಂದುವ ಸಾಧ್ಯತೆಗಳು",
    "primary vehicle significator": "ಪ್ರಾಥಮಿಕ ವಾಹನ ಸೂಚಕ",
    "Vehicle Through Financing / Loan": "ಹಣಸಹಾಯ / ಸಾಲದ ಮೂಲಕ ವಾಹನ",
    "Vehicle Through Gift": "ಉಡುಗೊರೆ ಮೂಲಕ ವಾಹನ",
    "Venus active in DBA": "DBAದಲ್ಲಿ ಶುಕ್ರ ಚಕ್ರವ್ಯವಸ್ಥೆ ಸಕ್ರಿಯ",
    "Premium / Luxury Vehicle Indicators": "ಪ್ರೀಮಿಯಂ / ಐಶ್ವರ್ಯವಂತಿ ವಾಹನ ಸೂಚಕಗಳು",
    "primary factor": "ಪ್ರಾಥಮಿಕ ಕಾರಣ",
    "Natural benefic planets": "ಪ್ರಕೃತಿಕರ ಲಾಭಕಾರ ಗ್ರಹಗಳು",
    "aspecting/supporting factor": "ಮುಖಮಾಡುವ / ಬೆಂಬಲಿಸುವ ಕಾರಣ",
    "Pre-Owned Vehicle Indicators": "ಹಳೆಯ ವಾಹನ ಸೂಚಕಗಳು",
    "aspecting factor": "ಮುಖಮಾಡುವ ಕಾರಣ",
    "Vehicle Maintenance Concerns": "ವಾಹನ ನಿರ್ವಹಣೆ ಕುರಿತ ಚಿಂತೆಗಳು",
    "Commercial Vehicle Indicators": "ವಾಣಿಜ್ಯ ವಾಹನ ಸೂಚಕಗಳು",
    "commercial vehicle modifier": "ವಾಣಿಜ್ಯ ವಾಹನ ಬದಲಾವಣೆಯ ಸೂಚಕ",
    "Mercury involved or aspecting": "ಬುಧ ಗ್ರಹ ಸಂಬಂಧಿತ ಅಥವಾ ಮುಖಮಾಡುವ",
    "small commercial vehicle modifier": "ಸಣ್ಣ ವಾಣಿಜ್ಯ ವಾಹನ ಬದಲಾವಣೆಯ ಸೂಚಕ",
    "Venus involved or aspecting": "ಶುಕ್ರ ಭಾಗಿಯಾಗಿರುವ ಅಥವಾ ಆಸ್ಪೆಕ್ಟಿಂಗ್",
    "heavy commercial vehicle modifier": "ಹೆವಿ ಕಮರ್ಷಿಯಲ್ ವೆಹಿಕಲ್ ಮಾರ್ಪಾಡು",
    "Saturn involved or aspecting": "ಶನಿ ಭಾಗಿಯಾಗಿದ್ದಾನೆ ಅಥವಾ ನೋಡುತ್ತಾನೆ",
    "Vehicle Security / Possession Caution": "ವಾಹನ ಭದ್ರತೆ / ಸ್ವಾಧೀನ ಎಚ್ಚರಿಕೆ",
    "Strong Vehicle Security / Possession Caution": "ಬಲವಾದ ವಾಹನ ಭದ್ರತೆ / ಸ್ವಾಧೀನ ಎಚ್ಚರಿಕೆ",
    "Vehicle Recovery / Resolution Indicators": "ವೆಹಿಕಲ್ ರಿಕವರಿ / ರೆಸಲ್ಯೂಶನ್ ಇಂಡಿಕೇಟರ್ ಗಳು",
    "Vehicle Loan Repayment Challenges": "ವಾಹನ ಸಾಲ ಮರುಪಾವತಿ ಸವಾಲುಗಳು",
    "Stronger while the combination remains active in DBA": "ಸಂಯೋಜನೆಯು ಡಿಬಿಎಯಲ್ಲಿ ಸಕ್ರಿಯವಾಗಿರುವಾಗ ಬಲವಾಗಿರುತ್ತದೆ",
    "Improvement/return after payment: 4,6,11": "ಸುಧಾರಣೆ / ಪಾವತಿಯ ನಂತರ ಆದಾಯ: 4,6,11",
    "Vehicle Sale Prospects": "ವಾಹನ ಮಾರಾಟದ ನಿರೀಕ್ಷೆಗಳು",
    "Insurance Claim Indicators": "ವಿಮಾ ಕ್ಲೈಮ್ ಸೂಚಕಗಳು",
    "Travel, Visa & Foreign Matters": "ಪ್ರಯಾಣ, ವೀಸಾ ಮತ್ತು ವಿದೇಶಾಂಗ ವಿಷಯಗಳು",
    "Travel Prospects": "ಪ್ರಯಾಣದ ನಿರೀಕ್ಷೆಗಳು",
    "travel modifier": "ಟ್ರಾವೆಲ್ ಮಾರ್ಪಾಡು",
    "Short-Distance Travel": "ಅಲ್ಪ-ದೂರದ ಪ್ರಯಾಣ",
    "Long-Distance Travel": "ದೂರದ ಪ್ರಯಾಣ",
    "Change in Travel Plans / Route": "ಪ್ರಯಾಣ ಯೋಜನೆಗಳು / ಮಾರ್ಗದಲ್ಲಿ ಬದಲಾವಣೆ",
    "Separative planet": "ಬೇರ್ಪಡಿಸುವ ಗ್ರಹ\n[[ಎನ್ 193]] ಹೆಚ್ಚಿನ ಹೊಂದಾಣಿಕೆಯ ಅಗತ್ಯವಿರುವ ಅಂತರರಾಷ್ಟ್ರೀಯ ಪ್ರಯಾಣ\n[[ಎನ್ 194]] ಅಪರೂಪದ ಗ್ರಹಗಳು",
    "International Travel Requiring Greater Adjustment": "ಅಂತರರಾಷ್ಟ್ರೀಯ ಪ್ರವಾಸ ಹೆಚ್ಚು ಸರಿಹೊಂದುತ್ತಿರುವ ಅಗತ್ಯವಿರುವುದು",
    "Malefic planets": "ಖರಾಪು ಗ್ರಹಗಳು",
    "Supportive International Travel": "ಬೆಂಬಲ ನೀಡುವ ಅಂತರ್ಜාತೀಯ ಪ್ರಯಾಣ",
    "Benefic planets": "ಲಾಭದಾಯಕ ಗ್ರಹಗಳು",
    "Return Home / Homecoming": "ಮನೆಗೆ ಹಿಂತಿರುಗುವಿಕೆ / ಹೋಮ್ ಕಾಮಿಂಗ್",
    "Visa Prospects": "ವೀಸಾ ಸಾಧ್ಯತೆಗಳು",
    "Tourist Visa Prospects": "ಪ್ರವಾಸಿ ವೀಸಾ ಸಾಧ್ಯತೆಗಳು",
    "Study Visa Prospects": "ಅಧ್ಯಯನ ವೀಸಾ ಸಾಧ್ಯತೆಗಳು",
    "Business Visa Prospects": "ವ್ಯವಹಾರ ವೀಸಾ ಸಾಧ್ಯತೆಗಳು",
    "Import/export business: +2,7,10,11": "ಆಮದು/ರಫ್ತು ವ್ಯಾಪಾರ: +2,7,10,11",
    "Work Visa Prospects": "ಕೆಲಸದ ವೀಸಾ ಸಾಧ್ಯತೆಗಳು",
    "Partner Abroad Indicators": "ವಿದೇಶದಲ್ಲಿನ ಜೊತೆಯ ಸೂಚಕಗಳು",
    "Marriage Abroad Prospects": "ವಿದೇಶದಲ್ಲಿ ವಿವಾಹ ಸಾಧ್ಯತೆಗಳು",
    "Professional / Conference Travel": "ವೃತ್ತಿಪರ / ಸಮ್ಮೇಳನ ಪ್ರಯಾಣ",
    "Sports-Related Travel": "ಕ್ರೀಡಾ ಸಂಬಂಧಿತ ಪ್ರಯಾಣ",
    "Family & Life Development": "ಕುಟುಂಬ ಮತ್ತು ಜೀವನದ ಅಭಿವೃದ್ಧಿ",
    "Family Expansion Prospects": "ಕುಟುಂಬ ವಿಸ್ತರಣೆ ಸಾಧ್ಯತೆಗಳು"
  },
  "ml": {
    "Event Analysis": "ഇവന്റ് വിശകലനം",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "പരമ്പരാഗത നാടി വീട്ടുപ്രസംഗങ്ങൾക്കും പങ്കെടുക്കുന്ന ഗ്രഹങ്ങൾക്കുമായി ഒരു വർഗ്ഗവും ഇവന്റും തിരഞ്ഞെടുക്കുക.",
    "Category": "വർഗ്ഗം",
    "Event": "ഇവന്റ്",
    "Locked": "ലോക്ക് ചെയ്തിരിക്കുന്നു",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "എല്ലാ വർഗ്ഗങ്ങളും ഇവന്റുകളും കാണാനാകും. ലോക്ക് ചെയ്ത ഇവന്റ് വിശകലന ഓപ്ഷനുകൾ അൺലോക്ക് ചെയ്യാൻ പ്രീമിയമിലേക്ക് അപ്ഗ്രേഡ് ചെയ്യുക.",
    "Supportive indication": "പിന്തുണയ്ക്കുന്ന സൂചനം",
    "Challenging indication": "വെല്ലുവിളിയുള്ള സൂചനം",
    "Neutral indication": "നിഷ്പക്ഷ സൂചനം",
    "Event groups": "ഇവന്റ് ഗ്രൂപ്പുകൾ",
    "Good": "നല്ലത്",
    "Bad": "മോശം",
    "Supportive": "പിന്തുണയുള്ള",
    "Challenging supportive": "വെല്ലുവിളിയുള്ള പിന്തുണ",
    "Planets involved": "പങ്കെടുേവഗ്രഹങ്ങൾ",
    "involved": "പങ്കെടുത്ത",
    "Pro": "പ്രൊ",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "ഈ വ്യാഖ്യാനങ്ങൾ പരമ്പരാഗത ജ്യോതിഷ ശാസ്ത്ര സിദ്ധാന്തങ്ങളിൽ അടിസ്ഥാനമാക്കിയുള്ളവയാണ്, വിവരകല്പനക്കും വിദ്യാഭ്യാസത്തിനും വേണ്ടി ഉദ്ദേശിച്ചവയാണ്. അവ പ്രവണതകളും സാധ്യതകളെയും സൂചിപ്പിക്കുന്നു, ഉറപ്പുള്ള ഫലങ്ങളല്ല. നിയമ, സാമ്പത്തിക, വൈദ്യശാസ്‌ത്രം അല്ലെങ്കിൽ മറ്റ് പ്രൊഫഷണൽ കാര്യങ്ങൾക്ക്, അനുയോജ്യമായ അർഹതയുള്ള പ്രൊഫഷണൽക്ക് സമീപിക്കുക.",
    "Career, Work & Business": "കരിയർ, ജോലി & ബിസിനസ്",
    "Employment Prospects": "തൊഴിൽ സാധ്യതകൾ",
    "Business Prospects": "ബിസിനസ് സാധ്യതകൾ",
    "Earning Potential": "വരുമാന സാധ്യത",
    "Business Challenges": "ബിസിനസ് പ്രതിസന്ധികൾ",
    "Business Recovery Indicators": "ബിസിനസ് പുനരുദ്ധാരണ സൂചകങ്ങൾ",
    "10,11 acts as regain/recovery support after business difficulty.": "ബിസിനസ് പ്രശ്‌നത്തിനുശേഷം പുനരുദ്ധാരണ സഹായം നൽകുന്നത് 10,11 ആണ്.",
    "Administration Career": "ഭരണപരമായ കരിയർ",
    "Employment Challenges": "തൊഴിൽ-related വെല്ലുവിളികൾ",
    "Professional Obstacles / Delays": "പ്രൊഫഷണൽ തടസ്സങ്ങൾ / വൈകിപ്പിക്കൽ",
    "Professional Recognition Challenges": "പ്രൊഫഷണൽ അംഗീകരണ വെല്ലുവിളികൾ",
    "Financial Pressure": "സാമ്പത്തിക സമ്മർദ്ദം",
    "Financial Return Cycle": "സാമ്പത്തിക തിരിച്ചുപ്രവാഹ ചക്രം",
    "Supportive Career Change": "പിന്തുണ നൽകുന്ന കരിയർ മാറ്റം",
    "Favourable Career Transition": "അനുകൂല കരിയർ മാറൽ",
    "Next DBA": "അടുത്ത DBA",
    "Challenging Career Transition": "വെല്ലുവിളി കരിയർ മാറൽ",
    "Workplace Transfer / Relocation": "ജോലി സ്ഥലം മാറ്റം / സ്ഥലംമാറ്റം",
    "Return to Previous Workplace / Location": "മുമ്പത്തെ ഓഫീസിൽ / സ്ഥലത്തേക്ക് മടങ്ങൽ",
    "Personality & Temperament": "വ്യക്തിത്വവും സ്വഭാവവും",
    "Assertive / Intense Temperament": "ആത്മവിശ്വസ്തമായ / ഊർജ്ജസ്വലമായ സ്വഭാവം",
    "Mars": "മംഗളം (Mars)",
    "modifier": "മാറ്റം കണ്ടുകൂട്ടുക",
    "Mars connected with the 1st or 3rd house": "1-ാം അല്ലെങ്കിൽ 3-ാം ഭവവുമായി മംഗളം ബന്ധിതം",
    "Emotional Sensitivity": "മാനസിക സഹിഷ്ണുത",
    "Moon": "ചന്ദ്രൻ (Moon)",
    "Moon influence; source also notes Cancer connected with the 1st house": "ചന്ദ്രന്റെ സ്വാധീനം; ഉറവിടം 1-ാം ഭവവുമായി കാൻസർ ബന്ധിതമാണെന്ന് എടുത്തു പറയുന്നു",
    "Affectionate & Relationship-Oriented Nature": "സ്നേഹപരവും ബന്ധങ്ങൾക്ക് ആകർഷകമായ സ്വഭാവം",
    "Warm & Supportive Nature": "ചൂടുള്ളയും പിന്തുണയുള്ള സ്വഭാവം",
    "Independent / Detached Tendencies": "സ്വതന്ത്യരമായ / വേർതിരിച്ചുള്ള പ്രവണതകൾ",
    "Rahu": "രാഹു (Rahu)",
    "associated planet": "ബന്ധപ്പെട്ട ഗ്രഹം",
    "Ketu": "കേതു (Ketu)",
    "Saturn": "ശനി (Saturn)",
    "Sun": "സൂര്യൻ (Sun)",
    "Reserved / Practical Nature": "സംരക്ഷിതമായ / യാഥാർത്ഥ്യപ്രധാനമായ സ്വഭാവം",
    "Persistent / Determined Nature": "സ്ഥിരതയുള്ള / നിർണയമായ സ്വഭാവം",
    "Relationships & Marriage": "ബന്ധങ്ങളും വിവാഹവും",
    "Relationship Boundary Challenges": "ബന്ധ പരിമിതികൾ സംബന്ധിച്ച വെല്ലുവിളികൾ",
    "Supportive Relationship Bond": "പിന്തുണയുള്ള ബന്ധത്തിന്റെ ബന്ധം",
    "Private / Complex Relationship Phase": "സ്വകാര്യ / സങ്കീർണബന്ധ ഘട്ടം",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "സ്രോതസ്സും 5,9,11; 5,11; 5,8,11 നെ കൂടുതൽ ശുദ്ധമായ/പിന്തുണയുള്ള ബന്ധത്തിന്റെ വ്യത്യാസങ്ങളായി പട്ടികപ്പെടുത്തുന്നു.",
    "Relationship Conflict / Reactive Dynamics": "ബന്ധങ്ങളുടെ പ്രതിസന്ധി / പ്രതികാര ചലനങ്ങൾ",
    "Marriage Prospects": "വിവാഹ സാധ്യതകൾ",
    "Marriage Through Known Circle": "പരിചിത വൃത്തത്തിലൂടെ വിവാഹം",
    "Supportive Marriage Circumstances": "പിന്തുണയുള്ള വിവാഹ സാഹചര്യങ്ങൾ",
    "Marriage Delay Indicators": "വിവാഹ വൈകല്യ സൂചനകൾ",
    "In DBA": "ഡബി.എയിൽ",
    "Emotional Distance in Relationship": "ബന്ധത്തിൽ മാനസിക അകലം",
    "Reconciliation Indicators": "പുനഃസൗഹൃദം സൂചിപ്പിക്കുന്ന സൂചനകൾ",
    "Use with the preceding relationship/separation combination.": "മുമ്പത്തെ പങ്കാളിത്തം / വേർപാട് സംയോജിതവുമായി ഉപയോഗിക്കുക.",
    "Marital Transition / Separation Indicators": "വിവാഹ പാരിതോഷികം / വേർപാട് സൂചനകൾ",
    "Reduced Support for Marriage": "വിവാഹത്തിനുള്ള പിന്തുണ കുറഞ്ഞത്",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "നിരവധി ബന്ധപ്പെട്ട ഗ്രഹങ്ങൾ / സൂചകങ്ങൾ വഴി 1,6,10 ആവർത്തിച്ച് സ്ഥിരമാക്കുമ്പോൾ ശക്തമാവുന്നു.",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "ഏഴാമത്തെ കപ്സ് ഭരണം 1,6,10 ന്റെ സൂചകൻ ആയിരിക്കുകയും ചെയ്താൽ ശക്തമാകുന്നു.",
    "Relocation After Marriage": "വിവാഹത്തിന് ശേഷം താമസം മാറ്റം",
    "Relocation to a Distant / Unfamiliar Place": "ദൂരെ / പരിചിതമല്ലാത്ത സ്ഥലത്തേക്ക് സമപ്പിക്കൽ",
    "Non-Traditional Relationship Pattern": "പരമ്പരാഗതമല്ലാത്ത ബന്ധ പാറ്റേൺ",
    "Education & Learning": "വിദ്യാഭ്യാസം & പഠനം",
    "Education Prospects": "വിദ്യാഭ്യാസ സാധ്യതകൾ",
    "Strong Education Potential": "ശക്തമായ വിദ്യാഭ്യാസ സാധ്യത",
    "Management / Professional Higher Education Potential": "മാനേജ്മെന്റ് / പ്രൊഫഷണൽ ഉയർന്ന വിദ്യാഭ്യാസ സാധ്യത",
    "Profession Indicators": "തൊഴിൽ സൂചകങ്ങൾ",
    "Astrology / Astrologer": "ജ്യോതിശാസ്ത്രം / ജ്യോതിശാസ്താവ്",
    "Mercury": "ബുധൻ",
    "profession modifier": "തൊഴിൽ മാറ്റുക രൂപകാരി",
    "Jupiter": "ജ്യുപിറ്റർ",
    "Teacher / Educator": "അധ്യാപകർ / വിദ്യാഭ്യാസ വിദഗ്ധർ",
    "Higher-education support: 1,2,4,9,11": "ഉയർന്ന വിദ്യാഭ്യാസ പിന്തുണ: 1,2,4,9,11",
    "Writer / Professional Writing": "എഴുത്തുകാരൻ / പ്രൊഫഷണൽ എഴുത്ത്",
    "Income Support Through Profession": "തൊഴിൽ വഴി വരുമാന പിന്തുണ",
    "Medical / Healthcare Profession": "മെഡിക്കൽ / ആരോഗ്യ സംരക്ഷണ തൊഴിൽ",
    "Stronger professional quality: 5,9,11 + 6,8,12": "ശക്തമായ പ്രൊഫഷണൽ ഗുണം: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "പ്രൊഫഷണൽ വിജയം പിന്തുണ: 6,8,12 + 10,11 അല്ലെങ്കിൽ +11 അല്ലെങ്കിൽ +9,11",
    "Engineer": "എഞ്ചിനീയർ",
    "Scientist": "ശാസ്ത്രജ്ഞൻ",
    "Research / Inventions / Deep Analysis": "ഗവേഷണം / കണ്ടുമുട്ടലുകൾ / ആഴത്തിലുള്ള വിശകലനം",
    "Recognition Through Research / Innovation": "ഗവേഷണം / ആവിഷ്കാരത്തിലൂടെ അംഗീകാരം",
    "Information Technology": "വിവര സാങ്കേതികവിദ്യ",
    "Higher-education support: 2,4,5,9,11": "ഉയർന്ന വിദ്യാഭ്യാസ സഹായം: 2,4,5,9,11",
    "Lawyer / Legal Profession": "അഭിഭാഷകൻ / നിയമ തൊഴിൽ",
    "Architect": "വാസ്തുവിദ്",
    "Builder / Construction": "കെട്ടിട നിർമ്മാൽ / നിർമ്മാണം",
    "Property / Real-Estate Professional": "സ്വത്ത് / റിയൽ എസ്റ്റേറ്റ് പ്രൊഫഷണൽ",
    "Property purchase activity: 4,11,12": "സ്വത്ത് വാങ്ങാനുള്ള പ്രവർത്തനങ്ങൾ: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "സ്വത്ത് വിൽപ്പന പ്രവർത്തനങ്ങൾ: 3,5,10 ശനി, മംഗലങ്ങൾക്കൊപ്പം",
    "Interior Designer / Decorator": "ഇന്റീരിയർ ഡിസൈനർ / അലങ്കാര രൂപകാരൻ",
    "Creativity / Innovation": "സൃഷ്ടിപരമായ / നവീകരണം",
    "Politics / Public Leadership": "രാഷ്ട്രീയം / പൊതുജന നേതൃത്വം",
    "Chartered Accountant": "ചാർട്ടേർഡ് അക്കൗണ്ടൻറ്",
    "Data Management / Business Management": "ഡാറ്റാ മാനേജ്‌മെന്റ് / ബിസിനസ് മാനേജ്‌മെന്റ്",
    "Chef / Culinary Profession": "ഷെഫ് / പാചക പ്രൊഫഷണൽ",
    "Benefic planet": "അനുകൂല ഗ്രഹം",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "2-ാം ഭവനിൽ അനുകൂല അസ്തിത്വം കാണിക്കുന്ന അല്ലെങ്കിൽ 2-ാം ഭവനത്തെ അനുകൂലമായി ബാധിക്കുന്ന",
    "International / continental cuisine: +9,3,12": "അന്താരാഷ്ട്ര / കണ്ടിനന്റൽ അടുക്കള: +9,3,12",
    "Correctional / Institutional Administration": "ശിക്ഷാനുഷ്ഠാന / സ്ഥാപക ഭരണവ്യവസ്ഥ",
    "Journalist / Media Professional": "മാധ്യമ / മാധ്യമ പ്രൊഫഷണൽ",
    "Investigative / crime reporting: +7,8,12": "അന്വേഷണം / കുറ്റകൃത്യ റിപ്പോർട്ടിംഗ്: +7,8,12",
    "Political reporting: +1,10,11": "രാഷ്ട്രീയ റിപ്പോർട്ടിംഗ്: +1,10,11",
    "Sports reporting: +5,10": "കായിക റിപ്പോർട്ടിംഗ്: +5,10",
    "Creative Writer": "സൃഷ്ടിപരമായ എഴുത്തുകാരൻ",
    "Creativity: +5,9": "സൃഷ്ടിപ്രവർത്തനശീലത: +5,9",
    "Artistic writing: 5,11": "കലാപരമായ എഴുത്ത്: 5,11",
    "Mystery / occult / deep subjects: 8,12": "രഹസ്യം / അപ്രകട പ്രതിഭാസങ്ങൾ / ഗഹന വിഷയങ്ങൾ: 8,12",
    "Legal Matters": "നിയമകാര്യങ്ങൾ",
    "Legal Dispute Indicators": "നിയമ തർക്ക സൂചകങ്ങൾ",
    "Supportive Legal Matter Indicators": "പിന്തുണയുള്ള നിയമകാര്യ സൂചകങ്ങൾ",
    "Challenging Legal Matter Indicators": "വെല്ലുവിളിയുള്ള നിയമകാര്യ സൂചകങ്ങൾ",
    "Legal Relief Indicators": "നിയമ സംരക്ഷണ സൂചകങ്ങൾ",
    "5,9 acts as a facilitator.": "5,9 ഒരു സഹായകമായി പ്രവർത്തിക്കുന്നു.",
    "Property & Residence": "സ്വത്തും താമസവും",
    "Property Purchase Prospects": "സ്വത്ത് വാങ്ങാനുള്ള സാധ്യതകൾ",
    "property modifier": "സ്വത്ത് മാറ്റം വരുത്തുന്ന ഘടകം",
    "Source notes aspect, transit, conjunction and DBA involvement": "സ്രോതസ്സിൽ കുറിപ്പുകൾ, ഗതാഗതം, യോജനം, DBA പങ്കാളിത്തം എന്നിവ",
    "Property Through Financing / Loan": "ധനസഹായം / വായ്പാ മാർഗ്ഗത്തിലൂടെയുള്ള സ്വത്ത്",
    "Loan repayment/completion support: +4,11": "വായ്പ പൂരിപ്പിക്കല്‍/പൂർത്തീകരണ സഹായം: +4,11",
    "Property Through Institutional / Personal Support": "സ്ഥാപനപരമായ / വ്യക്തിഗത പിന്തുണയിലൂടെ സ്വത്ത്",
    "Property Through Gift / Inheritance": "സമ്മാനമൂടി / പാരമ്പര്യവഴി സ്വത്ത്",
    "Property Purchase in Stages": "ഘട്ടങ്ങളിലായി സ്വത്ത് വാങ്ങല്‍",
    "Government / Institution-Allotted Property": "സര്‍ക്കാര്‍ / സ്ഥാപന നിരോധിച്ച സ്വത്ത്",
    "Commercial Property Purchase": "വ്യാപാര സ്വത്ത് വാങ്ങല്‍",
    "Rental Income Potential": "വാടക വരുമാന സാധ്യത",
    "Considering a Residence Change": "താമസസ്ഥലം മാറ്റം പരിഗണിക്കുന്നു",
    "Change of Residence": "താമസസ്ഥലം മാറ്റം",
    "Separative planets": "വ്യത്യാസപ്പെടുത്തുന്ന ഗ്രഹങ്ങള്‍",
    "Property Through Family / Marriage Arrangement": "കുടുംബ / വിവാഹ ഒരുക്കം വഴി സ്വത്ത്",
    "Property Ownership / Possession Challenges": "സ്വത്ത് ഉടമസ്ഥത / സ്വത്ത്വം കൈവശംവെയ്ക്കുന്നതില്‍ പ്രശ്നങ്ങള്‍",
    "Property Conflict / Government Intervention": "സ്വത്ത് സംഘര്‍ഷം / സര്‍ക്കാര്‍ ഇടപെടല്‍",
    "Property Dispute / Litigation Indicators": "സ്വത്ത് വാദവിചാര / നിയമപട്ടിക സൂചകങ്ങള്‍",
    "Venus": "വെള്ളി",
    "source modifier": "ഉറവിട മാറ്റി നിര്‍മിച്ച പങ്ക്",
    "Do not infer gender in public UI": "പൊതുയൂഐയില്‍ ലിംഗം നിർണ്ണയിക്കരുത്",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "ബുധന്‍ കൂടിയും ഇരട്ട രാശിയുള്ളവര്‍ക്ക്, ഉറവിടം ആവര്‍ത്തിത / നിരവധി പ്രശ്നങ്ങള്‍ സൂചിപ്പിക്കുന്നു",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "ബൃഹസ്പതി കൂടിയും ഇരട്ട രാശിയുള്ളവര്‍ക്ക്, ഉറവിടം ആവര്‍ത്തിത / നിരവധി പ്രശ്നങ്ങള്‍ സൂചിപ്പിക്കുന്നു",
    "Supportive Property Dispute Indicators": "പിന്തുണയുള്ള സ്വത്ത് വാദ സൂചകങ്ങള്‍",
    "Challenging Property Dispute Indicators": "വെല്ലുവിളികൾ നിറഞ്ഞ സacksonസ് ആവശ്യകത സൂചകങ്ങൾ",
    "Property Division / Partition": "സ്വത്തു വിഭജനം / പെയ്യുന്നിടം",
    "Property Sale Prospects": "സ്വത്ത് വിൽപ്പന സാധ്യതകൾ",
    "Favourable Property Sale Conditions": "അനുകൂല സ്വത്ത് വിൽപ്പന നിലകൾ",
    "Less Supportive Property Sale Conditions": "കുറച്ചും അനുകൂലമല്ലാത്ത സ്വത്ത് വിൽപ്പന നിലകൾ",
    "Vehicle": "വാഹനം",
    "Vehicle Acquisition Prospects": "വാഹനം നേടാനുള്ള സാധ്യതകൾ",
    "primary vehicle significator": "പ്രാഥമിക വാഹന സൂചകം",
    "Vehicle Through Financing / Loan": "ഫിനാൻസിംഗ് / വായ്പവഴി വാഹനം",
    "Vehicle Through Gift": "ഉപഹാരത്തിലൂടെ വാഹനം",
    "Venus active in DBA": "DBA-യിൽ പ്രവർത്തനമാവുന്ന ശുക്രൻ",
    "Premium / Luxury Vehicle Indicators": "പ്രീമിയം / ലക്സറി വാഹന സൂചകങ്ങൾ",
    "primary factor": "പ്രാഥമിക ഘടകം",
    "Natural benefic planets": "പ്രകൃതിദത്ത നേർത്തഗ്രഹങ്ങൾ",
    "aspecting/supporting factor": "ആയാസ/സഹായ ഘടകം",
    "Pre-Owned Vehicle Indicators": "ഉപയോഗിച് എടുത്ത വാഹന സൂചകങ്ങൾ",
    "aspecting factor": "ആയാസ ഘടകം",
    "Vehicle Maintenance Concerns": "വാഹന പരിപാലന പ്രശ്‌നങ്ങൾ",
    "Commercial Vehicle Indicators": "വ്യാപാര വാഹന സൂചകങ്ങൾ",
    "commercial vehicle modifier": "വ്യാപാര വാഹന സംസ്കരണ ഘടകം",
    "Mercury involved or aspecting": "ബുദ്ധഗ്രഹം പങ്കാളിയാകുന്നു അല്ലെങ്കിൽ ആയാസം നൽകുന്നു",
    "small commercial vehicle modifier": "ചെറിയ വ്യാപാര വാഹന ഘടകം",
    "Venus involved or aspecting": "വെനസ് ഉൾപ്പെട്ടതോ പദവി നേടിയതോ",
    "heavy commercial vehicle modifier": "ഭാരമുള്ള വാണിജ്യ വാഹനം മാറ്റംചെയ്യുന്നവ",
    "Saturn involved or aspecting": "ശനി ഉൾപ്പെട്ടതോ പദവി നേടിയതോ",
    "Vehicle Security / Possession Caution": "വാഹന സുരക്ഷ / ഉടമസ്ഥാവകാശ ജാഗ്രത",
    "Strong Vehicle Security / Possession Caution": "ശക്തമായ വാഹന സുരക്ഷ / ഉടമസ്ഥാവകാശ ജാഗ്രത",
    "Vehicle Recovery / Resolution Indicators": "വാഹന വീണ്ടെടുക്കൽ / പരിഹാര സൂചകങ്ങൾ",
    "Vehicle Loan Repayment Challenges": "വാഹന ലോൺ തിരിച്ചടവ് പ്രശ്നങ്ങൾ",
    "Stronger while the combination remains active in DBA": "DBA ൽ സംയോജനം സജീവമായിരിക്കുമ്പോൾ കൂടുതൽ ശക്തമായിട്ട്",
    "Improvement/return after payment: 4,6,11": "പണം അടച്ചശേഷം പുരോഗതി/പ്രതിഫലം: 4,6,11",
    "Vehicle Sale Prospects": "വാഹന വിൽപ്പന സാധ്യതകൾ",
    "Insurance Claim Indicators": "ഇൻഷുറൻസ് ക്ലെയിം സൂചകങ്ങൾ",
    "Travel, Visa & Foreign Matters": "യാത്ര, വിസാ & വിദേശ വിഷയങ്ങൾ",
    "Travel Prospects": "യാത്ര സാധ്യതകൾ",
    "travel modifier": "യാത്ര മാറ്റംചെയ്യുന്നവ",
    "Short-Distance Travel": "ചെറിയ ദൂരത്തെ യാത്ര",
    "Long-Distance Travel": "ദൈർഘ്യമുള്ള യാത്ര",
    "Change in Travel Plans / Route": "യാത്ര പദ്ധതിയിൽ / റൂട്ടിൽ മാറ്റം",
    "Separative planet": "വേർതിരിക്കുന്ന ഗ്രഹം",
    "International Travel Requiring Greater Adjustment": "വലിയ പരിഷ്കാരത്തിന് ആവശ്യമുള്ള അന്താരാഷ്ട്ര യാത്ര",
    "Malefic planets": "ദോഷകരമായ ഗ്രഹങ്ങൾ",
    "Supportive International Travel": "പിന്തുണയുള്ള അന്താരാഷ്ട്ര യാത്ര",
    "Benefic planets": "അനുഗ്രഹ ദ്വീപങ്ങൾ",
    "Return Home / Homecoming": "വീട്ടിലേക്ക് മടങ്ങൽ / വീടിലേക്ക് തിരിച്ചുവരവ്",
    "Visa Prospects": "വിസ സാധ്യതകൾ",
    "Tourist Visa Prospects": "ടൂറിസ്റ്റ് വിസ സാധ്യതകൾ",
    "Study Visa Prospects": "പഠന വിസ സാധ്യതകൾ",
    "Business Visa Prospects": "ബിസിനസ് വിസ സാധ്യതകൾ",
    "Import/export business: +2,7,10,11": "ഇറക്കുമതി/ചർച്ചുവെട്ടു വ്യവസായം: +2,7,10,11",
    "Work Visa Prospects": "തൊഴിൽ വിസ സാധ്യതകൾ",
    "Partner Abroad Indicators": "വിദേശത്ത് പങ്കാളി സൂചനകൾ",
    "Marriage Abroad Prospects": "വിദേശത്തു വിവാഹം സാധ്യതകൾ",
    "Professional / Conference Travel": "പ്രൊഫഷണൽ / സമ്മേളന യാത്ര",
    "Sports-Related Travel": "കായിക ബന്ധപ്പെട്ടു യാത്ര",
    "Family & Life Development": "കുടുംബം & ജീവിത വികസനം",
    "Family Expansion Prospects": "കുടുംബ വിപുലീകരണ സാധ്യതകൾ"
  },
  "pa": {
    "Event Analysis": "ਘਟਨਾ ਵਿਸ਼ਲੇਸ਼ਣ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "ਆਪਣੀ ਰਵਾਇਤੀ ਨਾਡੀ ਘਰ ਸਮੂਹ ਅਤੇ ਸੰਬੰਧਿਤ ਗ੍ਰਹਾਂ ਨੂੰ ਦੇਖਣ ਲਈ ਕਿਸੇ ਸ਼੍ਰੇਣੀ ਅਤੇ ਘਟਨਾ ਨੂੰ ਚੁਣੋ।",
    "Category": "ਸ਼੍ਰੇਣੀ",
    "Event": "ਘਟਨਾ",
    "Locked": "ਲੌਕ ਕੀਤਾ ਗਿਆ",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "ਸਾਰੀਆਂ ਸ਼੍ਰੇਣੀਆਂ ਅਤੇ ਘਟਨਾਵਾਂ ਦਿੱਖ ਰਹੀਆਂ ਹਨ। ਲੌਕ ਕੀਤੀ ਘਟਨਾ ਵਿਸ਼ਲੇਸ਼ਣ ਵਿਕਲਪਾਂ ਨੂੰ ਖੋਲ੍ਹਣ ਲਈ ਪ੍ਰੀਮੀਅਮ ਵਿੱਚ ਅਪਗ੍ਰੇਡ ਕਰੋ।",
    "Supportive indication": "ਸਹਾਇਕ ਸੰਕੇਤ",
    "Challenging indication": "ਚੁਣੌਤੀਪੂਰਣ ਸੰਕੇਤ",
    "Neutral indication": "ਤਟਸਥ ਸੰਕੇਤ",
    "Event groups": "ਘਟਨਾ ਸਮੂਹ",
    "Good": "ਚੰਗਾ",
    "Bad": "ਮਾੜਾ",
    "Supportive": "ਸਹਾਇਕ",
    "Challenging supportive": "ਚੁਣੌਤੀਪੂਰਣ ਸਹਾਇਕ",
    "Planets involved": "ਸੰਬੰਧਿਤ ਗ੍ਰਹ",
    "involved": "ਸੰਬੰਧਿਤ",
    "Pro": "ਪ੍ਰੋ",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "ਇਹ ਵਿਆਖਿਆਵਾਂ ਰਵਾਇਤੀ ਖਗੋਲ-ਸ਼ਾਸਤਰੀ ਸਿਧਾਂਤਾਂ 'ਤੇ ਆਧਾਰਿਤ ਹਨ ਅਤੇ ਜਾਣਕਾਰੀ ਅਤੇ ਸਿੱਖਿਆ ਦੇ ਉਦੇਸ਼ ਲਈ ਹਨ। ਇਹ ਰੁਝਾਨਾਂ ਅਤੇ ਸੰਭਾਵਨਾਵਾਂ ਨੂੰ ਦਰਸਾਉਂਦੀਆਂ ਹਨ, ਨਾ ਕਿ ਗਾਰੰਟੀ ਵਾਲੇ ਨਤੀਜੇ। ਕਾਨੂੰਨੀ, ਵਿੱਤੀ, ਗ਼ੈਰ-ਦਵਾਈ ਜਾਂ ਹੋਰ ਪੇਸ਼ੇਵਰ ਮਾਮਲਿਆਂ ਲਈ, ਇੱਕ ਯੋਗ ਪੇਸ਼ੇਵਰ ਸਲਾਹਕਾਰ ਨਾਲ ਸਲਾਹ ਕਰੋ।",
    "Career, Work & Business": "ਕਰੀਅਰ, ਕੰਮ ਅਤੇ ਵਪਾਰ",
    "Employment Prospects": "ਨੌਕਰੀ ਦੇ ਮੌਕੇ",
    "Business Prospects": "ਵਪਾਰ ਦੇ ਮੌਕੇ",
    "Earning Potential": "ਕਮਾਈ ਦੀ ਸੰਭਾਵਨਾ",
    "Business Challenges": "ਵਪਾਰ ਦੀਆਂ ਚੁਣੌਤੀਆਂ",
    "Business Recovery Indicators": "ਵਪਾਰ ਮੁੜ ਉੱਤਰਨ ਦੇ ਸੰਕੇਤ",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 ਵਪਾਰ ਦੀ ਮੁਸ਼ਕਲ ਤੋਂ ਬਾਅਦ ਮੁੜ ਪ੍ਰਾਪਤੀ/ਸਹਾਇਤਾ ਦਾ ਕੰਮ ਕਰਦਾ ਹੈ।",
    "Administration Career": "ਪ੍ਰਸ਼ਾਸਨਿਕ ਕਰੀਅਰ",
    "Employment Challenges": "ਨੌਕਰੀ ਦੀਆਂ ਚੁਣੌਤੀਆਂ",
    "Professional Obstacles / Delays": "ਪੇਸ਼ੇਵਰ ਰੁਕਾਵਟਾਂ / ਵਿਲੰਬ",
    "Professional Recognition Challenges": "ਪੇਸ਼ੇਵਰ ਸਨਮਾਨ ਦੀਆਂ ਚੁਣੌਤੀਆਂ",
    "Financial Pressure": "ਵਿੱਤੀ ਦਬਾਅ",
    "Financial Return Cycle": "ਵਿੱਤੀ ਵਾਪਸੀ ਦਾ ਚੱਕਰ",
    "Supportive Career Change": "ਸਹਾਇਕ ਕਰੀਅਰ ਬਦਲਾਅ",
    "Favourable Career Transition": "ਅਨੁਕੂਲ ਕਰੀਅਰ ਪਰਿਵਰਤਨ",
    "Next DBA": "ਅਗਲਾ ਡੀਬੀਏ",
    "Challenging Career Transition": "ਚੁਣੌਤੀਪੂਰ੍ਣ ਕਰੀਅਰ ਪਰਿਵਰਤਨ",
    "Workplace Transfer / Relocation": "ਕਾਰਜਸਥਲ ਦੀ ਤਬਦੀਲੀ / ਬਦਲਾਓ",
    "Return to Previous Workplace / Location": "ਪਹਿਲਾਂ ਦੇ ਕਾਰਜਸਥਲ / ਸਥਾਨ 'ਤੇ ਵਾਪਸੀ",
    "Personality & Temperament": "ਵਿਅਕਤੀਗਤਤਾ & ਸੁਭਾਉ",
    "Assertive / Intense Temperament": "ਦਬੰਗ / ਤੀਵ੍ਰ ਸੁਭਾਉ",
    "Mars": "ਮੰਗਲ",
    "modifier": "ਸੋਧਕ",
    "Mars connected with the 1st or 3rd house": "ਪਹਿਲੇ ਜਾਂ ਤੀਜੇ ਘਰ ਨਾਲ ਸੰਬੰਧਿਤ ਮੰਗਲ",
    "Emotional Sensitivity": "ਭਾਵਨਾਤਮਕ ਸੰਵੇਦਨਸ਼ੀਲਤਾ",
    "Moon": "ਚੰਦਰਮਾ",
    "Moon influence; source also notes Cancer connected with the 1st house": "ਚੰਦਰਮਾ ਦਾ ਪ੍ਰਭਾਵ; ਸਰੋਤ ਵਿੱਚ ਇਹ ਵੀ ਨੋਟ ਕੀਤਾ ਕਿ ਪਹਿਲੇ ਘਰ ਨਾਲ ਕਰੈਂਸਰ ਸੰਬੰਧਿਤ ਹੈ",
    "Affectionate & Relationship-Oriented Nature": "ਸਨਮਰਧੀ & ਸੰਬੰਧ-ਛੋਹਵਾਂ ਪ੍ਰਵਿਰਿੱਤੀ",
    "Warm & Supportive Nature": "ਗਰਮਜੋਸ਼ & ਸਮਰਥਨਸ਼ੀਲ ਸੁਭਾਉ",
    "Independent / Detached Tendencies": "ਸੁਤੰਤਰ / ਵੱਖਰੀ ਪ੍ਰਵਿਰਿੱਤੀ",
    "Rahu": "ਰਾਹੁ",
    "associated planet": "ਸੰਬੰਧਿਤ ਗ੍ਰਹਿ",
    "Ketu": "ਕੇਤੂ",
    "Saturn": "ਸ਼ਨੀ",
    "Sun": "ਸੂਰਜ",
    "Reserved / Practical Nature": "ਸੰਕੁਚਿਤ / ਵਾਸਤਵਿਕ ਸੁਭਾਉ",
    "Persistent / Determined Nature": "ਸਥਿਰ / ਨਿਰਧਾਰਿਤ ਸੁਭਾਉ",
    "Relationships & Marriage": "ਸੰਬੰਧ & ਵਿਆਹ",
    "Relationship Boundary Challenges": "ਸੰਬੰਧ ਸੀਮਾ ਚੁਣੌਤੀਆਂ",
    "Supportive Relationship Bond": "ਸਹਾਇਕ ਸੰਬੰਧ ਬਾਂਧਨ",
    "Private / Complex Relationship Phase": "ਨਿੱਜੀ / ਜਟਿਲ ਸੰਬੰਧ ਪੜਾਅ",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "ਸਤਰਾਂ ਵਿੱਚ 5,9,11; 5,11; ਅਤੇ 5,8,11 ਨੂੰ ਵੀ ਸਾਫ਼/ਸਹਾਇਕ ਸੰਬੰਧ ਦੇ ਰੂਪ ਵਿੱਚ ਦੱਸਿਆ ਗਿਆ ਹੈ।",
    "Relationship Conflict / Reactive Dynamics": "ਸੰਬੰਧੀ ਵਿਵਾਦ / ਪ੍ਰਤੀਕਿਰਿਆਤਮਕ ਗਤੀਵਿਧੀਆਂ",
    "Marriage Prospects": "ਵਿਆਹ ਦੀ ਸੰਭਾਵਨਾ",
    "Marriage Through Known Circle": "ਜਾਣ-ਪਛਾਣ ਵਾਲੇ ਵਲਾਇਕੇ ਦੁਆਰਾ ਵਿਆਹ",
    "Supportive Marriage Circumstances": "ਸਹਾਇਕ ਵਿਆਹੀ ਪਰਿਸਥਿਤੀਆਂ",
    "Marriage Delay Indicators": "ਵਿਆਹ ਦੇ ਦਿੱਲੀਲ ਸੰਕੇਤ",
    "In DBA": "ਡੀਬੀਏ ਵਿੱਚ",
    "Emotional Distance in Relationship": "ਸੰਬੰਧ ਵਿੱਚ ਭਾਵਨਾਤਮਕ ਦੂਰੀ",
    "Reconciliation Indicators": "ਪੁਨਰਮਿਲਨ ਸੰਕੇਤ",
    "Use with the preceding relationship/separation combination.": "ਪਿਛਲੇ ਸੰਬੰਧ/ਵਿਚੋੜੇ ਦੇ ਸੁਮੇਲ ਨਾਲ ਵਰਤੋਂ ਕਰੋ।",
    "Marital Transition / Separation Indicators": "ਵਿਆਹੀ ਪਰਿਵਰਤਨ / ਵਿਛੋੜੇ ਦੇ ਸੰਕੇਤ",
    "Reduced Support for Marriage": "ਵਿਆਹ ਲਈ ਘੱਟ ਸਹਾਇਤਾ",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "ਤਾਕਤਵਰ ਹੁੰਦਾ ਹੈ ਜਦੋਂ 1,6,10 ਨੂੰ ਕਈ ਸੰਬੰਧਿਤ ਗ੍ਰਹਾਂ/ਸੂਚਕਾਂ ਦੁਆਰਾ ਦੁਹਰਾਇਆ ਜਾਂਦਾ ਹੈ।",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "ਤਾਕਤਵਰ ਹੁੰਦਾ ਹੈ ਜਦੋਂ 7ਵਾਂ ਕੱਸਪ ਲਾਰਡ ਵੀ 1,6,10 ਦਾ ਸੂਚਕ ਹੋਵੇ।",
    "Relocation After Marriage": "ਵਿਆਹ ਤੋਂ ਬਾਅਦ ਦੀ ਰਿਹਾਇਸ਼",
    "Relocation to a Distant / Unfamiliar Place": "ਇਕ ਦੂਰਲੇ / ਅਣਜਾਣ ਸਥਾਨ 'ਤੇ ਸਥਾਨਾਂਤਰਣ",
    "Non-Traditional Relationship Pattern": "ਗੈਰ-ਰਵਾਇਤੀ ਰਿਸ਼ਤੇ ਦਾ ਰੂਪ",
    "Education & Learning": "ਸਿੱਖਿਆ ਅਤੇ ਸਿਖਲਾਈ",
    "Education Prospects": "ਸਿੱਖਿਆ ਦੇ ਮੌਕੇ",
    "Strong Education Potential": "ਮਜ਼ਬੂਤ ਸਿੱਖਿਆ ਦੀ ਸੰਭਾਵਨਾ",
    "Management / Professional Higher Education Potential": "ਪ੍ਰਬੰਧਨ / ਪੇਸ਼ੇਵਰ ਉੱਚ ਸਿੱਖਿਆ ਦੀ ਸੰਭਾਵਨਾ",
    "Profession Indicators": "ਪੇਸ਼ੇ ਦੇ ਦਰਸਕ",
    "Astrology / Astrologer": "ਜ੍ਯੋਤਿਸ਼ / ਜ੍ਯੋਤਿਸ਼ੀ",
    "Mercury": "ਬੁੱਧ",
    "profession modifier": "ਪੇਸ਼ੇ ਦਾ ਸੋਧਕ",
    "Jupiter": "ਗੁਰੂ (ਬ੍ਰਹਸਪਤੀ)",
    "Teacher / Educator": "ਅਧਿਆਪਕ / ਸਿੱਖਣ ਵਾਲਾ",
    "Higher-education support: 1,2,4,9,11": "ਉੱਚ ਸਿੱਖਿਆ ਦਾ ਸਮਰਥਨ: 1,2,4,9,11",
    "Writer / Professional Writing": "ਲੇਖਕ / ਪੇਸ਼ੇਵਰ ਲਿਖਾਈ",
    "Income Support Through Profession": "ਪੇਸ਼ੇ ਰਾਹੀਂ ਆਮਦਨ ਦਾ ਸਮਰਥਨ",
    "Medical / Healthcare Profession": "ਚਿਕਿਤਸਾ / ਸਿਹਤ ਸੇਵਾ ਦਾ ਪੇਸ਼ਾ",
    "Stronger professional quality: 5,9,11 + 6,8,12": "ਮਜ਼ਬੂਤ ਪੇਸ਼ੇਵਰ ਗੁਣ: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "ਪੇਸ਼ੇਵਰ ਸਫਲਤਾ ਦਾ ਸਮਰਥਨ: 6,8,12 + 10,11 ਜਾਂ +11 ਜਾਂ +9,11",
    "Engineer": "ਇੰਜੀਨੀਅਰ",
    "Scientist": "ਵਿਗਿਆਨੀ",
    "Research / Inventions / Deep Analysis": "ਖੋਜ / ਆਵਿਸ਼ਕਾਰ / ਡੂੰਘੀ ਵਿਸ਼ਲੇਸ਼ਣ",
    "Recognition Through Research / Innovation": "ਖੋਜ / ਨਵੀਨਤਾ ਰਾਹੀਂ ਮਾਨਤਾ",
    "Information Technology": "ਜਾਣਕਾਰੀ ਤਕਨਾਲੋਜੀ",
    "Higher-education support: 2,4,5,9,11": "ਉੱਚ-ਸਿੱਖਿਆ ਸਹਾਇਤਾ: 2,4,5,9,11",
    "Lawyer / Legal Profession": "ਵਕੀਲ / ਕਾਨੂੰਨੀ ਪੇਸ਼ਾ",
    "Architect": "ਵਾਸਤੁਕਾਰ",
    "Builder / Construction": "ਨਿਰਮਾਤਾ / ਨਿਰਮਾਣ",
    "Property / Real-Estate Professional": "ਜਾਇਦਾਦ / ਰੀਅਲ-ਸਟੇਟ ਪੇਸ਼ੇਵਰ",
    "Property purchase activity: 4,11,12": "ਜਾਇਦਾਦ ਖਰੀਦਣ ਦੀ ਗਤੀਵਿਧੀ: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "ਜਾਇਦਾਦ ਵਿਕਰੀ ਦੀ ਗਤੀਵਿਧੀ: 3,5,10 ਸਤਰਨ ਅਤੇ ਮਾਰਸ ਨਾਲ",
    "Interior Designer / Decorator": "ਅੰਦਰੂਨੀ ਡਿਜ਼ਾਈਨਰ / ਸਜਾਵਟਕਾਰ",
    "Creativity / Innovation": "ਰਚਨਾਤਮਕਤਾ / ਨਵੀਨਤਾ",
    "Politics / Public Leadership": "ਰਾਜਨੀਤੀ / ਜਨਤਕ ਨੇਤ੍ਰਿਤਵ",
    "Chartered Accountant": "ਚਾਰਟਡ ਅਕਾਉਂਟੈਂਟ",
    "Data Management / Business Management": "ਡਾਟਾ ਪ੍ਰਬੰਧਨ / ਵਪਾਰ ਪ੍ਰਬੰਧਨ",
    "Chef / Culinary Profession": "ਸ਼ੈਫ / ਰਸੋਈ ਪੇਸ਼ਾ",
    "Benefic planet": "ਲਾਭਦਾਇਕ ਗ੍ਰਹਿ",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "ਦੂਜੇ ਘਰ ਵਿੱਚ ਲਾਭਦਾਇਕ ਜਾਂ ਦੂਜੇ ਘਰ ਨੂੰ ਲਾਭਦਾਇਕ ਤੌਰ 'ਤੇ ਪ੍ਰਭਾਵਤ ਕਰਨਾ",
    "International / continental cuisine: +9,3,12": "ਅੰਤਰਰਾਸ਼ਟਰ / ਖੇਤੀਬਾੜੀ ਭੋਜਨ: +9,3,12",
    "Correctional / Institutional Administration": "ਸਹੀਕਰਨ / ਸੰਸਥਾਗਤ ਪ੍ਰਬੰਧਨ",
    "Journalist / Media Professional": "ਅਖਬਾਰਚੀ / ਮੀਡਿਆ ਪੇਸ਼ੇਵਰ",
    "Investigative / crime reporting: +7,8,12": "ਜਾਂਚ/ਅਪਰਾਧ ਰਿਪੋਰਟਿੰਗ: +7,8,12",
    "Political reporting: +1,10,11": "ਰਾਜਨੀਤਿਕ ਰਿਪੋਰਟਿੰਗ: +1,10,11",
    "Sports reporting: +5,10": "ਖੇਡ ਰਿਪੋਰਟਿੰਗ: +5,10",
    "Creative Writer": "ਰਚਨਾਤਮਕ ਲੇਖਕ",
    "Creativity: +5,9": "ਰਚਨਾਤਮਕਤਾ: +5,9",
    "Artistic writing: 5,11": "ਕਲਾਤਮਕ ਲਿਖਾਈ: 5,11",
    "Mystery / occult / deep subjects: 8,12": "ਰਹੱਸ / ਅਜੀਬ / ਗਹਿਰੇ ਵਿਸ਼ੇ: 8,12",
    "Legal Matters": "ਕਾਨੂੰਨੀ ਮਾਮਲੇ",
    "Legal Dispute Indicators": "ਕਾਨੂੰਨੀ ਵਿਵਾਦ ਸੰਕੇਤ",
    "Supportive Legal Matter Indicators": "ਸਹਾਇਕ ਕਾਨੂੰਨੀ ਮਾਮਲੇ ਦੇ ਸੰਕੇਤ",
    "Challenging Legal Matter Indicators": "ਚੁਣੌਤੀਪੂਰਨ ਕਾਨੂੰਨੀ ਮਾਮਲੇ ਦੇ ਸੰਕੇਤ",
    "Legal Relief Indicators": "ਕਾਨੂੰਨੀ ਰਾਹਤ ਸੰਕੇਤ",
    "5,9 acts as a facilitator.": "5,9 ਸਹੂਲਤਕਾਰ ਵਜੋਂ ਕੰਮ ਕਰਦੇ ਹਨ.",
    "Property & Residence": "ਸੰਪਤੀ ਅਤੇ ਨਿਵਾਸ",
    "Property Purchase Prospects": "ਸੰਪਤੀ ਖਰੀਦਣ ਦੀ ਸੰਭਾਵਨਾ",
    "property modifier": "ਸੰਪਤੀ ਸੰਸ਼ੋਧਕ",
    "Source notes aspect, transit, conjunction and DBA involvement": "ਸਰੋਤ ਨੋਟਸ ਪਾਸਾ, ਆਵਾਜਾਈ, ਸੰਗਠਨ ਅਤੇ DBA ਸ਼ਾਮਿਲ ਕਰਦਾ ਹੈ",
    "Property Through Financing / Loan": "ਫਾਇਨੈਂਸਿੰਗ/ਲੋਨ ਰਾਹੀਂ ਸੰਪਤੀ",
    "Loan repayment/completion support: +4,11": "ਲੋਨ ਮੁਅੱਤ / ਸਮਾਪਤੀ ਸਹਾਇਤਾ: +4,11",
    "Property Through Institutional / Personal Support": "ਸੰਗਠਨਾਤਮਕ / ਨਿੱਜੀ ਸਹਾਇਤਾ ਰਾਹੀਂ ਸੰਪਤੀ",
    "Property Through Gift / Inheritance": "ਉਪਹਾਰ / ਵਿਰਾਸਤ ਰਾਹੀਂ ਸੰਪਤੀ",
    "Property Purchase in Stages": "ਪੜਾਅਵਾਰ ਸੰਪਤੀ ਦੀ ਖਰੀਦ",
    "Government / Institution-Allotted Property": "ਸਰਕਾਰ / ਸੰਸਥਾ-ਵੰਡ ਕੀਤੀ ਸੰਪਤੀ",
    "Commercial Property Purchase": "ਵਪਾਰਕ ਸੰਪਤੀ ਖਰੀਦ",
    "Rental Income Potential": "ਕਿਰਾਏ ਦੀ ਆਮਦਨੀ ਦੀ ਸੰਭਾਵਨਾ",
    "Considering a Residence Change": "ਰਹਿਣ-ਸਥਾਨ ਬਦਲਣ ਬਾਰੇ ਸੋਚਣਾ",
    "Change of Residence": "ਰਹਿਣ-ਸਥਾਨ ਬਦਲਣਾ",
    "Separative planets": "ਵੱਖਰੇ ਗ੍ਰਹਿ",
    "Property Through Family / Marriage Arrangement": "ਪਰਿਵਾਰ / ਵਿਆਹ ਦੇ ਵਿਵਸਥਾ ਰਾਹੀਂ ਸੰਪਤੀ",
    "Property Ownership / Possession Challenges": "ਸੰਪਤੀ ਦੀ ਮਲਕੀਅਤ / ਮਲਕਾਣੇ ਦੀਆਂ ਚੁਣੌਤੀਆਂ",
    "Property Conflict / Government Intervention": "ਸੰਪਤੀ ਸੰਗਰਾਮ / ਸਰਕਾਰ ਦਖ਼ਲਅੰਦਾਜ਼ੀ",
    "Property Dispute / Litigation Indicators": "ਸੰਪਤੀ ਵਿਰੋਧ / ਮਥੱਥੇ ਦੇ ਸੁਚਕ",
    "Venus": "ਸ਼ੁੱਕਰ",
    "source modifier": "ਸਰੋਤ ਪਰਿਵਰਤਕ",
    "Do not infer gender in public UI": "ਸਰਵਜਨਿਕ UI ਵਿੱਚ ਲਿੰਗ ਦਾ ਅਨੁਮਾਨ ਨਾ ਲਗਾਓ",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "ਬੁੱਧ ਅਤੇ ਦੁਹਰਾ ਚਿੰਹ ਨਾਲ, ਸਰੋਤ ਦੁਹਰਾਏ ਗਏ / ਅਨੇਕ ਮੁੱਦਿਆਂ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "ਬ੍ਰਹਸਪਤਿ ਅਤੇ ਦੁਹਰਾ ਚਿੰਹ ਨਾਲ, ਸਰੋਤ ਦੁਹਰਾਏ ਗਏ / ਅਨੇਕ ਮੁੱਦਿਆਂ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ",
    "Supportive Property Dispute Indicators": "ਸਮਰਥਕ ਸੰਪਤੀ ਵਿਰੋਧ ਦੇ ਸੁਚਕ",
    "Challenging Property Dispute Indicators": "ਮੁਸ਼ਕਿਲ ਸੰਪਤੀ ਵਿਵਾਦ ਸੰਕੇਤ",
    "Property Division / Partition": "ਸੰਪਤੀ ਵੰਡ / ਵਿਭਾਜਨ",
    "Property Sale Prospects": "ਸੰਪਤੀ ਵਿਕਰੀ ਦੇ ਮੌਕੇ",
    "Favourable Property Sale Conditions": "ਲਾਭਕਾਰੀ ਸੰਪਤੀ ਵਿਕਰੀ ਦੀਆਂ ਸਥਿਤੀਆਂ",
    "Less Supportive Property Sale Conditions": "ਘੱਟ ਸਹਾਇਕ ਸੰਪਤੀ ਵਿਕਰੀ ਦੀਆਂ ਸਥਿਤੀਆਂ",
    "Vehicle": "ਵਾਹਨ",
    "Vehicle Acquisition Prospects": "ਵਾਹਨ ਅਧਿਗ੍ਰਹਣ ਦੇ ਮੌਕੇ",
    "primary vehicle significator": "ਮੁੱਖ ਵਾਹਨ ਸੰਕੇਤਕ",
    "Vehicle Through Financing / Loan": "ਵਾਹਨ ਫਾਇਨੈਨਸ / ਕਰਜ਼ੇ ਰਾਹੀਂ",
    "Vehicle Through Gift": "ਵਾਹਨ ਤੋਹਫੇ ਰਾਹੀਂ",
    "Venus active in DBA": "DBA ਵਿੱਚ ਸ਼ੁਕਰ ਸਰਗਰਮ",
    "Premium / Luxury Vehicle Indicators": "ਪ੍ਰੀਮੀਅਮ / ਲਗਜ਼ਰੀ ਵਾਹਨ ਸੰਕੇਤ",
    "primary factor": "ਮੁੱਖ ਕਾਰਕ",
    "Natural benefic planets": "ਕੁਦਰਤੀ ਲਾਭਕਾਰੀ ਗ੍ਰਹਿ",
    "aspecting/supporting factor": "ਅਸਪੈਕਟ ਕਰਨ ਵਾਲਾ / ਸਹਾਇਕ ਕਾਰਕ",
    "Pre-Owned Vehicle Indicators": "ਪੂਰਵ-ਮਾਲਕ ਵਾਹਨ ਸੰਕੇਤ",
    "aspecting factor": "ਅਸਪੈਕਟ ਕਰਨ ਵਾਲਾ ਕਾਰਕ",
    "Vehicle Maintenance Concerns": "ਵਾਹਨ ਦੇ ਰੱਖ-ਰਖਾਅ ਸਬੰਧੀ ਚਿੰਤਾਵਾਂ",
    "Commercial Vehicle Indicators": "ਵਪਾਰਕ ਵਾਹਨ ਸੰਕੇਤ",
    "commercial vehicle modifier": "ਵਪਾਰਕ ਵਾਹਨ ਸੋਧਕ",
    "Mercury involved or aspecting": "ਬੁੱਧ ਸ਼ਾਮਲ ਜਾਂ ਅਸਪੈਕਟ ਕਰਨ ਵਾਲਾ",
    "small commercial vehicle modifier": "ਛੋਟਾ ਵਪਾਰਕ ਵਾਹਨ ਸੋਧਕ",
    "Venus involved or aspecting": "ਸ਼ੁੱਕਰ ਸੰਬੰਧਿਤ ਜਾਂ ਪ੍ਰਭਾਵਿਤ",
    "heavy commercial vehicle modifier": "ਭਾਰੀ ਵਪਾਰਕ ਵਾਹਨ ਸੋਧਕ",
    "Saturn involved or aspecting": "ਸ਼ਨੀ ਸੰਬੰਧਿਤ ਜਾਂ ਪ੍ਰਭਾਵਿਤ",
    "Vehicle Security / Possession Caution": "ਵਾਹਨ ਸੁਰੱਖਿਆ / ਮਾਲਕੀ ਚੇਤਾਵਨੀ",
    "Strong Vehicle Security / Possession Caution": "ਮਜ਼ਬੂਤ ਵਾਹਨ ਸੁਰੱਖਿਆ / ਮਾਲਕੀ ਚੇਤਾਵਨੀ",
    "Vehicle Recovery / Resolution Indicators": "ਵਾਹਨ ਮੁੜ ਪ੍ਰਾਪਤੀ / ਹੱਲ ਦਰਸਾਉਣ ਵਾਲੇ ਸੰਕੇਤ",
    "Vehicle Loan Repayment Challenges": "ਵਾਹਨ ਲੋਣ ਚੁਕਾਣ ਸੰਬੰਧੀ ਚੁਣੌਤੀਆਂ",
    "Stronger while the combination remains active in DBA": "ਜਦੋਂ ਤੱਕ ਸੰਗੀਤਕ ਸੰਯੋਗ DBA ਵਿੱਚ ਸਰਗਰਮ ਹੈ, ਇਹ ਮਜ਼ਬੂਤ ਰਹਿੰਦਾ ਹੈ",
    "Improvement/return after payment: 4,6,11": "ਭੁਗਤਾਨ ਤੋਂ ਬਾਅਦ ਸੁਧਾਰ / ਵਾਪਸੀ: 4,6,11",
    "Vehicle Sale Prospects": "ਵਾਹਨ ਵਿਕਰੀ ਦੀਆਂ ਸੰਭਾਵਨਾਵਾਂ",
    "Insurance Claim Indicators": "ਬੀਮਾ ਦਾਅਵਾ ਸੰਕੇਤ",
    "Travel, Visa & Foreign Matters": "ਯਾਤਰਾ, ਵੀਜ਼ਾ & ਵਿਦੇਸ਼ੀ ਮਾਮਲਿਆਂ",
    "Travel Prospects": "ਯਾਤਰਾ ਸੰਭਾਵਨਾਵਾਂ",
    "travel modifier": "ਯਾਤਰਾ ਸੋਧਕ",
    "Short-Distance Travel": "ਛੋਟੀ ਦੂਰੀ ਦੀ ਯਾਤਰਾ",
    "Long-Distance Travel": "ਲੰਮੀ ਦੂਰੀ ਦੀ ਯਾਤਰਾ",
    "Change in Travel Plans / Route": "ਯਾਤਰਾ ਯੋਜ਼ਨਿਆਂ / ਰਸਤੇ ਵਿੱਚ ਬਦਲਾਅ",
    "Separative planet": "ਵਿਭਾਜਕ ਗ੍ਰਹਿ",
    "International Travel Requiring Greater Adjustment": "ਅੰਤਰਰਾਸ਼ਟਰੀ ਯਾਤਰਾ ਜੋ ਵੱਡੀ ਸਹਿਮਤੀ ਦੀ ਮੰਗ ਕਰਦੀ ਹੈ",
    "Malefic planets": "ਅਪਿੜ ਗ੍ਰਹਿ",
    "Supportive International Travel": "ਸਹਾਇਕ ਅੰਤਰਰਾਸ਼ਟਰੀ ਯਾਤਰਾ",
    "Benefic planets": "ਲਾਭਕਾਰੀ ਗ੍ਰਹ",
    "Return Home / Homecoming": "ਘਰ ਵਾਪਸੀ / ਘਰ ਆਉਣਾ",
    "Visa Prospects": "ਵੀਜ਼ਾ ਸੰਭਾਵਨਾਵਾਂ",
    "Tourist Visa Prospects": "ਟੂਰਿਸਟ ਵੀਜ਼ਾ ਸੰਭਾਵਨਾਵਾਂ",
    "Study Visa Prospects": "ਅਧਿਐਨ ਵੀਜ਼ਾ ਸੰਭਾਵਨਾਵਾਂ",
    "Business Visa Prospects": "ਕਾਰੋਬਾਰੀ ਵੀਜ਼ਾ ਸੰਭਾਵਨਾਵਾਂ",
    "Import/export business: +2,7,10,11": "ਆਯਾਤ/ਨਿਰਯਾਤ ਵਪਾਰ: +2,7,10,11",
    "Work Visa Prospects": "ਵਰਕ ਵੀਜ਼ਾ ਸੰਭਾਵਨਾਵਾਂ",
    "Partner Abroad Indicators": "ਵਿਦੇਸ਼ ਵਿੱਚ ਭਾਗੀਦਾਰ ਦੇ ਸੰਕੇਤ",
    "Marriage Abroad Prospects": "ਵਿਦੇਸ਼ ਵਿੱਚ ਵਿਆਹ ਦੀ ਸੰਭਾਵਨਾਵਾਂ",
    "Professional / Conference Travel": "ਪੇਸ਼ਾਵਰ / ਸੈਮੀਨਾਰ ਯਾਤਰਾ",
    "Sports-Related Travel": "ਖੇਡ ਸੰਬੰਧੀ ਯਾਤਰਾ",
    "Family & Life Development": "ਪਰਿਵਾਰ ਅਤੇ ਜੀਵਨ ਵਿਕਾਸ",
    "Family Expansion Prospects": "ਪਰਿਵਾਰ ਵਾਧੇ ਦੀ ਸੰਭਾਵਨਾਵਾਂ"
  },
  "or": {
    "Event Analysis": "ଘଟଣା ବିଶ୍ଳେଷଣ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "ପାରମ୍ପରିକ ନାଡ଼ୀ ଘର ଗୋଷ୍ଠୀ ଏବଂ ସଂପୃକ୍ତ ଗ୍ରହଗୁଡ଼ିକୁ ଦେଖିବା ପାଇଁ ଏକ ଶ୍ରେଣୀ ଏବଂ ଘଟଣା ଚୟନ କରନ୍ତୁ।",
    "Category": "ଶ୍ରେଣୀ",
    "Event": "ଘଟଣା",
    "Locked": "ବନ୍ଦ",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "ସମସ୍ତ ଶ୍ରେଣୀ ଏବଂ ଘଟଣାଗୁଡ଼ିକ ଦେଖାଯାଉଛି। ବନ୍ଦ ଘଟଣା ବିଶ୍ଳେଷଣ ବିକଳ୍ପଗୁଡ଼ିକୁ ଖୋଲିବାକୁ ପ୍ରୀମିୟମ୍‌ରେ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ।",
    "Supportive indication": "ସମର୍ଥକ ସୂଚନା",
    "Challenging indication": "ଚ୍ୟାଲେଞ୍ଜିଂ ସୂଚନା",
    "Neutral indication": "ନିଷ୍ପକ୍ଷ ସୂଚନା",
    "Event groups": "ଘଟଣା ଗୋଷ୍ଠୀ",
    "Good": "ଭଲ",
    "Bad": "ଖରାପ",
    "Supportive": "ସମର୍ଥକ",
    "Challenging supportive": "ଚ୍ୟାଲେଞ୍ଜିଂ ସମର୍ଥକ",
    "Planets involved": "ସଂପୃକ୍ତ ଗ୍ରହଗୁଡ଼ିକ",
    "involved": "ସଂପୃକ୍ତ",
    "Pro": "ପ୍ରୋ",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "ଏହି ବ୍ୟାଖ୍ୟାଗୁଡ଼ିକ ପାରମ୍ପରିକ ଜ୍ଞାତିଶାସ୍ତ୍ରୀୟ ସିଦ୍ଧାନ୍ତରେ ଆଧାରିତ ଅଟିଏ ଏବଂ ସୂଚନାମୂଳକ ଏବଂ ଶିକ୍ଷାମୂଳକ ଉଦ୍ଦେଶ୍ୟରେ ଥିବାକୁ ହେଉଛି। ସେଗୁଡ଼ିକ ପ୍ରବୃତ୍ତି ଏବଂ ସମ୍ଭାବନାକୁ ସୂଚିତ କରନ୍ତି, ନିଶ୍ଚିତ ପରିଣାମକୁ ନୁହେଁ। ଆଇନ, ଆର୍ଥିକ, ଚିକିତ୍ସା ବା ଅନ୍ୟାନ୍ୟ ପେଶାଗତ କାର୍ଯ୍ୟସାଧନ ପାଇଁ, ଯୋଗ୍ୟ ପ୍ରଶିକ୍ଷିତ ବୃତ୍ତିଜ୍ଞଙ୍କ ସହିତ ପରାମର୍ଶ କରନ୍ତୁ।",
    "Career, Work & Business": "କ୍ୟାରିଅର୍, କାମ ଏବଂ ବ୍ୟବସାୟ",
    "Employment Prospects": "ଚାକିରି ସମ୍ଭାବନା",
    "Business Prospects": "ବ୍ୟବସାୟ ସମ୍ଭାବନା",
    "Earning Potential": "ଆୟ ସମ୍ଭାବନା",
    "Business Challenges": "ବ୍ୟବସାୟ ଚ୍ୟାଲେଞ୍ଜ୍‌ଗୁଡ଼ିକ",
    "Business Recovery Indicators": "ବ୍ୟବସାୟ ପୁନରୁଦ୍ଧାର ସୂଚକ",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 ବ୍ୟବସାୟ କଷ୍ଟପରେ ପୁନର୍ବାପାର/ପୁନର୍ବାସନ ସମର୍ଥନ ଭାବେ କାର୍ଯ୍ୟ କରେ।",
    "Administration Career": "ପ୍ରଶାସନ ଜ୍ଞାତିଶାସ୍ତ୍ରୀୟ କ୍ୟାରିଅର୍",
    "Employment Challenges": "ଚାକିରି ସମସ୍ୟାଗୁଡ଼ିକ",
    "Professional Obstacles / Delays": "ପେଶାଗତ ବାଧା / ବିଳମ୍ବ",
    "Professional Recognition Challenges": "ପେଶାଗତ ସ୍ୱୀକୃତି ସମସ୍ୟାଗୁଡ଼ିକ",
    "Financial Pressure": "ଆର୍ଥିକ ଚାପ",
    "Financial Return Cycle": "ଆର୍ଥିକ ବାପଟ ସୂଚନା ପରିଚଳନା",
    "Supportive Career Change": "ସମର୍ଥକ କ୍ୟାରିଅର୍ ପରିବର୍ତ୍ତନ",
    "Favourable Career Transition": "ଅନୁକୂଳ କ୍ୟାରିୟର ପରିବର୍ତ୍ତନ",
    "Next DBA": "ପରବର୍ତ୍ତୀ ଡିବିଏ",
    "Challenging Career Transition": "ଚ୍ୟାଲେଞ୍ଜିଂ କ୍ୟାରିୟର ପରିବର୍ତ୍ତନ",
    "Workplace Transfer / Relocation": "କାର୍ଯ୍ୟସ୍ଥଳ ସ୍ଥାନାନ୍ତରଣ / ସ୍ଥାନାନ୍ତରଣ",
    "Return to Previous Workplace / Location": "ପୂର୍ବବର୍ତ୍ତୀ କାର୍ଯ୍ୟସ୍ଥଳ/ସ୍ଥାନକୁ ଫେରନ୍ତୁ",
    "Personality & Temperament": "ବ୍ୟକ୍ତିତ୍ୱ ଏବଂ ସ୍ୱଭାବ",
    "Assertive / Intense Temperament": "ଦୃଢ / ତୀବ୍ର ସ୍ୱଭାବ",
    "Mars": "ମଙ୍ଗଳ ଗ୍ରହ",
    "modifier": "ମୋଡିଫାୟର୍",
    "Mars connected with the 1st or 3rd house": "ମଙ୍ଗଳ 1ମ କିମ୍ୱା 3ୟ ଘର ସହିତ ସଂଯୁକ୍ତ",
    "Emotional Sensitivity": "ଭାବପ୍ରବଣ ସମ୍ବେଦନଶୀଳତା",
    "Moon": "ଚନ୍ଦ୍ର",
    "Moon influence; source also notes Cancer connected with the 1st house": "ଚନ୍ଦ୍ର ପ୍ରଭାବ; ସୂତ୍ରରୁ ଏହା ମଧ୍ୟ ଜଣାପଡିଛି ଯେ କର୍କଟ 1ମ ଘର ସହିତ ଜଡିତ",
    "Affectionate & Relationship-Oriented Nature": "ସ୍ନେହପୂର୍ଣ୍ଣ ଏବଂ ସମ୍ପର୍କ ଭିତ୍ତିକ ପ୍ରକୃତି",
    "Warm & Supportive Nature": "ଉଷ୍ମ ଏବଂ ସହାୟକ ପ୍ରକୃତି",
    "Independent / Detached Tendencies": "ସ୍ୱାଧୀନ / ବିଚ୍ଛିନ୍ନ ପ୍ରବୃତ୍ତି",
    "Rahu": "ରାହୁ",
    "associated planet": "ଜଡିତ ଗ୍ରହ",
    "Ketu": "କେତୁ",
    "Saturn": "ଶନି",
    "Sun": "ସୂର୍ଯ୍ୟ",
    "Reserved / Practical Nature": "ସଂରକ୍ଷିତ / ବ୍ୟବହାରିକ ପ୍ରକୃତି",
    "Persistent / Determined Nature": "ସ୍ଥିର/ନିର୍ଦ୍ଧାରିତ ପ୍ରକୃତି",
    "Relationships & Marriage": "ସମ୍ପର୍କ ଏବଂ ବିବାହ",
    "Relationship Boundary Challenges": "ସମ୍ପର୍କ ସୀମା ଚ୍ୟାଲେଞ୍ଜ",
    "Supportive Relationship Bond": "ସହାୟକ ସମ୍ପର୍କ ବନ୍ଧନ",
    "Private / Complex Relationship Phase": "ଂଶୀକ / ଜଟିଳ ସମ୍ପର୍କ ପର୍ଯ୍ୟାୟ",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "ଉତ୍ସ ଏହାକୁ ଅଧିକ ସ୍ୱଚ୍ଛ/ସହାୟକ ସମ୍ପର୍କ ପରିବର୍ତ୍ତନସ୍ଥଳ ଭାବରେ 5,9,11; 5,11; ଏବଂ 5,8,11 ଭାବରେ ମଧ୍ୟ ସୂଚିତ କରିଛି।",
    "Relationship Conflict / Reactive Dynamics": "ସମ୍ପର୍କ ସଂଘର୍ଷ / ପ୍ରତିକ୍ରିୟାଶୀଳ ଗତିବିଧି",
    "Marriage Prospects": "ବିବାହ ସମ୍ଭାବନା",
    "Marriage Through Known Circle": "ପରିଚିତ ବୃତ୍ତର ମାଧ୍ୟମରେ ବିବାହ",
    "Supportive Marriage Circumstances": "ସହାୟକ ବିବାହ ପରିସ୍ଥିତି",
    "Marriage Delay Indicators": "ବିବାହ ବିଳମ୍ବ ସଂକେତ",
    "In DBA": "DBA ରେ",
    "Emotional Distance in Relationship": "ସମ୍ପର୍କରେ ଭାବନାତ୍ମକ ଦୂରତା",
    "Reconciliation Indicators": "ସମ୍ମିଳନ ସଂକେତ",
    "Use with the preceding relationship/separation combination.": "ପୂର୍ବରୁ ଥିବା ସମ୍ପର୍କ/ବିଚ୍ଛେଦ ସଂଯୋଜନ ସହିତ ବ୍ୟବହାର କରନ୍ତୁ।",
    "Marital Transition / Separation Indicators": "ବିବାହ ପରିବର୍ତ୍ତନ / ବିଚ୍ଛେଦ ସଂକେତ",
    "Reduced Support for Marriage": "ବିବାହ ପାଇଁ ସହାୟକତା କମିବା",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "ଯେତେବେଳେ 1,6,10 ପୁନରାବୃତ୍ତି ହୁଏ ଓ ବିଭିନ୍ନ ସମ୍ବନ୍ଧିତ ଗ୍ରହ/ଚିହ୍ନକର୍ତ୍ତା ମାଧ୍ୟମରେ ଏହା ଶକ୍ତିଶାଳୀ ହୁଏ।",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "ଯେତେବେଳେ 7ମ କପସ୍ ଲୋର୍ଡ ମଧ୍ୟ 1,6,10 ସୂଚିତ କରେ, ଏହା ଶକ୍ତିଶାଳୀ ହୁଏ।",
    "Relocation After Marriage": "ବିବାହ ପରେ ସ୍ଥାନାନ୍ତରଣ",
    "Relocation to a Distant / Unfamiliar Place": "ଦୂର / ପରିଚିତ ନହୋଇଥିବା ସ୍ଥାନକୁ ପୁନଃସ୍ଥାନାନ୍ତରଣ",
    "Non-Traditional Relationship Pattern": "ଅପରମ୍ପରାଗତ ସମ୍ପର୍କ ପ୍ରଣାଳୀ",
    "Education & Learning": "ଶିକ୍ଷା ଏବଂ ଶିଖ୍ୟା",
    "Education Prospects": "ଶିକ୍ଷାର ସମ୍ଭାବନା",
    "Strong Education Potential": "ଦୃଢ ଶିକ୍ଷା ସମ୍ଭାବନା",
    "Management / Professional Higher Education Potential": "ପ୍ରବନ୍ଧନ / ପେଶାଗତ ଉଚ୍ଚ ଶିକ୍ଷା ସମ୍ଭାବନା",
    "Profession Indicators": "ଚେଷ୍ଟା ସୂଚକ",
    "Astrology / Astrologer": "ଜ୍ଞାତା / ଜ୍ୟୋତିଷ",
    "Mercury": "ବୁଧ",
    "profession modifier": "ପେଶା ସଂପାଦକ",
    "Jupiter": "ବୃହସ୍ପତି",
    "Teacher / Educator": "ଶିକ୍ଷକ / ଶିକ୍ଷାଦାତା",
    "Higher-education support: 1,2,4,9,11": "ଉଚ୍ଚ ଶିକ୍ଷା ଶହାୟତା: 1,2,4,9,11",
    "Writer / Professional Writing": "ଲେଖକ / ପେଶାଗତ ଲେଖନ",
    "Income Support Through Profession": "ପେଶା ମାଧ୍ୟମରେ ଆୟ ଶହାୟତା",
    "Medical / Healthcare Profession": "ଚିକିତ୍ସା / ସ୍ୱାସ୍ଥ୍ୟସେବା ପେଶା",
    "Stronger professional quality: 5,9,11 + 6,8,12": "ଶକ୍ତିଶାଳୀ ପେଶାଗତ ଗୁଣ: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "ପେଶାଗତ ସଫଳତା ଶହାୟତା: 6,8,12 + 10,11 କିମ୍ବା +11 କିମ୍ବା +9,11",
    "Engineer": "ଇଞ୍ଜିନିୟର",
    "Scientist": "ବୈଜ୍ଞାନିକ",
    "Research / Inventions / Deep Analysis": "ଗବେଷଣା / ଆବିଷ୍କାର / ଗଭୀର ଖୋଜଖବର",
    "Recognition Through Research / Innovation": "ଗବେଷଣା / ଆବିଷ୍କାର ମାଧ୍ୟମରେ ପରିଚୟ",
    "Information Technology": "ସୂଚନା ପ୍ରଯୁକ୍ତି",
    "Higher-education support: 2,4,5,9,11": "ଉଚ୍ଚ ଶିକ୍ଷା ସହାୟତା: 2,4,5,9,11",
    "Lawyer / Legal Profession": "ଆଇନଜୀବୀ / ଆଇନ ପେଶା",
    "Architect": "ଆର୍କିଟେକ୍ଟ",
    "Builder / Construction": "ନିର୍ମାପକ / ନିର୍ମାଣ",
    "Property / Real-Estate Professional": "ଜମି/ଅସ୍ତିତ୍ୱ ପେଶା",
    "Property purchase activity: 4,11,12": "ସମ୍ପତ୍ତି କ୍ରୟ କାର୍ଯ୍ୟକଳାପ: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "ସମ୍ପତ୍ତି ବିକ୍ରୟ କାର୍ଯ୍ୟକଳାପ: 3,5,10 ସହ ଶନି ଏବଂ ମଙ୍ଗଳ",
    "Interior Designer / Decorator": "ଇଣ୍ଟିରିୟର ଡିଜାଇନର / ସଜାଣା",
    "Creativity / Innovation": "ସୃଜନଶୀଳତା / ନବୋନ୍ମେଷ",
    "Politics / Public Leadership": "ରାଜନୀତି / ସାଧାରଣ ନେତୃତ୍ୱ",
    "Chartered Accountant": "ଚାର୍ଟର୍ଡ ଏକାଉଣ୍ଟାଣ୍ଟ",
    "Data Management / Business Management": "ତଥ୍ୟ ପରିଚାଳନା / ବ୍ୟବସାୟ ପରିଚାଳନା",
    "Chef / Culinary Profession": "ରାନ୍ଧଣା ବିଶେଷଜ୍ଞ / କୁଳିନାରୀ ପେଶା",
    "Benefic planet": "ଉପକାରକ ଗ୍ରହ",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "ସହାୟକ ଦ୍ୱିତୀୟ ଘରରେ ବା ସ୍ୱାଧୀନତା ଭାବେ ଦ୍ୱିତୀୟ ଘରକୁ ପ୍ରଭାବିତ କରୁଥିବା",
    "International / continental cuisine: +9,3,12": "ଆନ୍ତର୍ଜାତୀୟ / ମହାଦେଶୀୟ ଖାଦ୍ୟ: +9,3,12",
    "Correctional / Institutional Administration": "ସଂଶୋଧନ / ପ୍ରତିଷ୍ଠାନ ପରିଚାଳନା",
    "Journalist / Media Professional": "ସାମ୍ବାଦିକ / ମାଧ୍ୟମ ପେଶା",
    "Investigative / crime reporting: +7,8,12": "ଅନ୍ୱେଷଣ / ଅପରାଧ ରିପୋର୍ଟିଂ: +7,8,12",
    "Political reporting: +1,10,11": "ରାଜନୈତିକ ରିପୋର୍ଟିଂ: +1,10,11",
    "Sports reporting: +5,10": "କ୍ରୀଡା ରିପୋର୍ଟିଂ: +5,10",
    "Creative Writer": "ସୃଜନାତ୍ମକ ଲେଖକ",
    "Creativity: +5,9": "ସୃଜନଶୀଳତା: +5,9",
    "Artistic writing: 5,11": "କଳାମୟ ଲେଖନ: 5,11",
    "Mystery / occult / deep subjects: 8,12": "ରହସ୍ୟ / ଅଦୃଶ୍ୟ / ଗଭୀର ବିଷୟ: 8,12",
    "Legal Matters": "ଆଇନ ମାମଲା",
    "Legal Dispute Indicators": "ଆଇନ ଝଗଡା ସୂଚକ",
    "Supportive Legal Matter Indicators": "ସହାୟକ ଆଇନ ମାମଲା ସୂଚକ",
    "Challenging Legal Matter Indicators": "ଚ୍ୟାଲେଞ୍ଜିଂ ଆଇନ ମାମଲା ସୂଚକ",
    "Legal Relief Indicators": "ଆଇନିକ ସୁବିଧା ସୂଚକ",
    "5,9 acts as a facilitator.": "5,9 ଏକ ସହାୟକ ବାବୁରୁ କାମ କରେ।",
    "Property & Residence": "ସମ୍ପତ୍ତି ଏବଂ ରହଣୀକ୍ଷେତ୍ର",
    "Property Purchase Prospects": "ସମ୍ପତ୍ତି କ୍ରୟ ସମ୍ଭାବନା",
    "property modifier": "ସମ୍ପତ୍ତି ସଂଶୋଧକ",
    "Source notes aspect, transit, conjunction and DBA involvement": "ଉତ୍ସ ଟୀପ୍ପଣୀ, ପରିବହନ, ସଂଯୋଜନ ଏବଂ DBA ଅଂଶଗ୍ରହଣ",
    "Property Through Financing / Loan": "ଋଣ / ଆର୍ଥିକ ସହାୟତା ମାଧ୍ୟମରେ ସମ୍ପତ୍ତି",
    "Loan repayment/completion support: +4,11": "ଋଣ ପ୍ରତିପୂରଣ / ସମ୍ପୂର୍ଣ୍ଣ ସହାୟତା: +4,11",
    "Property Through Institutional / Personal Support": "ସଂସ୍ଥାଗତ / ବ୍ୟକ୍ତିଗତ ସହାୟତା ମାଧ୍ୟମରେ ସମ୍ପତ୍ତି",
    "Property Through Gift / Inheritance": "ଉପହାର / ଉତ୍ତରାଧିକାର ମାଧ୍ୟମରେ ସମ୍ପତ୍ତି",
    "Property Purchase in Stages": "ପଡା କଦମରେ ସମ୍ପତ୍ତି କ୍ରୟ",
    "Government / Institution-Allotted Property": "ସରକାର / ସଂସ୍ଥା ଦ୍ୱାରା ଅଲୋକିତ ସମ୍ପତ୍ତି",
    "Commercial Property Purchase": "ବାଣିଜ୍ୟିକ ସମ୍ପତ୍ତି କ୍ରୟ",
    "Rental Income Potential": "କିରାୟା ଆୟ ସମ୍ଭାବନା",
    "Considering a Residence Change": "ବାସସ୍ଥାନ ପରିବର୍ତ୍ତନ ବିଚାର କରୁଛନ୍ତି",
    "Change of Residence": "ବାସସ୍ଥାନ ପରିବର୍ତ୍ତନ",
    "Separative planets": "ଭିନ୍ନ ଗ୍ରହମାନେ",
    "Property Through Family / Marriage Arrangement": "ପରିବାର / ବିବାହ ବ୍ୟବସ୍ଥା ମାଧ୍ୟମରେ ସମ୍ପତ୍ତି",
    "Property Ownership / Possession Challenges": "ସମ୍ପତ୍ତି ମାଲିକାନା / ଧାରଣା ସମସ୍ୟା",
    "Property Conflict / Government Intervention": "ସମ୍ପତ୍ତି ସଂଘର୍ଷ / ସରକାରୀ ହସ୍ତକ୍ଷେପ",
    "Property Dispute / Litigation Indicators": "ସମ୍ପତ୍ତି ବିବାଦ / ମାମଲା ସୂଚକ",
    "Venus": "ଶୁକ୍ର",
    "source modifier": "ଉତ୍ସ ପରିବର୍ତ୍ତକ",
    "Do not infer gender in public UI": "ସାଧାରଣ UI ରେ ଲିଙ୍ଗ ନିଷ୍କର୍ଷ କରନ୍ତୁ ନାହିଁ",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "ସୂଚନା ଗୁଣାନ୍ଶ ପ୍ରଭୁତ୍ୱ ଓ ଦ୍ବିତୀୟ ରାଶି ସହ, ଉତ୍ସ ପୁନରାବୃତ୍ତି / ଅନେକ ସମସ୍ୟା ସୂଚିତ କରେ",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "ବୃହସ୍ପତି ଓ ଦ୍ବିତୀୟ ରାଶି ସହ, ଉତ୍ସ ପୁନରାବୃତ୍ତି / ଅନେକ ସମସ୍ୟା ସୂଚିତ କରେ",
    "Supportive Property Dispute Indicators": "ସହଯୋଗୀ ସମ୍ପତ୍ତି ବିବାଦ ସୂଚକ",
    "Challenging Property Dispute Indicators": "ଚ୍ୟାଲେଞ୍ଜିଙ୍ଗ୍ ସମ୍ପତ୍ତି ବିବାଦ ସୂଚକ",
    "Property Division / Partition": "ସମ୍ପତ୍ତି ବିଭାଜନ / ବିଭାଜନ",
    "Property Sale Prospects": "ସମ୍ପତ୍ତି ବିକ୍ରୟ ସମ୍ଭାବନା",
    "Favourable Property Sale Conditions": "ହିତାଙ୍କରୀ ସମ୍ପତ୍ତି ବିକ୍ରୟ ପରିସ୍ଥିତି",
    "Less Supportive Property Sale Conditions": "କମ୍ ସହାୟକ ସମ୍ପତ୍ତି ବିକ୍ରୟ ପରିସ୍ଥିତି",
    "Vehicle": "ଯାନ",
    "Vehicle Acquisition Prospects": "ଯାନ ଅର୍ଜନ ସମ୍ଭାବନା",
    "primary vehicle significator": "ପ୍ରାଥମିକ ଯାନ ସୂଚକ",
    "Vehicle Through Financing / Loan": "ରିଣ / ુଙ୍କ ମାଧ୍ୟମରେ ଯାନ",
    "Vehicle Through Gift": "ଉପହାର ମାଧ୍ୟମରେ ଯାନ",
    "Venus active in DBA": "DBA ରେ ବେନସ୍ ସକ୍ରିୟ",
    "Premium / Luxury Vehicle Indicators": "ପ୍ରିମିୟମ୍ / ଲକ୍ସୁରୀ ଯାନ ସୂଚକ",
    "primary factor": "ପ୍ରାଥମିକ ତତ୍ତ୍ୱ",
    "Natural benefic planets": "ପ୍ରାକୃତିକ ହିତାଙ୍କରୀ ଗ୍ରହ",
    "aspecting/supporting factor": "ଆସପେକ୍ଟିଂ / ସମର୍ଥକ ତତ୍ତ୍ୱ",
    "Pre-Owned Vehicle Indicators": "ପୂର୍ବ ଉପଯୋଗ ହୋଇଥିବା ଯାନ ସୂଚକ",
    "aspecting factor": "ସମର୍ଥକ ତତ୍ତ୍ୱ",
    "Vehicle Maintenance Concerns": "ଯାନ ରକ୍ଷାଣାବେକ୍ଷା ଚିନ୍ତା",
    "Commercial Vehicle Indicators": "ବାଣିଜ୍ୟିକ ଯାନ ସୂଚକ",
    "commercial vehicle modifier": "ବାଣିଜ୍ୟିକ ଯାନ ସଂଶୋଧକ",
    "Mercury involved or aspecting": "ବୁଧ ସମ୍ପୃକ୍ତ କିମ୍ବା ଆସପେକ୍ଟିଂ",
    "small commercial vehicle modifier": "ଛୋଟ ବାଣିଜ୍ୟିକ ଯାନ ସଂଶୋଧକ",
    "Venus involved or aspecting": "ଶୁକ୍ର ସଂଲଗ୍ନ କିମ୍ବା ପ୍ରଭାବୀ",
    "heavy commercial vehicle modifier": "ଭାରୀ ବାଣିଜ୍ୟିକ ଯାନ ଗୁଣକ",
    "Saturn involved or aspecting": "ଶନି ସଂଲଗ୍ନ କିମ୍ବା ପ୍ରଭାବୀ",
    "Vehicle Security / Possession Caution": "ଯାନ ସୁରକ୍ଷା / ମାଳିକାନା ସତର୍କତା",
    "Strong Vehicle Security / Possession Caution": "ଶକ୍ତିଶାଳୀ ଯାନ ସୁରକ୍ଷା / ମାଳିକାନା ସତର୍କତା",
    "Vehicle Recovery / Resolution Indicators": "ଯାନ ପୁନରୁଦ୍ଧାର / ସମାଧାନ ସୂଚକ",
    "Vehicle Loan Repayment Challenges": "ଯାନ ଋଣ ପୂରଣ ଚ୍ୟାଲେଞ୍ଜ",
    "Stronger while the combination remains active in DBA": "ଯେତେବେଳେ ସଂଯୋଗ DBA ରେ ସକ୍ରିୟ ରହିଥାଏ ସେତେବେଳେ ଶକ୍ତିଶାଳୀ",
    "Improvement/return after payment: 4,6,11": "ଅଦାୟ ପରେ ସୁଧାର / ଫେରା: 4,6,11",
    "Vehicle Sale Prospects": "ଯାନ ବିକ୍ରୟ ସମ୍ଭାବନା",
    "Insurance Claim Indicators": "ବୀମା ଦାବୀ ସୂଚକ",
    "Travel, Visa & Foreign Matters": "ଭ୍ରମଣ, ଭିସା ଏବଂ ବୈଦେଶିକ ମାମଲା",
    "Travel Prospects": "ଭ୍ରମଣ ସମ୍ଭାବନା",
    "travel modifier": "ଭ୍ରମଣ ଗୁଣକ",
    "Short-Distance Travel": "ସଂକ୍ଷିପ୍ତ ଦୂର ସଂଚାର",
    "Long-Distance Travel": "ଦୀର୍ଘ ଦୂର ସଂଚାର",
    "Change in Travel Plans / Route": "ଭ୍ରମଣ ଯୋଜନା / ମାର୍ଗ ବଦଳ",
    "Separative planet": "ବିଛେଦକ ଗ୍ରହ",
    "International Travel Requiring Greater Adjustment": "ଅଧିକ ସମନ୍ୱୟ ଦରକାରିଆଁ ଅନ୍ତର୍ଜାତୀୟ ଭ୍ରମଣ",
    "Malefic planets": "ଦୁଷ୍ଟ ଗ୍ରହ",
    "Supportive International Travel": "ସାହାଯ୍ୟମୂଳକ ଆନ୍ତର୍ଜାତୀୟ ଯାତ୍ରା",
    "Benefic planets": "ଉପକାରକ ଗ୍ରହମାନେ",
    "Return Home / Homecoming": "ଘରକୁ ଫେରା / ଘରକୁ ଆସିବା",
    "Visa Prospects": "ଭିସା ସମ୍ଭାବନା",
    "Tourist Visa Prospects": "ପର୍ଯ୍ୟଟକ ଭିସା ସମ୍ଭାବନା",
    "Study Visa Prospects": "ଅଧୟନ ଭିସା ସମ୍ଭାବନା",
    "Business Visa Prospects": "ବ୍ୟବସାୟ ଭିସା ସମ୍ଭାବନା",
    "Import/export business: +2,7,10,11": "ଆମଦାନି/ରପ୍ତାନି ବ୍ୟବସାୟ: +2,7,10,11",
    "Work Visa Prospects": "କାର୍ଯ୍ୟ ଭିସା ସମ୍ଭାବନା",
    "Partner Abroad Indicators": "ବିଦେଶରେ ସହଯୋଗୀ ସୂଚକ",
    "Marriage Abroad Prospects": "ବିଦେଶରେ ବିବାହ ସମ୍ଭାବନା",
    "Professional / Conference Travel": "ପେଶାଗତ / ସମ୍ମେଳନ ଯାତ୍ରା",
    "Sports-Related Travel": "କ୍ରୀଡ଼ା ସଂପର୍କିତ ଯାତ୍ରା",
    "Family & Life Development": "ପରିବାର ଓ ଜୀବନ ବିକାଶ",
    "Family Expansion Prospects": "ପରିବାର ବିସ୍ତାର ସମ୍ଭାବନା"
  },
  "as": {
    "Event Analysis": "ঘটনাৰ বিশ্লেষণ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "পৰম্পৰাগত নাড়ী ঘৰ গোট আৰু জড়িত গ্ৰহসমূহ চাবলৈ এটা শ্ৰেণী আৰু ঘটনা নিৰ্বাচন কৰক।",
    "Category": "শ্ৰেণী",
    "Event": "ঘটনা",
    "Locked": "তালাবদ্ধ",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "সকলো শ্ৰেণী আৰু ঘটনা দৃশ্যমান। তালাবদ্ধ ঘটনাৰ বিশ্লেষণ বিকল্পসমূহ খোলাৰ বাবে প্ৰিমিয়ামত উন্নীত কৰক।",
    "Supportive indication": "সহায়ক সংকেত",
    "Challenging indication": "চেলেঞ্জিং সংকেত",
    "Neutral indication": "নিৰপেক্ষ সংকেত",
    "Event groups": "ঘটনা গোটসমূহ",
    "Good": "ভাল",
    "Bad": "বেয়া",
    "Supportive": "সহায়ক",
    "Challenging supportive": "চেলেঞ্জিং সহায়ক",
    "Planets involved": "জড়িত গ্ৰহসমূহ",
    "involved": "জড়িত",
    "Pro": "প্ৰ",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "এই ব্যাখ্যা সমূহ পৰম্পৰাগত জ্যোতিষশাস্ত্ৰৰ নীতিৰ ওপৰত আধাৰিত আৰু শিক্ষামূলক আৰু তথ্যমূলক উদ্দেশ্যৰ বাবে প্ৰস্তুত কৰা হৈছে। এইবোৰ ঝুঁকি আৰু সম্ভাৱনাৰ দিশ দাঙি ধৰে, নিশ্চয়তা প্ৰদান নকৰে। আইন, বিত্তীয়, চিকিৎসা বা অন্য ব্যৱসায়িক বিষয়ৰ বাবে, যথোপযুক্ত যোগ্যতাৰ সৈতে এটি পেচাদাৰী ব্যক্তিৰ সৈতে পৰামৰ্শ কৰক।",
    "Career, Work & Business": "কৰ্মজীৱন, কাম-কাজ আৰু ব্যৱসায়",
    "Employment Prospects": "কৰ্মসংস্থাপন সম্ভাৱনা",
    "Business Prospects": "ব্যৱসায়ৰ সম্ভাৱনা",
    "Earning Potential": "আয় ক্ষমতা",
    "Business Challenges": "ব্যৱসায়ৰ সমস্যা",
    "Business Recovery Indicators": "ব্যৱসায় পুনৰুদ্ধাৰ সূচক",
    "10,11 acts as regain/recovery support after business difficulty.": "10,11 ব্যৱসায়িক সমস্যাৰ পাছত পুনৰুদ্ধাৰৰ সহায় হিচাপে কৰ্ম কৰে।",
    "Administration Career": "পৰিচালনা কৰ্মজীৱন",
    "Employment Challenges": "কৰ্মসংস্থাপন সমস্যা",
    "Professional Obstacles / Delays": "পেচাদাৰী বাধা / বিলম্ব",
    "Professional Recognition Challenges": "পেচাদাৰী স্বীকৃতিৰ সমস্যা",
    "Financial Pressure": "বিত্তীয় চাপ",
    "Financial Return Cycle": "বিত্তীয় লাভ চক্র",
    "Supportive Career Change": "সমৰ্থক কৰ্মজীৱন পৰিবৰ্তন",
    "Favourable Career Transition": "অনুকূল ব্যৱসায় পৰিবৰ্তন",
    "Next DBA": "পৰৱৰ্তী DBA",
    "Challenging Career Transition": "চেলেঞ্জিং ব্যৱসায় পৰিবৰ্তন",
    "Workplace Transfer / Relocation": "কাৰ্যালয় স্থানান্তৰ / স্থানচ্যুতি",
    "Return to Previous Workplace / Location": "পূৰ্বৰ কাৰ্যালয় / স্থানলৈ উভতি যোৱা",
    "Personality & Temperament": "ব্যক্তিত্ব আৰু মনোভাৱ",
    "Assertive / Intense Temperament": "দৃঢ় / তীব্ৰ মনোভাৱ",
    "Mars": "মঙ্গল",
    "modifier": "পৰিবর্তক",
    "Mars connected with the 1st or 3rd house": "প্ৰথম বা তৃতীয় ঘৰত মঙ্গলৰ সংযোগ",
    "Emotional Sensitivity": "অনুভূমিক সংবেদনশীলতা",
    "Moon": "চন্দ্ৰ",
    "Moon influence; source also notes Cancer connected with the 1st house": "চন্দ্ৰৰ প্ৰভাৱ; উৎসত উল্লেখ আছে প্ৰথম ঘৰত কেঞ্চৰৰ সংযোগ",
    "Affectionate & Relationship-Oriented Nature": "স্নেহময় আৰু সম্পৰ্কমুখী প্ৰকৃতি",
    "Warm & Supportive Nature": "উষ্ণ আৰু সমৰ্থক প্ৰকৃতি",
    "Independent / Detached Tendencies": "স্বতন্ত্ৰ / পৃথক প্ৰৱণতা",
    "Rahu": "ৰাহু",
    "associated planet": "সংশ্লিষ্ট গ্ৰহ",
    "Ketu": "কেতু",
    "Saturn": "শনি",
    "Sun": "সূৰ্য",
    "Reserved / Practical Nature": "সংৰক্ষিত / ব্যৱহাৰিক প্ৰকৃতি",
    "Persistent / Determined Nature": "দৃঢ় / সংকল্পবদ্ধ প্ৰকৃতি",
    "Relationships & Marriage": "সম্পৰ্ক আৰু বিবাহ",
    "Relationship Boundary Challenges": "সম্পৰ্কৰ সীমা সংক্রান্ত সমস্যা",
    "Supportive Relationship Bond": "সমৰ্থক সম্পর্ক বন্ধন",
    "Private / Complex Relationship Phase": "ব্যক্তিগত / জটিল সম্পর্ক পৰ্যায়",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "উৎসত 5,9,11; 5,11; আৰু 5,8,11 ক শুদ্ধ/সমৰ্থক সম্পর্কৰ ৰূপ হিচাপে উল্লেখ কৰিছে।",
    "Relationship Conflict / Reactive Dynamics": "সম্পর্কৰ সংঘাত / প্ৰতিক্ৰিয়াশীল গতিশীলতা",
    "Marriage Prospects": "বিবাহৰ সম্ভাৱনা",
    "Marriage Through Known Circle": "পৰিচিত বৃত্তৰ জৰিয়তে বিবাহ",
    "Supportive Marriage Circumstances": "সমৰ্থক বিবাহ পৰিস্থিতি",
    "Marriage Delay Indicators": "বিবাহ বিলম্বৰ সূচক",
    "In DBA": "ডিবিএত",
    "Emotional Distance in Relationship": "সম্পর্কত মানসিক দূৰত্ব",
    "Reconciliation Indicators": "পুনর্মিলনৰ সূচক",
    "Use with the preceding relationship/separation combination.": "পূৰ্বৰ সম্পর্ক/বিচ্ছিন্নতাৰ সংমিশ্ৰণৰ সৈতে ব্যৱহাৰ কৰক।",
    "Marital Transition / Separation Indicators": "বিবাহ পৰিৱৰ্তন / বিচ্ছিন্নতাৰ সূচক",
    "Reduced Support for Marriage": "বিবাহৰ সমৰ্থন হ্ৰাস",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "প্ৰবল হয় যেতিয়া 1,6,10 বহু প্ৰাসংগিক গ্ৰহ/সংকেতকৰ দ্বাৰা পুনৰাবৃত্তি হয়।",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "প্ৰবল হয় যেতিয়া 7ম কাসপৰ প্রভুয়ে 1,6,10কো সংকেত দিয়ে।",
    "Relocation After Marriage": "বিবাহৰ পাছত স্থানান্তৰ",
    "Relocation to a Distant / Unfamiliar Place": "দূৰ/অচিন পৰিলক্ষিত ঠাইলৈ স্থানান্তৰ",
    "Non-Traditional Relationship Pattern": "পৰম্পৰাগত নহয় এমন সম্পৰ্কৰ ৰূপ",
    "Education & Learning": "শিক্ষা আৰু শিক্‌য়া",
    "Education Prospects": "শিক্ষাৰ সম্ভাৱনা",
    "Strong Education Potential": "শক্তিশালী শিক্ষাৰ সম্ভাৱনা",
    "Management / Professional Higher Education Potential": "ব্যৱস্থাপনা/পেশাগত উচ্চ শিক্ষা সম্ভাৱনা",
    "Profession Indicators": "পেশাৰ সূচক",
    "Astrology / Astrologer": "জ্যোতিষ শাস্ত্ৰ / জ্যোতিষী",
    "Mercury": "বুধ",
    "profession modifier": "পেশা সংশোধক",
    "Jupiter": "বৃহস্পতি",
    "Teacher / Educator": "শিক্ষক / শিক্ষকে",
    "Higher-education support: 1,2,4,9,11": "উচ্চ শিক্ষাৰ সহায়ঃ 1,2,4,9,11",
    "Writer / Professional Writing": "লিখক / পেশাগত লেখা",
    "Income Support Through Profession": "পেশাৰ দ্বাৰা আয়ৰ সহায়",
    "Medical / Healthcare Profession": "চিকিৎসা / স্বাস্থ্য সংৰক্ষণ পেশা",
    "Stronger professional quality: 5,9,11 + 6,8,12": "অধিক শক্তিশালী পেশাগত গুণমানঃ 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "পেশাগত সফলতাৰ সহায়ঃ 6,8,12 + 10,11 বা +11 বা +9,11",
    "Engineer": "অভিযান্ত্ৰিক",
    "Scientist": "বিজ্ঞানী",
    "Research / Inventions / Deep Analysis": "গৱেষণা / উদ্ভাৱন / গভীৰ বিশ্লেষণ",
    "Recognition Through Research / Innovation": "গৱেষণা / উদ্ভাৱনৰ মাধ্যমে স্বীকৃতি",
    "Information Technology": "তথ্য প্ৰযুক্তি",
    "Higher-education support: 2,4,5,9,11": "উচ্চ শিক্ষাৰ সহায়তা: 2,4,5,9,11",
    "Lawyer / Legal Profession": "উকীল / আইন ব্যৱসায়",
    "Architect": "স্থপতি",
    "Builder / Construction": "নিৰ্মাতা / নিৰ্মাণ",
    "Property / Real-Estate Professional": "সম্পত্তি / ৰিয়েল-এষ্টেট ব্যৱসায়ী",
    "Property purchase activity: 4,11,12": "সম্পত্তি ক্ৰয় কৰ্ম: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "সম্পত্তি বিক্ৰী কৰ্ম: 3,5,10 শনিচৰ আৰু মঙ্গলৰ সৈতে",
    "Interior Designer / Decorator": "অন্তঃসজ্জাৰ ডিজাইনাৰ / ডেকৰেটৰ",
    "Creativity / Innovation": "সৃষ্টিশীলতা / নতুনত্ব",
    "Politics / Public Leadership": "ৰাজনীতি / ৰাজহুৱা নেতৃত্ব",
    "Chartered Accountant": "চার্টাৰ্ড একাউণ্টেণ্ট",
    "Data Management / Business Management": "ডাটা ব্যৱস্থাপনা / ব্যৱস্থাপনা ব্যৱসায়",
    "Chef / Culinary Profession": "ৰন্ধনকাৰ / ৰন্ধন ব্যৱসায়",
    "Benefic planet": "সহায়ক গ্ৰহ",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "২য় ঘৰত সহায়ক বা ২য় ঘৰলৈ সহায়ক দৃষ্টিৰে প্ৰভাৱশালী",
    "International / continental cuisine: +9,3,12": "আন্তঃৰাষ্ট্ৰীয় / মহাদেশীয় ৰন্ধনশৈলী: +9,3,12",
    "Correctional / Institutional Administration": "সংশোধনমূলক / প্ৰতিষ্ঠানিক প্ৰশাসন",
    "Journalist / Media Professional": "সাংবাদিক / মিডিয়া ব্যৱসায়ী",
    "Investigative / crime reporting: +7,8,12": "অনুসন্ধানমূলক / অপৰাধ প্ৰতিবেদন: +7,8,12",
    "Political reporting: +1,10,11": "ৰাজনৈতিক প্ৰতিবেদন: +1,10,11",
    "Sports reporting: +5,10": "ক্ৰীড়া প্ৰতিবেদন: +5,10",
    "Creative Writer": "সৃজনশীল লেখক",
    "Creativity: +5,9": "সৃজনশীলতা: +5,9",
    "Artistic writing: 5,11": "কলাত্মক লেখা: 5,11",
    "Mystery / occult / deep subjects: 8,12": "ৰহস্য / গোপন / গভীৰ বিষয়: 8,12",
    "Legal Matters": "আইনী বিষয়",
    "Legal Dispute Indicators": "আইনী বিবাদ সূচকসমূহ",
    "Supportive Legal Matter Indicators": "সহায়ক আইনী বিষয় সূচকসমূহ",
    "Challenging Legal Matter Indicators": "চেলেঞ্জিং আইনী বিষয় সূচকসমূহ",
    "Legal Relief Indicators": "আইনী আৰাম সূচকসমূহ",
    "5,9 acts as a facilitator.": "5,9 এটা সুবিধাদায়ক হিচাপে কাম কৰে।",
    "Property & Residence": "সম্পত্তি আৰু বাসগৃহ",
    "Property Purchase Prospects": "সম্পত্তি ক্ৰয় সম্ভাৱনা",
    "property modifier": "সম্পত্তি পৰিৱৰ্তক",
    "Source notes aspect, transit, conjunction and DBA involvement": "উৎস নোটস্‌ দৃষ্টি, পৰিবহণ, সংযোগ আৰু ডিবিএ জড়িততা",
    "Property Through Financing / Loan": "সম্পত্তি অর্থায়ন / ঋণৰ জৰিয়তে",
    "Loan repayment/completion support: +4,11": "ঋণ পৰিশোধ / সম্পূৰ্ণৰূপে সহায়: +4,11",
    "Property Through Institutional / Personal Support": "সম্পত্তি প্ৰতিষ্ঠানিক / ব্যক্তিগত সহায়ৰ জৰিয়তে",
    "Property Through Gift / Inheritance": "উপহাৰ / পৰৱৰ্ত্তনীয়তা যোগে সম্পত্তি",
    "Property Purchase in Stages": "পৰ্যায়ক্রমে সম্পত্তি ক্ৰয়",
    "Government / Institution-Allotted Property": "চৰকাৰ / প্ৰতিষ্ঠানে নিৰ্দিষ্ট কৰা সম্পত্তি",
    "Commercial Property Purchase": "বাণিজ্যিক সম্পত্তি ক্ৰয়",
    "Rental Income Potential": "ভাড়াৰ আয় সম্ভাৱনা",
    "Considering a Residence Change": "আবাস স্থান পৰিৱৰ্তনৰ বিষয়ে বিবেচনা কৰা",
    "Change of Residence": "আবাস স্থান পৰিৱৰ্তন",
    "Separative planets": "পৃথক গ্ৰহসমূহ",
    "Property Through Family / Marriage Arrangement": "পৰিয়াল / বিবাহ ব্যৱস্থাৰ যোগে সম্পত্তি",
    "Property Ownership / Possession Challenges": "সম্পত্তি স্বত্ব / দখল সমস্যাসমূহ",
    "Property Conflict / Government Intervention": "সম্পত্তি সংঘাত / চৰকাৰৰ হস্তক্ষেপ",
    "Property Dispute / Litigation Indicators": "সম্পত্তি বিবাদ / মোকদ্দমাৰ সূচকসমূহ",
    "Venus": "বৃষ",
    "source modifier": "উৎস পৰিবৰ্তক",
    "Do not infer gender in public UI": "সাৰ্বজনীন UI-ত লিংগ অনুমান নকৰিব",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "বুধ আৰু দ্বৈত ৰাশিৰ সৈতে, উৎস বুলিয়ে পুনৰাবৃত্তি / বহুবাৰ সমস্যা সংকেত দিয়ে",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "বৃহস্পতিৰ সৈতে আৰু দ্বৈত ৰাশিৰ সৈতে, উৎস বুলিয়ে পুনৰাবৃত্তি / বহুবাৰ সমস্যা সংকেত দিয়ে",
    "Supportive Property Dispute Indicators": "সহায়ক সম্পত্তি বিবাদ সূচকসমূহ",
    "Challenging Property Dispute Indicators": "প্ৰত্যাহ্বানজনক সম্পত্তি বিবাদ সূচকসমূহ",
    "Property Division / Partition": "সম্পত্তি বিভাজন / পাৰ্টিছন",
    "Property Sale Prospects": "সম্পত্তি বিক্ৰী সম্ভাবনা",
    "Favourable Property Sale Conditions": "অনুকূল সম্পত্তি বিক্ৰী পৰিস্থিতি",
    "Less Supportive Property Sale Conditions": "কম সহায়ক সম্পত্তি বিক্ৰী পৰিস্থিতি",
    "Vehicle": "বাহন",
    "Vehicle Acquisition Prospects": "বাহন অৰ্জন সম্ভাবনা",
    "primary vehicle significator": "প্ৰাথমিক বাহন সূচক",
    "Vehicle Through Financing / Loan": "ঋণ / ফাইনেঞ্চিঙৰ যোগে বাহন",
    "Vehicle Through Gift": "উপহাৰৰ মাধ্যমে বাহন",
    "Venus active in DBA": "DBA-ত শুক্ৰ সক্ৰিয়",
    "Premium / Luxury Vehicle Indicators": "প্ৰিমিয়াম / বিলাসী বাহন সূচকসমূহ",
    "primary factor": "প্ৰাথমিক কাৰক",
    "Natural benefic planets": "প্ৰাকৃতিক শুভ গ্ৰহসমূহ",
    "aspecting/supporting factor": "প্ৰভাৱ / সহায়ক কাৰক",
    "Pre-Owned Vehicle Indicators": "পূৰ্বপ্ৰাপ্ত বাহন সূচকসমূহ",
    "aspecting factor": "প্ৰভাৱ বিএকাৰক",
    "Vehicle Maintenance Concerns": "বাহন ৰক্ষণাবেক্ষণ চিন্তা",
    "Commercial Vehicle Indicators": "বাণিজ্যিক বাহন সূচকসমূহ",
    "commercial vehicle modifier": "বাণিজ্যিক বাহন সংশোধক",
    "Mercury involved or aspecting": "বুধ জড়িত অথবা প্ৰভাৱ বিস্তাৰিত",
    "small commercial vehicle modifier": "সৰু বাণিজ্যিক বাহন সংশোধক",
    "Venus involved or aspecting": "শুক্ৰ জড়িত বা দৃষ্টিভংগী",
    "heavy commercial vehicle modifier": "গধুৰ বাণিজ্যিক বাহন সংশোধনকাৰী",
    "Saturn involved or aspecting": "শনি জড়িত বা দৃষ্টিভংগী",
    "Vehicle Security / Possession Caution": "বাহনৰ সুৰক্ষা / দখলৰ সতৰ্কতা",
    "Strong Vehicle Security / Possession Caution": "বাহনৰ শক্তিশালী সুৰক্ষা / দখলৰ সতৰ্কতা",
    "Vehicle Recovery / Resolution Indicators": "বাহন পুনৰুদ্ধাৰ / ৰিজলুশ্বন সূচক",
    "Vehicle Loan Repayment Challenges": "বাহন ঋণ পৰিশোধৰ প্ৰত্যাহ্বান",
    "Stronger while the combination remains active in DBA": "ডি.বি.এ.-ত মিশ্ৰণটো সক্ৰিয় হৈ থাকিলে অধিক শক্তিশালী",
    "Improvement/return after payment: 4,6,11": "পৰিশোধৰ পিছত উন্নতি/প্ৰত্যাৱৰ্তন: 4,6,11",
    "Vehicle Sale Prospects": "বাহন বিক্ৰীৰ সম্ভাৱনা",
    "Insurance Claim Indicators": "বীমা দাবীৰ সূচক",
    "Travel, Visa & Foreign Matters": "ভ্ৰমণ, ভিছা আৰু বৈদেশিক বিষয়সমূহ",
    "Travel Prospects": "ভ্ৰমণৰ সম্ভাৱনা",
    "travel modifier": "ট্ৰেভেল মডিফায়াৰ",
    "Short-Distance Travel": "চমু দূৰত্বৰ ভ্ৰমণ[সম্পাদনা কৰক]",
    "Long-Distance Travel": "দীৰ্ঘ দূৰত্বৰ ভ্ৰমণ",
    "Change in Travel Plans / Route": "ভ্ৰমণ আঁচনি / পথত পৰিৱৰ্তন",
    "Separative planet": "বিভাজিত গ্ৰহ",
    "International Travel Requiring Greater Adjustment": "অধিক সংশোধনৰ প্ৰয়োজন হোৱা আন্তৰ্জাতিক ভ্ৰমণ",
    "Malefic planets": "পুৰুষ গ্ৰহ[সম্পাদনা কৰক]",
    "Supportive International Travel": "সমৰ্থক আন্তঃৰাজ্যীয় যাত্ৰা",
    "Benefic planets": "লাভদায়ক গ্ৰহসমূহ",
    "Return Home / Homecoming": "ঘূৰি আহি ঘৰলৈ যোৱা / ঘূৰ্ণাৱাস",
    "Visa Prospects": "ভিছাৰ সম্ভাৱনা",
    "Tourist Visa Prospects": "পৰ্যটক ভিছাৰ সম্ভাৱনা",
    "Study Visa Prospects": "অধ্যয়ন ভিছাৰ সম্ভাৱনা",
    "Business Visa Prospects": "ব্যৱসায় ভিছাৰ সম্ভাৱনা",
    "Import/export business: +2,7,10,11": "আমদানি/ৰপ্তানি ব্যৱসায়: +২,৭,১০,১১",
    "Work Visa Prospects": "কৰ্ম ভিছাৰ সম্ভাৱনা",
    "Partner Abroad Indicators": "বৈদেশিক সহকৰ্মীৰ সূত্ৰ",
    "Marriage Abroad Prospects": "বৈদেশিক বিবাহৰ সম্ভাৱনা",
    "Professional / Conference Travel": "পেচাদাৰী / সন্মিলন যাত্ৰা",
    "Sports-Related Travel": "খেল-সংক্রান্ত যাত্ৰা",
    "Family & Life Development": "পৰিয়াল আৰু জীৱনৰ বিকাশ",
    "Family Expansion Prospects": "পৰিয়াল বৃদ্ধি সম্ভাৱনা"
  },
  "ur": {
    "Event Analysis": "ایونٹ تجزیہ",
    "Select a category and event to view its traditional Nadi house groups and involved planets.": "اپنا کیٹیگری اور ایونٹ منتخب کریں تاکہ اس کے روایتی نادی ہاؤس گروپس اور شامل سیارے دیکھ سکیں۔",
    "Category": "کیٹیگری",
    "Event": "ایونٹ",
    "Locked": "مقفل",
    "All categories and events are visible. Upgrade to Premium to unlock the locked Event Analysis options.": "تمام کیٹیگریز اور ایونٹس دکھائی دے رہے ہیں۔ مقفل ایونٹ تجزیہ کے اختیارات کو ان لاک کرنے کے لیے پریمیم میں اپ گریڈ کریں۔",
    "Supportive indication": "معاون اشاریہ",
    "Challenging indication": "چیلنجنگ اشاریہ",
    "Neutral indication": "غیر جانبدار اشاریہ",
    "Event groups": "ایونٹ گروپس",
    "Good": "اچھا",
    "Bad": "برا",
    "Supportive": "معاون",
    "Challenging supportive": "چیلنجنگ معاون",
    "Planets involved": "شامل سیارے",
    "involved": "شامل",
    "Pro": "پیشہ ور",
    "These interpretations are based on traditional astrological principles and are intended for informational and educational purposes. They indicate tendencies and possibilities, not guaranteed outcomes. For legal, financial, medical or other professional matters, consult an appropriately qualified professional.": "یہ تشریحات روایتی نجومی اصولوں پر مبنی ہیں اور معلوماتی اور تعلیمی مقاصد کے لئے ہیں۔ یہ رجحانات اور امکانات کی نشاندہی کرتی ہیں، یقینی نتائج نہیں۔ قانونی، مالی، طبی یا دیگر پیشہ ورانہ امور کے لیے، مناسب قابلیت رکھنے والے پیشہ ور سے مشورہ کریں۔",
    "Career, Work & Business": "کیریئر، کام اور کاروبار",
    "Employment Prospects": "ملازمت کے امکانات",
    "Business Prospects": "کاروباری امکانات",
    "Earning Potential": "آمدنی کی صلاحیت",
    "Business Challenges": "کاروباری چیلنجز",
    "Business Recovery Indicators": "کاروبار کی بحالی کے اشارے",
    "10,11 acts as regain/recovery support after business difficulty.": "10،11 کاروباری مشکلات کے بعد بحالی/واپسی میں مدد فراہم کرتے ہیں۔",
    "Administration Career": "انتظامیہ کا کیریئر",
    "Employment Challenges": "ملازمت کے چیلنجز",
    "Professional Obstacles / Delays": "پیشہ ورانہ رکاوٹیں / تأخیر",
    "Professional Recognition Challenges": "پیشہ ورانہ شناخت کے چیلنجز",
    "Financial Pressure": "مالی دباؤ",
    "Financial Return Cycle": "مالی آمد و رفت کا دَور",
    "Supportive Career Change": "معاون کیریئر تبدیلی",
    "Favourable Career Transition": "موافق کیریئر منتقلی",
    "Next DBA": "اگلا ڈی بی اے",
    "Challenging Career Transition": "چیلنجنگ کیریئر منتقلی",
    "Workplace Transfer / Relocation": "کام کی جگہ کی منتقلی / تبادلہ",
    "Return to Previous Workplace / Location": "پچھلی کام کی جگہ / مقام پر واپسی",
    "Personality & Temperament": "شخصیت اور مزاج",
    "Assertive / Intense Temperament": "پر زور / شدید مزاج",
    "Mars": "مریخ",
    "modifier": "موڈیفائیر",
    "Mars connected with the 1st or 3rd house": "مریخ کا پہلے یا تیسرے گھر سے تعلق",
    "Emotional Sensitivity": "جذباتی حساسیت",
    "Moon": "چاند",
    "Moon influence; source also notes Cancer connected with the 1st house": "چاند کا اثر؛ ماخذ میں یہ بھی نوٹ کیا گیا ہے کہ سرطان کا پہلا گھر سے تعلق ہے",
    "Affectionate & Relationship-Oriented Nature": "محبت اور تعلقات کی طرف مائل طبیعت",
    "Warm & Supportive Nature": "گرمجوش اور مددگار طبیعت",
    "Independent / Detached Tendencies": "خود مختار / الگ مائل طبیعت",
    "Rahu": "راہو",
    "associated planet": "منسلک سیارہ",
    "Ketu": "کیتو",
    "Saturn": "شنی",
    "Sun": "سورج",
    "Reserved / Practical Nature": "محتاط / عملی طبیعت",
    "Persistent / Determined Nature": "مسلسل / پرعزم طبیعت",
    "Relationships & Marriage": "تعلقات اور شادی",
    "Relationship Boundary Challenges": "تعلقات کی حدوں میں چیلنجز",
    "Supportive Relationship Bond": "معاونت والا رشتہ",
    "Private / Complex Relationship Phase": "نجی / پیچیدہ رشتے کا مرحلہ",
    "Source also lists 5,9,11; 5,11; and 5,8,11 as cleaner/supportive relationship variants.": "ماخذ 5,9,11; 5,11; اور 5,8,11 کو صاف/معاون رشتہ کے مختلف ورژن کے طور پر بھی درج کرتا ہے۔",
    "Relationship Conflict / Reactive Dynamics": "رشتے میں تنازع / ردعمل کی حرکیات",
    "Marriage Prospects": "شادی کے امکانات",
    "Marriage Through Known Circle": "معلوم حلقہ کے ذریعے شادی",
    "Supportive Marriage Circumstances": "معاونت والے شادی کے حالات",
    "Marriage Delay Indicators": "شادی میں تاخیر کے اشارے",
    "In DBA": "ڈی بی اے میں",
    "Emotional Distance in Relationship": "رشتے میں جذباتی فاصلے",
    "Reconciliation Indicators": "مصالحت کے اشارے",
    "Use with the preceding relationship/separation combination.": "پیش آنے والے رشتہ/ علیحدگی کے امتزاج کے ساتھ استعمال کریں۔",
    "Marital Transition / Separation Indicators": "ازدواجی تبدیلی / علیحدگی کے اشارے",
    "Reduced Support for Marriage": "شادی کے لیے کم معاونت",
    "Strengthens when 1,6,10 is repeated through multiple relevant planets/significators.": "مضبوطی آتی ہے جب 1,6,10 متعدد متعلقہ سیاروں/علامتی اشارات کے ذریعے دہرائی جائے۔",
    "Strengthens when the 7th cusp lord also signifies 1,6,10.": "مضبوطی آتی ہے جب ساتویں کَسپی لورڈ بھی 1,6,10 کو ظاہر کرے۔",
    "Relocation After Marriage": "شادی کے بعد مقام کی تبدیلی",
    "Relocation to a Distant / Unfamiliar Place": "ایک دور دراز / غیر مانوس جگہ میں منتقلی",
    "Non-Traditional Relationship Pattern": "غیر روایتی تعلقاتی نمونہ",
    "Education & Learning": "تعلیم اور سیکھنا",
    "Education Prospects": "تعلیمی مواقع",
    "Strong Education Potential": "مضبوط تعلیمی صلاحیت",
    "Management / Professional Higher Education Potential": "انتظامیہ / پیشہ وارانہ اعلیٰ تعلیم کی صلاحیت",
    "Profession Indicators": "پیشہ ورانہ اشارے",
    "Astrology / Astrologer": "علم نجوم / ماہر علم نجوم",
    "Mercury": "عطارد",
    "profession modifier": "پیشہ ورانہ ترمیم کنندہ",
    "Jupiter": "زحل",
    "Teacher / Educator": "استاد / مربی",
    "Higher-education support: 1,2,4,9,11": "اعلیٰ تعلیم کی حمایت: 1,2,4,9,11",
    "Writer / Professional Writing": "مصنف / پیشہ ورانہ تحریر",
    "Income Support Through Profession": "پیشے کے ذریعہ آمدنی کی مدد",
    "Medical / Healthcare Profession": "طبی / صحت کی دیکھ بھال کا پیشہ",
    "Stronger professional quality: 5,9,11 + 6,8,12": "مضبوط تر پیشہ ورانہ معیار: 5,9,11 + 6,8,12",
    "Professional success support: 6,8,12 + 10,11 OR +11 OR +9,11": "پیشہ ورانہ کامیابی کی حمایت: 6,8,12 + 10,11 یا +11 یا +9,11",
    "Engineer": "انجینئر",
    "Scientist": "سائنسدان",
    "Research / Inventions / Deep Analysis": "تحقیق / ایجادات / گہری تجزیہ",
    "Recognition Through Research / Innovation": "تحقیق / اختراع کے ذریعے اعتراف",
    "Information Technology": "انفارمیشن ٹیکنالوجی",
    "Higher-education support: 2,4,5,9,11": "اعلیٰ تعلیم کی معاونت: 2,4,5,9,11",
    "Lawyer / Legal Profession": "وکیل / قانونی پیشہ",
    "Architect": "آرکیٹیکٹ",
    "Builder / Construction": "بلڈر / تعمیرات",
    "Property / Real-Estate Professional": "جائداد / ریل اسٹیٹ پروفیشنل",
    "Property purchase activity: 4,11,12": "جائداد خریداری کی سرگرمی: 4,11,12",
    "Property sale activity: 3,5,10 with Saturn and Mars": "جائداد فروخت کی سرگرمی: 3,5,10 زحل اور مریخ کے ساتھ",
    "Interior Designer / Decorator": "انٹیریئر ڈیزائنر / ڈیکوریٹر",
    "Creativity / Innovation": "تخلیقی صلاحیت / نئی اختراعات",
    "Politics / Public Leadership": "سیاست / عوامی قیادت",
    "Chartered Accountant": "چارٹرڈ اکاؤنٹنٹ",
    "Data Management / Business Management": "ڈیٹا مینجمنٹ / کاروباری انتظام",
    "Chef / Culinary Profession": "شیف / کھانوں کا پیشہ",
    "Benefic planet": "فائدہ مند سیارہ",
    "Benefic in the 2nd house or beneficially aspecting/influencing the 2nd house": "دوسرا گھر میں فائدہ مند یا دوسرے گھر پر فائدہ مند اثر ڈالنے والا",
    "International / continental cuisine: +9,3,12": "بین الاقوامی / برِّاعظمی کھانے پکانے کی مہارت: +9,3,12",
    "Correctional / Institutional Administration": "اصلاحی / ادارہ جاتی انتظام",
    "Journalist / Media Professional": "صحافی / میڈیا پروفیشنل",
    "Investigative / crime reporting: +7,8,12": "تحقیقی / جرائم کی رپورٹنگ: +7,8,12",
    "Political reporting: +1,10,11": "سیاسی رپورٹنگ: +1,10,11",
    "Sports reporting: +5,10": "کھیلوں کی رپورٹنگ: +5,10",
    "Creative Writer": "تخلیقی مصنف",
    "Creativity: +5,9": "تخلیقی صلاحیت: +5,9",
    "Artistic writing: 5,11": "فنکارانہ تحریر: 5,11",
    "Mystery / occult / deep subjects: 8,12": "پراسرار / مافوق الفطرت / گہری موضوعات: 8,12",
    "Legal Matters": "قانونی امور",
    "Legal Dispute Indicators": "قانونی تنازعہ کے اشارے",
    "Supportive Legal Matter Indicators": "معاون قانونی معاملے کے اشارے",
    "Challenging Legal Matter Indicators": "چیلنجنگ قانونی معاملے کے اشارے",
    "Legal Relief Indicators": "قانونی نجات کے اشارے",
    "5,9 acts as a facilitator.": "5,9 بطور سہولت کار کام کرتا ہے.",
    "Property & Residence": "جائیداد اور رہائش",
    "Property Purchase Prospects": "جائیداد خریدنے کے امکانات",
    "property modifier": "جائیداد ماڈیفائر",
    "Source notes aspect, transit, conjunction and DBA involvement": "ماخذ نوٹس پہلو، عبور، ملاپ اور ڈی بی اے کی شمولیت",
    "Property Through Financing / Loan": "مالی امداد / قرض کے ذریعے جائیداد",
    "Loan repayment/completion support: +4,11": "قرض کی ادائیگی / تکمیل کی حمایت: +4,11",
    "Property Through Institutional / Personal Support": "ادارہ جاتی / ذاتی مدد کے ذریعے جائیداد",
    "Property Through Gift / Inheritance": "تحفے / وراثت کے ذریعے جائیداد",
    "Property Purchase in Stages": "پراپرٹی کی خریداری مرحلہ وار",
    "Government / Institution-Allotted Property": "حکومتی / ادارے کی طرف سے مختص جائیداد",
    "Commercial Property Purchase": "کمرشل پراپرٹی کی خریداری",
    "Rental Income Potential": "کرایہ کی آمدنی کی صلاحیت",
    "Considering a Residence Change": "رہائش کی تبدیلی پر غور",
    "Change of Residence": "رہائش کی تبدیلی",
    "Separative planets": "علیحدہ سیارے",
    "Property Through Family / Marriage Arrangement": "خاندانی / شادی کے انتظام کے ذریعے جائیداد",
    "Property Ownership / Possession Challenges": "جائیداد کی ملکیت / قبضے کے چیلنجز",
    "Property Conflict / Government Intervention": "جائیداد کا تنازعہ / حکومتی مداخلت",
    "Property Dispute / Litigation Indicators": "جائیداد کے تنازعہ / مقدمات کے اشارے",
    "Venus": "زہرہ",
    "source modifier": "سورس موڈیفائر",
    "Do not infer gender in public UI": "پبلک یوزر انٹرفیس میں جنس کا تعین نہ کریں",
    "With Mercury and a dual sign, source indicates repeated/multiple issues": "مرکری اور ڈوئل سائن کے ساتھ، سورس بار بار یا متعدد مسائل کی نشاندہی کرتا ہے",
    "With Jupiter and a dual sign, source indicates repeated/multiple issues": "مشتری اور دوہری نشان کے ساتھ، ماخذ بار بار یا متعدد مسائل کی نشاندہی کرتا ہے",
    "Supportive Property Dispute Indicators": "معاون جائیداد کے تنازعات کے اشارے",
    "Challenging Property Dispute Indicators": "چیلنجنگ پراپرٹی تنازعہ کے اشارے",
    "Property Division / Partition": "جائیداد کی تقسیم / تقسیم",
    "Property Sale Prospects": "جائیداد کی فروخت کے امکانات",
    "Favourable Property Sale Conditions": "سازگار جائیداد فروخت کے حالات",
    "Less Supportive Property Sale Conditions": "کم معاون جائیداد کی فروخت کے حالات",
    "Vehicle": "گاڑی",
    "Vehicle Acquisition Prospects": "گاڑی کے حصول کے امکانات",
    "primary vehicle significator": "پرائمری وہیکل سگنیفیکیٹر",
    "Vehicle Through Financing / Loan": "فنانسنگ / قرض کے ذریعے گاڑی",
    "Vehicle Through Gift": "تحفے کے ذریعے گاڑی",
    "Venus active in DBA": "ڈی بی اے میں فعال زہرہ",
    "Premium / Luxury Vehicle Indicators": "پریمیم / لگژری گاڑیوں کے اشارے",
    "primary factor": "بنیادی عنصر",
    "Natural benefic planets": "قدرتی فائدہ مند سیارے",
    "aspecting/supporting factor": "پہلو/معاون عنصر",
    "Pre-Owned Vehicle Indicators": "استعمال شدہ گاڑیوں کے اشارے",
    "aspecting factor": "ایسپیٹنگ فیکٹر",
    "Vehicle Maintenance Concerns": "گاڑی کی دیکھ بھال کے خدشات",
    "Commercial Vehicle Indicators": "کمرشل وہیکل انڈیکیٹرز",
    "commercial vehicle modifier": "کمرشل وہیکل موڈیفائر",
    "Mercury involved or aspecting": "مرکری شامل ہے یا کوئی پہلو",
    "small commercial vehicle modifier": "چھوٹے کمرشل وہیکل موڈیفائر",
    "Venus involved or aspecting": "زہرہ کا شامل یا رخ ہونا",
    "heavy commercial vehicle modifier": "ہیوی کمرشل وہیکل موڈیفائر",
    "Saturn involved or aspecting": "زحل شامل یا پہلو",
    "Vehicle Security / Possession Caution": "گاڑی کی سیکیورٹی / قبضے کی احتیاط",
    "Strong Vehicle Security / Possession Caution": "مضبوط گاڑی کی سیکیورٹی / قبضے کی احتیاط",
    "Vehicle Recovery / Resolution Indicators": "گاڑی کی بازیابی / ریزولوشن کے اشارے",
    "Vehicle Loan Repayment Challenges": "گاڑی کے قرض کی ادائیگی کے چیلنجز",
    "Stronger while the combination remains active in DBA": "جب تک یہ کمبینیشن ڈی بی اے میں فعال رہتا ہے، زیادہ مضبوط",
    "Improvement/return after payment: 4,6,11": "ادائیگی کے بعد بہتری/واپسی: 4,6,11",
    "Vehicle Sale Prospects": "گاڑیوں کی فروخت کے امکانات",
    "Insurance Claim Indicators": "انشورنس کلیم انڈیکیٹرز",
    "Travel, Visa & Foreign Matters": "سفر، ویزا اور غیر ملکی امور",
    "Travel Prospects": "سفر کے امکانات",
    "travel modifier": "ٹریول موڈیفائر",
    "Short-Distance Travel": "مختصر فاصلے کا سفر",
    "Long-Distance Travel": "طویل فاصلے کا سفر",
    "Change in Travel Plans / Route": "سفر کے منصوبے / راستے میں تبدیلی",
    "Separative planet": "علیحدہ سیارہ",
    "International Travel Requiring Greater Adjustment": "بین الاقوامی سفر جس کے لیے زیادہ ایڈجسٹمنٹ درکار ہے",
    "Malefic planets": "مالیفک سیارے",
    "Supportive International Travel": "معاون بین الاقوامی سفر",
    "Benefic planets": "مفید سیارے",
    "Return Home / Homecoming": "گھر واپسی / وطن واپسی",
    "Visa Prospects": "ویزا کے امکانات",
    "Tourist Visa Prospects": "سیاحتی ویزا کے امکانات",
    "Study Visa Prospects": "تعلیمی ویزا کے امکانات",
    "Business Visa Prospects": "کاروباری ویزا کے امکانات",
    "Import/export business: +2,7,10,11": "درآمد / برآمد کا کاروبار: +2,7,10,11",
    "Work Visa Prospects": "ورک ویزا کے امکانات",
    "Partner Abroad Indicators": "شریک حیات کے بیرون ملک اشارے",
    "Marriage Abroad Prospects": "بیرون ملک شادی کے امکانات",
    "Professional / Conference Travel": "پیشہ ورانہ / کانفرنس کے سفر",
    "Sports-Related Travel": "کھیلوں سے متعلق سفر",
    "Family & Life Development": "خاندان اور زندگی کی ترقی",
    "Family Expansion Prospects": "خاندان میں اضافے کے امکانات"
  }
} as const;

export type NadiEventLanguage = keyof typeof NADI_EVENT_TRANSLATIONS;

export const translateNadiEventText = (language: string | null | undefined, english: string) => {
  const code = String(language || 'en').toLowerCase().split(/[-_]/)[0] as NadiEventLanguage;
  const languageMap = NADI_EVENT_TRANSLATIONS[code] as Record<string, string> | undefined;
  return languageMap?.[english] || translateInline(language, english);
};
